import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: string;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: string;
};

export type AcquisitionChannelBase = {
  __typename?: 'AcquisitionChannel';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of AddAngelInvestmentInvitation */
export type AddAngelInvestmentInvitationInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 失効期限 */
  days: Scalars['Int'];
  /** 招待メール先アドレス */
  emails?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of AddAngelInvitation */
export type AddAngelInvitationInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 投資先企業の ID */
  companyId: Scalars['ID'];
  /** 失効期限 */
  days: Scalars['Int'];
  /** 招待メール先アドレス */
  emails?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of AddCompanyInvestment */
export type AddCompanyInvestmentInputBase = {
  attributes: InvestmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  investingCompanyId: Scalars['ID'];
};

/** Autogenerated input type of AddCompanyMember */
export type AddCompanyMemberInputBase = {
  attributes: CompanyMemberInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of AddCompanyReference */
export type AddCompanyReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  slug: Scalars['ID'];
};

/** Autogenerated input type of AddExperience */
export type AddExperienceInputBase = {
  attributes: ExperienceInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of AddFootprintToJob */
export type AddFootprintToJobInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  referer?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};

/** Autogenerated input type of AddInvestor */
export type AddInvestorInputBase = {
  attributes: InvestorInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of AddMemberInvitation */
export type AddMemberInvitationInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** メンバーになる企業の ID */
  companyId: Scalars['ID'];
  /** 失効期限 */
  days: Scalars['Int'];
  /** 招待メール先アドレス */
  emails?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of AddMyInvestment */
export type AddMyInvestmentInputBase = {
  attributes: InvestmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of AddMyJobBookmark */
export type AddMyJobBookmarkInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  jobId: Scalars['ID'];
};

/** Autogenerated input type of AddPitchAttachment */
export type AddPitchAttachmentInputBase = {
  attributes: PitchAttachmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pitchId: Scalars['ID'];
};

/** Autogenerated input type of AddProduct */
export type AddProductInputBase = {
  attributes: ProductInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

/** Autogenerated input type of AddUserReference */
export type AddUserReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  username: Scalars['ID'];
};

/** Autogenerated input type of AddVcInvestmentInvitation */
export type AddVcInvestmentInvitationInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 投資元企業の ID */
  companyId: Scalars['ID'];
  /** 失効期限 */
  days: Scalars['Int'];
  /** 招待メール先アドレス */
  emails?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of AddVcInvitation */
export type AddVcInvitationInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 投資先企業の ID */
  companyId: Scalars['ID'];
  /** 失効期限 */
  days: Scalars['Int'];
  /** 招待メール先アドレス */
  emails?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of AddVehicleItemPortfolioAttachment */
export type AddVehicleItemPortfolioAttachmentInputBase = {
  attributes: PortfolioAttachmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vehicleItemId: Scalars['ID'];
};

/** Autogenerated input type of AddVehicleItemRoundAttachment */
export type AddVehicleItemRoundAttachmentInputBase = {
  attributes: VehicleItemRoundAttachmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vehicleItemRoundId: Scalars['ID'];
};

/** Autogenerated input type of AddVehicleMember */
export type AddVehicleMemberInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  investorMemberRole?: InputMaybe<InvestorMemberRole>;
  userId: Scalars['ID'];
  vehicleId: Scalars['ID'];
  vehicleMemberRole?: InputMaybe<VehicleMemberRole>;
};

/** Autogenerated input type of ApplyForJob */
export type ApplyForJobInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  jobId: Scalars['ID'];
  message: Scalars['String'];
};

export type ArticleBase = {
  __typename?: 'Article';
  category?: Maybe<CategoryBase>;
  company?: Maybe<CompanyBase>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  fundraisingManualFields?: Maybe<FundraisingManualBase>;
  id?: Maybe<Scalars['ID']>;
  isLiked?: Maybe<Scalars['Boolean']>;
  likedUsersCount?: Maybe<Scalars['Int']>;
  ogImage?: Maybe<Scalars['String']>;
  opinionsUser?: Maybe<UserBase>;
  originalArticleUrl?: Maybe<Scalars['String']>;
  originalSiteName?: Maybe<Scalars['String']>;
  slug: Scalars['ID'];
  status: ArticleStatus;
  thumbnail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  topics?: Maybe<Array<TopicBase>>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ArticleAttachmentBase = {
  __typename?: 'ArticleAttachment';
  id: Scalars['ID'];
  image: Scalars['String'];
};

/** 記事の添付画像作成用の属性 */
export type ArticleAttachmentInputBase = {
  /** 画像 */
  image: Scalars['String'];
};

/** The connection type for Article. */
export type ArticleConnection = {
  __typename?: 'ArticleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ArticleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ArticleBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ArticleEdge = {
  __typename?: 'ArticleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ArticleBase>;
};

/** 記事作成用の属性 */
export type ArticleInputBase = {
  /** カテゴリーのID */
  categoryId?: InputMaybe<Scalars['ID']>;
  /** 記事の内容 */
  content?: InputMaybe<Scalars['String']>;
  /** 記事のディスクリプション */
  description?: InputMaybe<Scalars['String']>;
  /** 記事のOGイメージ */
  ogImage?: InputMaybe<Scalars['String']>;
  /** 記事のスラッグ */
  slug?: InputMaybe<Scalars['ID']>;
  /** 記事の公開ステータス */
  status: ArticleStatus;
  /** 記事のサムネイル */
  thumbnail?: InputMaybe<Scalars['String']>;
  /** 記事のタイトル */
  title: Scalars['String'];
};

export enum ArticleStatus {
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type BillingPortalBase = {
  __typename?: 'BillingPortal';
  sessionUrl: Scalars['String'];
};

export type CategoryBase = {
  __typename?: 'Category';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

export enum CommenterTypeBase {
  INVESTOR = 'INVESTOR',
  STARTUP = 'STARTUP'
}

export type CompanyBase = {
  __typename?: 'Company';
  aboutUs?: Maybe<Scalars['String']>;
  articles?: Maybe<ArticleConnection>;
  companyMembers?: Maybe<Array<CompanyMemberBase>>;
  companyReferences?: Maybe<CompanyReferenceConnection>;
  companySize?: Maybe<CompanySize>;
  conceptPitch?: Maybe<Scalars['String']>;
  currencyUnit?: Maybe<CurrencyUnit>;
  denyNewContact?: Maybe<Scalars['Boolean']>;
  excludeFromSearch?: Maybe<Scalars['Boolean']>;
  facebookUrl?: Maybe<Scalars['String']>;
  followersCount?: Maybe<Scalars['Int']>;
  fundraisingStatus?: Maybe<FundraisingStatus>;
  hasInvestmentsWithJobs?: Maybe<Scalars['Boolean']>;
  headerImage?: Maybe<Scalars['String']>;
  highlightedJobListings?: Maybe<JobConnection>;
  id?: Maybe<Scalars['ID']>;
  instagramUrl?: Maybe<Scalars['String']>;
  investmentTargetMarkets?: Maybe<Array<MarketBase>>;
  investmentTargetRounds?: Maybe<Array<RoundBase>>;
  investments?: Maybe<Array<InvestmentBase>>;
  isFollowing?: Maybe<Scalars['Boolean']>;
  isVc?: Maybe<Scalars['Boolean']>;
  jobs?: Maybe<JobConnection>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<LocationBase>>;
  logo?: Maybe<Scalars['String']>;
  markets?: Maybe<Array<MarketBase>>;
  maxInvestmentAmount?: Maybe<Scalars['BigInt']>;
  minInvestmentAmount?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  notificationSettings?: Maybe<Array<CompanyNotificationBase>>;
  products?: Maybe<Array<ProductBase>>;
  receivedInvestments?: Maybe<Array<InvestmentBase>>;
  round?: Maybe<RoundBase>;
  slug: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  totalFundingAmount?: Maybe<Scalars['BigInt']>;
  twitterUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};


export type CompanyArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyCompanyReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyHighlightedJobListingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Company. */
export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompanyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CompanyBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CompanyBase>;
};

/** 会社作成用の属性 */
export type CompanyInputBase = {
  /** 会社の詳細な説明 */
  aboutUs?: InputMaybe<Scalars['String']>;
  /** 従業員の概数 */
  companySize?: InputMaybe<CompanySize>;
  /** 会社を一文で表す文言 */
  conceptPitch?: InputMaybe<Scalars['String']>;
  /** 通貨単位 */
  currencyUnit?: InputMaybe<CurrencyUnit>;
  /** メッセージを受け付けるか */
  denyNewContact?: InputMaybe<Scalars['Boolean']>;
  /** 一覧表示させるかの判定 */
  excludeFromSearch?: InputMaybe<Scalars['Boolean']>;
  /** FacebookのURL */
  facebookUrl?: InputMaybe<Scalars['String']>;
  /** 資金調達ステータス */
  fundraisingStatus?: InputMaybe<FundraisingStatus>;
  /** ヘッダー画像 */
  headerImage?: InputMaybe<Scalars['String']>;
  /** InstagramのURL */
  instagramUrl?: InputMaybe<Scalars['String']>;
  /** 投資対象領域のID配列 */
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 投資対象ラウンドのID配列 */
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']>>;
  /** VCかどうかの判定 */
  isVc?: InputMaybe<Scalars['Boolean']>;
  /** LinkedInのURL */
  linkedinUrl?: InputMaybe<Scalars['String']>;
  /** 地域のID配列 */
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 会社のロゴ */
  logo?: InputMaybe<Scalars['String']>;
  /** マーケットのID配列 */
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 最大投資金額 */
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  /** 最小投資金額 */
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  /** 本名 */
  name: Scalars['String'];
  /** 投資のラウンド */
  roundId?: InputMaybe<Scalars['ID']>;
  /** 会社のスラッグ */
  slug?: InputMaybe<Scalars['ID']>;
  /** 公開・非公開 */
  status?: InputMaybe<Scalars['String']>;
  /** 合計資金調達金額 */
  totalFundingAmount?: InputMaybe<Scalars['BigInt']>;
  /** TwitterのURL */
  twitterUrl?: InputMaybe<Scalars['String']>;
  /** コーポレートサイトのURL */
  url?: InputMaybe<Scalars['String']>;
  /** YoutubeのURL */
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type CompanyMemberBase = {
  __typename?: 'CompanyMember';
  company?: Maybe<CompanyBase>;
  id?: Maybe<Scalars['ID']>;
  user?: Maybe<UserBase>;
};

/** 会社員追加・更新用の属性 */
export type CompanyMemberInputBase = {
  /** 所属の会社 */
  companyId: Scalars['ID'];
  /** 会社員の役割 */
  role: CompanyMemberRole;
  /** 会社員のユーザーアカウント */
  userId: Scalars['ID'];
};

export enum CompanyMemberRole {
  EDITOR = 'EDITOR',
  OWNER = 'OWNER',
  RECRUITER = 'RECRUITER'
}

export type CompanyNotificationBase = {
  __typename?: 'CompanyNotification';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

/** 会社の並び順 */
export type CompanyOrderBase = {
  /** ソートする会社のフィールド */
  companyOrderField: CompanyOrderFieldBase;
  /** 昇順・降順 */
  direction: OrderDirection;
};

export enum CompanyOrderFieldBase {
  CREATED_AT = 'CREATED_AT',
  GENERAL_SCORE = 'GENERAL_SCORE',
  STARTUP_SCORE = 'STARTUP_SCORE',
  VC_SCORE = 'VC_SCORE'
}

export type CompanyReferenceBase = {
  __typename?: 'CompanyReference';
  comment: Scalars['String'];
  commenter?: Maybe<UserBase>;
  id: Scalars['ID'];
  status: CompanyReferenceStatus;
};

/** The connection type for CompanyReference. */
export type CompanyReferenceConnection = {
  __typename?: 'CompanyReferenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompanyReferenceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CompanyReferenceBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CompanyReferenceEdge = {
  __typename?: 'CompanyReferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CompanyReferenceBase>;
};

export enum CompanyReferenceStatus {
  HIDDEN = 'HIDDEN',
  SHOWN = 'SHOWN'
}

export enum CompanySize {
  FROM_1_TO_10 = 'FROM_1_TO_10',
  FROM_11_TO_50 = 'FROM_11_TO_50',
  FROM_51_TO_200 = 'FROM_51_TO_200',
  FROM_201_TO_500 = 'FROM_201_TO_500',
  FROM_501_TO_1000 = 'FROM_501_TO_1000',
  FROM_1001_TO_5000 = 'FROM_1001_TO_5000',
  OVER_5000 = 'OVER_5000',
  UNKNOWN = 'UNKNOWN'
}

/** Autogenerated input type of CreateArticleAttachment */
export type CreateArticleAttachmentInputBase = {
  attributes: ArticleAttachmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateBillingPortalSession */
export type CreateBillingPortalSessionInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

/** Autogenerated input type of CreateCompanyArticle */
export type CreateCompanyArticleInputBase = {
  attributes: ArticleInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

/** Autogenerated input type of CreateCompany */
export type CreateCompanyInputBase = {
  attributes: CompanyInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateJobAttachment */
export type CreateJobAttachmentInputBase = {
  attributes: JobAttachmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateJob */
export type CreateJobInputBase = {
  attributes: JobInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

/** Autogenerated input type of CreateMessageThread */
export type CreateMessageThreadInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

/** Autogenerated input type of CreateMyArticle */
export type CreateMyArticleInputBase = {
  attributes: ArticleInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateMyCompany */
export type CreateMyCompanyInputBase = {
  attributes: CompanyInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreatePitch */
export type CreatePitchInputBase = {
  attributes: PitchInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

/** Autogenerated input type of CreateRecruitSubscription */
export type CreateRecruitSubscriptionInputBase = {
  attributes: RecruitSubscriptionInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

/** Autogenerated input type of CreateSkill */
export type CreateSkillInputBase = {
  attributes: SkillInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateVehicle */
export type CreateVehicleInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 通貨単位 */
  currencyUnit?: InputMaybe<CurrencyUnit>;
  entityType: VehicleInvestor;
  name: Scalars['String'];
  slug?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of CreateVehicleItem */
export type CreateVehicleItemInputBase = {
  attributes?: InputMaybe<VehicleItemInputBase>;
  captainUserId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  roundAttributes: VehicleItemRoundInputBase;
  vehicleStatusId: Scalars['ID'];
};

/** Autogenerated input type of CreateVehicleItemPortfolioMeeting */
export type CreateVehicleItemPortfolioMeetingInputBase = {
  attributes: PortfolioMeetingInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vehicleItemId: Scalars['ID'];
};

/** Autogenerated input type of CreateVehicleItemPortfolioNote */
export type CreateVehicleItemPortfolioNoteInputBase = {
  attributes: PortfolioNoteInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vehicleItemId: Scalars['ID'];
};

/** Autogenerated input type of CreateVehicleItemRound */
export type CreateVehicleItemRoundInputBase = {
  attributes: VehicleItemRoundInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vehicleItemId: Scalars['ID'];
};

/** Autogenerated input type of CreateVehicleStatus */
export type CreateVehicleStatusInputBase = {
  attributes: VehicleStatusInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vehicleSlug?: InputMaybe<Scalars['ID']>;
};

export enum CurrencyUnit {
  JPY = 'JPY',
  USD = 'USD'
}

export type DashboardBase = {
  __typename?: 'Dashboard';
  dashboardItems?: Maybe<Array<DashboardItemBase>>;
  name?: Maybe<Scalars['String']>;
};

export enum DashboardCategory {
  NUMBER = 'NUMBER',
  PIE = 'PIE'
}

export type DashboardItemBase = {
  __typename?: 'DashboardItem';
  category?: Maybe<DashboardCategory>;
  name?: Maybe<Scalars['String']>;
  numberDashboardItem?: Maybe<NumberDashboardItemBase>;
  pieDashboardItems?: Maybe<Array<PieDashboardItemBase>>;
};

/** Autogenerated input type of DeleteArticle */
export type DeleteArticleInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteCompanyArticle */
export type DeleteCompanyArticleInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteJob */
export type DeleteJobInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteMyArticle */
export type DeleteMyArticleInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeletePitchAttachment */
export type DeletePitchAttachmentInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeletePitch */
export type DeletePitchInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteVehicle */
export type DeleteVehicleInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteVehicleItem */
export type DeleteVehicleItemInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteVehicleItemPortfolioAttachment */
export type DeleteVehicleItemPortfolioAttachmentInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  vehicleItemId: Scalars['ID'];
};

/** Autogenerated input type of DeleteVehicleItemPortfolioMeeting */
export type DeleteVehicleItemPortfolioMeetingInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  vehicleItemId: Scalars['ID'];
};

/** Autogenerated input type of DeleteVehicleItemPortfolioNote */
export type DeleteVehicleItemPortfolioNoteInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  vehicleItemId: Scalars['ID'];
};

/** Autogenerated input type of DeleteVehicleItemRoundAttachment */
export type DeleteVehicleItemRoundAttachmentInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteVehicleItemRound */
export type DeleteVehicleItemRoundInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteVehicleStatus */
export type DeleteVehicleStatusInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DuplicateJob */
export type DuplicateJobInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ExperienceBase = {
  __typename?: 'Experience';
  addedByUser: UserBase;
  company: CompanyBase;
  current: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

/** 職歴作成用の属性 */
export type ExperienceInputBase = {
  /** 職歴の会社 */
  companyId: Scalars['ID'];
  /** 現在も所属しているか */
  current?: InputMaybe<Scalars['Boolean']>;
  /** 職歴についての説明 */
  description?: InputMaybe<Scalars['String']>;
  /** 職歴の終わった日時 */
  endedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** 職歴の始まった日時 */
  startedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** 追加の可否 */
  status?: InputMaybe<Scalars['String']>;
  /** 役職 */
  title: Scalars['String'];
  /** 対象ユーザー */
  userId: Scalars['ID'];
};

export type FollowableEntityBase = {
  __typename?: 'FollowableEntity';
  category: FollowableEntityCategory;
  description?: Maybe<Scalars['String']>;
  entityType: FollowableEntityEntityType;
  image?: Maybe<Scalars['String']>;
  isFollowing?: Maybe<Scalars['Boolean']>;
  isVerifiedAccount?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  shortDescription?: Maybe<Scalars['String']>;
  slug: Scalars['ID'];
};

export enum FollowableEntityCategory {
  ANGEL = 'ANGEL',
  STARTUP = 'STARTUP',
  USER = 'USER',
  VC = 'VC'
}

/** The connection type for FollowableEntity. */
export type FollowableEntityConnection = {
  __typename?: 'FollowableEntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FollowableEntityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FollowableEntityBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FollowableEntityEdge = {
  __typename?: 'FollowableEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<FollowableEntityBase>;
};

export enum FollowableEntityEntityType {
  COMPANY = 'COMPANY',
  USER = 'USER'
}

export type ForexRateBase = {
  __typename?: 'ForexRate';
  id?: Maybe<Scalars['ID']>;
  rate?: Maybe<Scalars['String']>;
  tickerSymbol?: Maybe<TickerSymbol>;
};

export type FundraisingManualBase = {
  __typename?: 'FundraisingManual';
  id: Scalars['ID'];
  step: Scalars['Int'];
  subcategory: FundraisingManualSubcategory;
};

export enum FundraisingManualSubcategory {
  PRACTICES = 'PRACTICES',
  THEORIES = 'THEORIES'
}

export enum FundraisingStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INACTIVE_BUT_OPEN_TO_OFFERS = 'INACTIVE_BUT_OPEN_TO_OFFERS',
  UNKNOWN = 'UNKNOWN'
}

export type FundraisingStatusUpdatedNotificationBase = {
  __typename?: 'FundraisingStatusUpdatedNotification';
  company: CompanyBase;
  id: Scalars['ID'];
};

/** Autogenerated input type of InitializePms */
export type InitializePmsInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  entityType: VehicleInvestor;
  slug?: InputMaybe<Scalars['ID']>;
};

export type InvestmentBase = {
  __typename?: 'Investment';
  angel?: Maybe<UserBase>;
  company?: Maybe<CompanyBase>;
  companyInvestedFrom?: Maybe<CompanyBase>;
  id: Scalars['ID'];
  investedAt?: Maybe<Scalars['ISO8601DateTime']>;
  investorComment?: Maybe<InvestmentCommentBase>;
  isLeadInvestor?: Maybe<Scalars['Boolean']>;
  referenceUrl?: Maybe<Scalars['String']>;
  round?: Maybe<RoundBase>;
  startupComment?: Maybe<InvestmentCommentBase>;
};

export type InvestmentCommentBase = {
  __typename?: 'InvestmentComment';
  comment: Scalars['String'];
  commenter: UserBase;
  commenterType: CommenterTypeBase;
};

/** インベストメント作成・更新用の属性 */
export type InvestmentInputBase = {
  /** コメント */
  comment?: InputMaybe<Scalars['String']>;
  /** 投資先会社 */
  companyId: Scalars['ID'];
  /** 投資した日時 */
  investedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** リードで出資したか */
  isLeadInvestor?: InputMaybe<Scalars['Boolean']>;
  /** 参照データ用のURL */
  referenceUrl?: InputMaybe<Scalars['String']>;
  /** 投資のラウンド */
  roundId?: InputMaybe<Scalars['ID']>;
};

export type InvestorBase = {
  __typename?: 'Investor';
  acquisitionChannels?: Maybe<Array<AcquisitionChannelBase>>;
  company?: Maybe<CompanyBase>;
  id?: Maybe<Scalars['ID']>;
  investorSlug?: Maybe<Scalars['String']>;
  investorType?: Maybe<VehicleInvestor>;
  portfolios?: Maybe<PortfolioConnection>;
  user?: Maybe<UserBase>;
  vehicles?: Maybe<Array<VehicleBase>>;
};


export type InvestorPortfoliosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** 投資先会社（自社）によるインベストメント作成・更新用の属性 */
export type InvestorInputBase = {
  /** 投資元エンジェル投資家 */
  angelUserId?: InputMaybe<Scalars['ID']>;
  /** コメント */
  comment?: InputMaybe<Scalars['String']>;
  /** 投資先会社（自社） */
  companyId: Scalars['ID'];
  /** 投資した日時 */
  investedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** リードで出資したか */
  isLeadInvestor?: InputMaybe<Scalars['Boolean']>;
  /** 参照データ用のURL */
  referenceUrl?: InputMaybe<Scalars['String']>;
  /** 投資のラウンド */
  roundId?: InputMaybe<Scalars['ID']>;
  /** 投資元VC */
  vcCompanyId?: InputMaybe<Scalars['ID']>;
};

export type InvestorMemberBase = {
  __typename?: 'InvestorMember';
  id?: Maybe<Scalars['ID']>;
  investor?: Maybe<InvestorBase>;
  role?: Maybe<InvestorMemberRole>;
  user?: Maybe<UserBase>;
  vehicleMembers?: Maybe<Array<VehicleMemberBase>>;
};

export enum InvestorMemberRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}

export type InvitationBase = {
  __typename?: 'Invitation';
  invitationOf: InvitationOfBase;
  isValid: Scalars['Boolean'];
};

export type InvitationLinkBase = {
  __typename?: 'InvitationLink';
  url: Scalars['String'];
};

export enum InvitationOfBase {
  ANGEL = 'ANGEL',
  ANGEL_INVESTMENT = 'ANGEL_INVESTMENT',
  MEMBER = 'MEMBER',
  VC = 'VC',
  VC_INVESTMENT = 'VC_INVESTMENT'
}

export type JobBase = {
  __typename?: 'Job';
  address?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  company?: Maybe<CompanyBase>;
  createdAt: Scalars['ISO8601DateTime'];
  currencyUnit: CurrencyUnit;
  equityGrant: Scalars['Boolean'];
  id: Scalars['ID'];
  jobCategories: Array<JobCategoryBase>;
  jobTags: Array<JobTagBase>;
  locations?: Maybe<Array<LocationBase>>;
  maxMonthlySalary: Scalars['BigInt'];
  minMonthlySalary: Scalars['BigInt'];
  primaryJobCategory?: Maybe<JobCategoryBase>;
  primaryRecruitingContact?: Maybe<UserBase>;
  skills: Array<SkillBase>;
  slug: Scalars['ID'];
  status: JobStatus;
  thumbnail: Scalars['String'];
  title: Scalars['String'];
  tokenGrant: Scalars['Boolean'];
  typeOfPosition: JobTypeOfPosition;
  updatedAt: Scalars['ISO8601DateTime'];
  workExperience: JobWorkExperience;
  workingForm: JobWorkingForm;
};

export type JobApplicationBase = {
  __typename?: 'JobApplication';
  id: Scalars['ID'];
  job: JobBase;
  messageThread: MessageThreadBase;
  user: UserBase;
};

/** The connection type for JobApplication. */
export type JobApplicationConnection = {
  __typename?: 'JobApplicationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobApplicationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<JobApplicationBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JobApplicationEdge = {
  __typename?: 'JobApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobApplicationBase>;
};

export type JobAttachmentBase = {
  __typename?: 'JobAttachment';
  id: Scalars['ID'];
  image: Scalars['String'];
};

/** 募集の添付画像作成用の属性 */
export type JobAttachmentInputBase = {
  /** 画像 */
  image: Scalars['String'];
};

export type JobBookmarkBase = {
  __typename?: 'JobBookmark';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['ID']>;
  job: JobBase;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  user?: Maybe<UserBase>;
};

/** The connection type for JobBookmark. */
export type JobBookmarkConnection = {
  __typename?: 'JobBookmarkConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobBookmarkEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<JobBookmarkBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JobBookmarkEdge = {
  __typename?: 'JobBookmarkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobBookmarkBase>;
};

export type JobCategoryBase = {
  __typename?: 'JobCategory';
  id: Scalars['ID'];
  jobCategoryType: JobCategoryType;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export enum JobCategoryType {
  DESIGNER = 'DESIGNER',
  ENGINEERING = 'ENGINEERING',
  MANAGEMENT = 'MANAGEMENT',
  MARKETING = 'MARKETING',
  OPERATIONS = 'OPERATIONS',
  OTHER = 'OTHER',
  PRODUCT = 'PRODUCT',
  SALES = 'SALES',
  UNKNOWN = 'UNKNOWN'
}

/** The connection type for Job. */
export type JobConnection = {
  __typename?: 'JobConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<JobBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JobEdge = {
  __typename?: 'JobEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobBase>;
};

export type JobFootprintBase = {
  __typename?: 'JobFootprint';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  job?: Maybe<JobBase>;
  referer?: Maybe<Scalars['String']>;
  user?: Maybe<UserBase>;
};

/** The connection type for JobFootprint. */
export type JobFootprintConnection = {
  __typename?: 'JobFootprintConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobFootprintEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<JobFootprintBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JobFootprintEdge = {
  __typename?: 'JobFootprintEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobFootprintBase>;
};

/** 募集作成用の属性 */
export type JobInputBase = {
  /** 住所 */
  address?: InputMaybe<Scalars['String']>;
  /** 募集内容 */
  body?: InputMaybe<Scalars['String']>;
  /** 貨幣単位 */
  currencyUnit?: InputMaybe<CurrencyUnit>;
  /** SO含む株式の付与があるかどうか */
  equityGrant?: InputMaybe<Scalars['Boolean']>;
  /** 募集カテゴリーのID配列 */
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 特徴のID配列 */
  jobTagIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 地域のID配列 */
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 最大給与額 */
  maxMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  /** 最小給与額 */
  minMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  /** 採用担当者 */
  primaryRecruitingContactId: Scalars['ID'];
  /** スキルのID配列 */
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 募集のスラッグ */
  slug?: InputMaybe<Scalars['ID']>;
  /** 募集の公開ステータス */
  status?: InputMaybe<JobStatus>;
  /** 募集のサムネイル */
  thumbnail?: InputMaybe<Scalars['String']>;
  /** 募集のタイトル */
  title: Scalars['String'];
  /** トークンの付与があるかどうか */
  tokenGrant?: InputMaybe<Scalars['Boolean']>;
  /** 募集形態 */
  typeOfPosition?: InputMaybe<JobTypeOfPosition>;
  /** 経験年数 */
  workExperience?: InputMaybe<JobWorkExperience>;
  /** 勤務形態 */
  workingForm?: InputMaybe<JobWorkingForm>;
};

export type JobSeekingStatusUpdatedNotificationBase = {
  __typename?: 'JobSeekingStatusUpdatedNotification';
  id: Scalars['ID'];
  user: UserBase;
};

export enum JobStatus {
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type JobTagBase = {
  __typename?: 'JobTag';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export enum JobTypeOfPosition {
  COFOUNDER = 'COFOUNDER',
  CONTRACTOR = 'CONTRACTOR',
  FREELANCER = 'FREELANCER',
  FULL_TIME_EMPLOYEE = 'FULL_TIME_EMPLOYEE',
  INTERN = 'INTERN',
  NEW_GRADUATE = 'NEW_GRADUATE',
  PART_TIMER = 'PART_TIMER'
}

export enum JobWorkExperience {
  EIGHT_YEARS_OR_MORE = 'EIGHT_YEARS_OR_MORE',
  FIVE_YEARS_OR_MORE = 'FIVE_YEARS_OR_MORE',
  FOUR_YEARS_OR_MORE = 'FOUR_YEARS_OR_MORE',
  NINE_YEARS_OR_MORE = 'NINE_YEARS_OR_MORE',
  NOT_REQUIRED = 'NOT_REQUIRED',
  ONE_YEAR_OR_MORE = 'ONE_YEAR_OR_MORE',
  SEVEN_YEARS_OR_MORE = 'SEVEN_YEARS_OR_MORE',
  SIX_YEARS_OR_MORE = 'SIX_YEARS_OR_MORE',
  TEN_YEARS_OR_MORE = 'TEN_YEARS_OR_MORE',
  THREE_YEARS_OR_MORE = 'THREE_YEARS_OR_MORE',
  TWO_YEARS_OR_MORE = 'TWO_YEARS_OR_MORE',
  ZERO_YEAR_OR_MORE = 'ZERO_YEAR_OR_MORE'
}

export enum JobWorkingForm {
  IN_OFFICE_ONLY = 'IN_OFFICE_ONLY',
  REMOTE_ACCEPTED = 'REMOTE_ACCEPTED',
  REMOTE_ONLY = 'REMOTE_ONLY'
}

/** Autogenerated input type of LeaveService */
export type LeaveServiceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type LocationBase = {
  __typename?: 'Location';
  id: Scalars['ID'];
  locationType: LocationCategory;
  name: Scalars['String'];
  shortDescription: Scalars['String'];
  slug: Scalars['String'];
};

export enum LocationCategory {
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  STATE = 'STATE'
}

/** The connection type for Location. */
export type LocationConnection = {
  __typename?: 'LocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LocationBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LocationEdge = {
  __typename?: 'LocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LocationBase>;
};

/** Autogenerated input type of MarkAllMessagesAsRead */
export type MarkAllMessagesAsReadInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};

/** Autogenerated return type of MarkAllMessagesAsRead. */
export type MarkAllMessagesAsReadPayload = {
  __typename?: 'MarkAllMessagesAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of MarkNotificationsAsRead */
export type MarkNotificationsAsReadInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of MarkNotificationsAsRead. */
export type MarkNotificationsAsReadPayload = {
  __typename?: 'MarkNotificationsAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  hasUnreadNotifications?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<Array<NotificationBase>>;
};

/** Autogenerated input type of MarkPitchAsRead */
export type MarkPitchAsReadInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};

export type MarketBase = {
  __typename?: 'Market';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

export type MeBase = {
  __typename?: 'Me';
  companyMembers?: Maybe<Array<MyCompanyMemberBase>>;
  email: Scalars['String'];
  experiences?: Maybe<Array<ExperienceBase>>;
  hasStripeCustomerId?: Maybe<Scalars['Boolean']>;
  hasUnreadNotifications?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  investments?: Maybe<Array<InvestmentBase>>;
  investorMembers?: Maybe<Array<InvestorMemberBase>>;
  invitationOf?: Maybe<InvitationOfBase>;
  isFirstSignIn?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notifications?: Maybe<NotificationConnection>;
  pmsPlan?: Maybe<PmsPlanBase>;
  profile?: Maybe<UserProfileBase>;
  role?: Maybe<UserRoleBase>;
  status?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};


export type MeNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MessageBase = {
  __typename?: 'Message';
  body: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  messageAttachments?: Maybe<Array<MessageAttachmentBase>>;
  messageThread?: Maybe<MessageThreadBase>;
  readers?: Maybe<Array<UserBase>>;
  updatedAt: Scalars['ISO8601DateTime'];
  user: UserBase;
};

export type MessageAttachmentBase = {
  __typename?: 'MessageAttachment';
  file: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  mimeType: Scalars['String'];
};

/** The connection type for Message. */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MessageBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MessageBase>;
};

export type MessageThreadBase = {
  __typename?: 'MessageThread';
  id?: Maybe<Scalars['ID']>;
  jobApplication?: Maybe<JobApplicationBase>;
  messageThreadType: MessageThreadType;
  messages?: Maybe<MessageConnection>;
  name?: Maybe<Scalars['String']>;
  slug: Scalars['ID'];
  users?: Maybe<Array<UserBase>>;
};


export type MessageThreadMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for MessageThread. */
export type MessageThreadConnection = {
  __typename?: 'MessageThreadConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessageThreadEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MessageThreadBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MessageThreadEdge = {
  __typename?: 'MessageThreadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MessageThreadBase>;
};

export enum MessageThreadType {
  GENERAL = 'GENERAL',
  RECRUITING = 'RECRUITING'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** エンジェル投資家の投資先の招待リンク発行 */
  addAngelInvestmentInvitation?: Maybe<InvitationLinkBase>;
  /** エンジェル投資家の招待リンク発行 */
  addAngelInvitation?: Maybe<InvitationLinkBase>;
  /** 投資元会社が投資先会社を追加する */
  addCompanyInvestment?: Maybe<InvestmentBase>;
  /** 会社員を追加する */
  addCompanyMember?: Maybe<MyCompanyMemberBase>;
  /** 会社のリファレンスを追加する */
  addCompanyReference?: Maybe<CompanyReferenceBase>;
  /** 職歴を追加する */
  addExperience?: Maybe<ExperienceBase>;
  /** 募集に足跡をつける */
  addFootprintToJob?: Maybe<JobBase>;
  /** 自社（スタートアップ）が投資元を追加する */
  addInvestor?: Maybe<InvestmentBase>;
  /** メンバーの招待リンク発行 */
  addMemberInvitation?: Maybe<InvitationLinkBase>;
  /** ログインユーザー（エンジェル投資家）が自分の投資先を追加する */
  addMyInvestment?: Maybe<InvestmentBase>;
  /** 求人ブックマークを追加する */
  addMyJobBookmark?: Maybe<JobBookmarkBase>;
  /** 資金調達クラウドのピッチ添付資料を作成する */
  addPitchAttachment?: Maybe<PitchAttachmentBase>;
  /** プロダクトを追加する */
  addProduct?: Maybe<ProductBase>;
  /** ユーザーのリファレンスを追加する */
  addUserReference?: Maybe<UserReferenceBase>;
  /** VC の投資先の招待リンク発行 */
  addVcInvestmentInvitation?: Maybe<InvitationLinkBase>;
  /** VCの招待リンク発行 */
  addVcInvitation?: Maybe<InvitationLinkBase>;
  /** ポートフォリオのファイルを追加する */
  addVehicleItemPortfolioAttachment?: Maybe<PortfolioAttachmentBase>;
  /** ビークルアイテムのファイルを追加する */
  addVehicleItemRoundAttachment?: Maybe<VehicleItemRoundAttachmentBase>;
  /** ビークルメンバーを追加する */
  addVehicleMember?: Maybe<VehicleMemberBase>;
  /** 応募を申請する */
  applyForJob?: Maybe<JobApplicationBase>;
  /** 記事の添付画像を作成する */
  createArticleAttachment?: Maybe<ArticleAttachmentBase>;
  /** 求人サービスのサブスクリプションを作成する */
  createBillingPortalSession?: Maybe<BillingPortalBase>;
  /** 会社を作成する */
  createCompany?: Maybe<CompanyBase>;
  /** 会社の記事を作成する */
  createCompanyArticle?: Maybe<ArticleBase>;
  /** 募集を作成する */
  createJob?: Maybe<JobBase>;
  /** 募集の添付画像を作成する */
  createJobAttachment?: Maybe<JobAttachmentBase>;
  /** スレッドを作成する */
  createMessageThread?: Maybe<MessageThreadBase>;
  /** ユーザーの記事を作成する */
  createMyArticle?: Maybe<ArticleBase>;
  /** 自分の会社を作成する */
  createMyCompany?: Maybe<MyCompanyBase>;
  /** 資金調達クラウドのピッチを作成する */
  createPitch?: Maybe<MyPitchBase>;
  /** 求人サービスのサブスクリプションを作成する */
  createRecruitSubscription?: Maybe<PaymentIntentBase>;
  /** スキルを作成する */
  createSkill?: Maybe<SkillBase>;
  /** ビークルを作成する */
  createVehicle?: Maybe<VehicleBase>;
  /** ピークルアイテムを作成する */
  createVehicleItem?: Maybe<VehicleItemBase>;
  /** ポートフォリオのミーティングを作成する */
  createVehicleItemPortfolioMeeting?: Maybe<PortfolioMeetingBase>;
  /** ポートフォリオのノートを作成する */
  createVehicleItemPortfolioNote?: Maybe<PortfolioNoteBase>;
  /** ビークルアイテムラウンドを作成する */
  createVehicleItemRound?: Maybe<VehicleItemRoundBase>;
  /** ビークルステータスを作成する */
  createVehicleStatus?: Maybe<VehicleStatusBase>;
  /** 記事を削除する */
  deleteArticle?: Maybe<ArticleBase>;
  /** 会社記事を削除する */
  deleteCompanyArticle?: Maybe<ArticleBase>;
  /** 募集を削除する */
  deleteJob?: Maybe<JobBase>;
  /** ユーザーの記事を削除する */
  deleteMyArticle?: Maybe<ArticleBase>;
  /** 資金調達クラウドのピッチを削除する */
  deletePitch?: Maybe<MyPitchBase>;
  /** 資金調達クラウドのピッチ添付資料を削除する */
  deletePitchAttachment?: Maybe<PitchAttachmentBase>;
  /** ピークルを削除する */
  deleteVehicle?: Maybe<VehicleBase>;
  /** ピークルアイテムを更新する */
  deleteVehicleItem?: Maybe<VehicleItemBase>;
  /** ポートフォリオのファイルを削除する */
  deleteVehicleItemPortfolioAttachment?: Maybe<PortfolioAttachmentBase>;
  /** ポートフォリオのミーティングを削除する */
  deleteVehicleItemPortfolioMeeting?: Maybe<PortfolioMeetingBase>;
  /** ポートフォリオのノートを削除する */
  deleteVehicleItemPortfolioNote?: Maybe<PortfolioNoteBase>;
  /** ビークルアイテムラウンドを削除する */
  deleteVehicleItemRound?: Maybe<VehicleItemRoundBase>;
  /** ビークルアイテムのファイルを削除する */
  deleteVehicleItemRoundAttachment?: Maybe<VehicleItemRoundAttachmentBase>;
  /** ピークルステータスを削除する */
  deleteVehicleStatus?: Maybe<VehicleStatusBase>;
  /** 募集のコピーを作成する */
  duplicateJob?: Maybe<JobBase>;
  /** PMS の初期化 */
  initializePms?: Maybe<InvestorMemberBase>;
  /** 現在のログインユーザーを退会済みにする */
  leaveService?: Maybe<MeBase>;
  /** スレッドの未読メッセージを既読にする */
  markAllMessagesAsRead?: Maybe<MarkAllMessagesAsReadPayload>;
  /** 通知を既読にする */
  markNotificationsAsRead?: Maybe<MarkNotificationsAsReadPayload>;
  /** ピッチを既読にする */
  markPitchAsRead?: Maybe<PitchBase>;
  /** 会社員を削除する */
  removeCompanyMember?: Maybe<MyCompanyMemberBase>;
  /** 会社のリファレンスを削除する */
  removeCompanyReference?: Maybe<CompanyReferenceBase>;
  /** 職歴を削除する */
  removeExperience?: Maybe<ExperienceBase>;
  /** インベストメントを削除する */
  removeInvestment?: Maybe<InvestmentBase>;
  /** 投資先会社（自社）によるインベストメントを削除する */
  removeInvestor?: Maybe<InvestmentBase>;
  /** 求人ブックマークを削除する */
  removeMyJobBookmark?: Maybe<JobBookmarkBase>;
  /** 資金調達クラウドのピッチから指定した添付資料を削除する */
  removePitchAttachmentFromPitch?: Maybe<PitchAttachmentBase>;
  /** プロダクトを削除する */
  removeProduct?: Maybe<ProductBase>;
  /** ユーザーのリファレンスを削除する */
  removeUserReference?: Maybe<UserReferenceBase>;
  /** 会社員を削除する */
  removeVehicleMember?: Maybe<VehicleMemberBase>;
  /** いいねの着脱 */
  toggleArticleLikedState?: Maybe<ArticleBase>;
  /** 会社のフォロー・フォロー解除 */
  toggleFollowCompany?: Maybe<CompanyBase>;
  /** ユーザーのフォロー・フォロー解除 */
  toggleFollowUser?: Maybe<UserBase>;
  /** 会社を更新する */
  updateCompany?: Maybe<MyCompanyBase>;
  /** 会社の記事を更新する */
  updateCompanyArticle?: Maybe<ArticleBase>;
  /** 会社員の role を更新する */
  updateCompanyMember?: Maybe<MyCompanyMemberBase>;
  /** フォローしている会社の通知受け取り設定 */
  updateCompanyNotificationSettings?: Maybe<CompanyBase>;
  /** 会社のリファレンスを更新する */
  updateCompanyReference?: Maybe<CompanyReferenceBase>;
  /** 職歴を更新する */
  updateExperience?: Maybe<ExperienceBase>;
  /** インベストメントを更新する */
  updateInvestment?: Maybe<InvestmentBase>;
  /** 投資先会社（自社）によるインベストメントを更新する */
  updateInvestor?: Maybe<InvestmentBase>;
  /** 募集を更新する */
  updateJob?: Maybe<JobBase>;
  /** 現在のログインユーザーの情報を更新する */
  updateMe?: Maybe<MeBase>;
  /** ユーザーの記事を更新する */
  updateMyArticle?: Maybe<ArticleBase>;
  /** 自分の会社についたリファレンスのステータスを更新する */
  updateMyCompanyReference?: Maybe<CompanyReferenceBase>;
  /** 現在のログインユーザーのプロフィール情報を更新する */
  updateMyProfile?: Maybe<UserProfileBase>;
  /** 自分についたリファレンスのステータスを更新する */
  updateMyReference?: Maybe<UserReferenceBase>;
  /** 資金調達クラウドのピッチを更新する */
  updatePitch?: Maybe<MyPitchBase>;
  /** 資金調達クラウドのピッチ添付資料を更新する */
  updatePitchAttachment?: Maybe<PitchAttachmentBase>;
  /** プロダクトを更新する */
  updateProduct?: Maybe<ProductBase>;
  /** フォローしているユーザーの通知受け取り設定 */
  updateUserNotificationSettings?: Maybe<UserBase>;
  /** ユーザーのリファレンスを更新する */
  updateUserReference?: Maybe<UserReferenceBase>;
  /** ピークルを更新する */
  updateVehicle?: Maybe<VehicleBase>;
  /** ピークルアイテムを更新する */
  updateVehicleItem?: Maybe<VehicleItemBase>;
  /** ポートフォリオを更新する */
  updateVehicleItemPortfolio?: Maybe<PortfolioBase>;
  /** ポートフォリオのミーティングを更新する */
  updateVehicleItemPortfolioMeeting?: Maybe<PortfolioMeetingBase>;
  /** ポートフォリオのノートを更新する */
  updateVehicleItemPortfolioNote?: Maybe<PortfolioNoteBase>;
  /** ビークルアイテムラウンドを更新する */
  updateVehicleItemRound?: Maybe<VehicleItemRoundBase>;
  /** 会社員の role を更新する */
  updateVehicleMember?: Maybe<VehicleMemberBase>;
  /** ビークルステータスを更新する */
  updateVehicleStatus?: Maybe<VehicleStatusBase>;
};


export type MutationAddAngelInvestmentInvitationArgs = {
  input: AddAngelInvestmentInvitationInputBase;
};


export type MutationAddAngelInvitationArgs = {
  input: AddAngelInvitationInputBase;
};


export type MutationAddCompanyInvestmentArgs = {
  input: AddCompanyInvestmentInputBase;
};


export type MutationAddCompanyMemberArgs = {
  input: AddCompanyMemberInputBase;
};


export type MutationAddCompanyReferenceArgs = {
  input: AddCompanyReferenceInputBase;
};


export type MutationAddExperienceArgs = {
  input: AddExperienceInputBase;
};


export type MutationAddFootprintToJobArgs = {
  input: AddFootprintToJobInputBase;
};


export type MutationAddInvestorArgs = {
  input: AddInvestorInputBase;
};


export type MutationAddMemberInvitationArgs = {
  input: AddMemberInvitationInputBase;
};


export type MutationAddMyInvestmentArgs = {
  input: AddMyInvestmentInputBase;
};


export type MutationAddMyJobBookmarkArgs = {
  input: AddMyJobBookmarkInputBase;
};


export type MutationAddPitchAttachmentArgs = {
  input: AddPitchAttachmentInputBase;
};


export type MutationAddProductArgs = {
  input: AddProductInputBase;
};


export type MutationAddUserReferenceArgs = {
  input: AddUserReferenceInputBase;
};


export type MutationAddVcInvestmentInvitationArgs = {
  input: AddVcInvestmentInvitationInputBase;
};


export type MutationAddVcInvitationArgs = {
  input: AddVcInvitationInputBase;
};


export type MutationAddVehicleItemPortfolioAttachmentArgs = {
  input: AddVehicleItemPortfolioAttachmentInputBase;
};


export type MutationAddVehicleItemRoundAttachmentArgs = {
  input: AddVehicleItemRoundAttachmentInputBase;
};


export type MutationAddVehicleMemberArgs = {
  input: AddVehicleMemberInputBase;
};


export type MutationApplyForJobArgs = {
  input: ApplyForJobInputBase;
};


export type MutationCreateArticleAttachmentArgs = {
  input: CreateArticleAttachmentInputBase;
};


export type MutationCreateBillingPortalSessionArgs = {
  input: CreateBillingPortalSessionInputBase;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInputBase;
};


export type MutationCreateCompanyArticleArgs = {
  input: CreateCompanyArticleInputBase;
};


export type MutationCreateJobArgs = {
  input: CreateJobInputBase;
};


export type MutationCreateJobAttachmentArgs = {
  input: CreateJobAttachmentInputBase;
};


export type MutationCreateMessageThreadArgs = {
  input: CreateMessageThreadInputBase;
};


export type MutationCreateMyArticleArgs = {
  input: CreateMyArticleInputBase;
};


export type MutationCreateMyCompanyArgs = {
  input: CreateMyCompanyInputBase;
};


export type MutationCreatePitchArgs = {
  input: CreatePitchInputBase;
};


export type MutationCreateRecruitSubscriptionArgs = {
  input: CreateRecruitSubscriptionInputBase;
};


export type MutationCreateSkillArgs = {
  input: CreateSkillInputBase;
};


export type MutationCreateVehicleArgs = {
  input: CreateVehicleInputBase;
};


export type MutationCreateVehicleItemArgs = {
  input: CreateVehicleItemInputBase;
};


export type MutationCreateVehicleItemPortfolioMeetingArgs = {
  input: CreateVehicleItemPortfolioMeetingInputBase;
};


export type MutationCreateVehicleItemPortfolioNoteArgs = {
  input: CreateVehicleItemPortfolioNoteInputBase;
};


export type MutationCreateVehicleItemRoundArgs = {
  input: CreateVehicleItemRoundInputBase;
};


export type MutationCreateVehicleStatusArgs = {
  input: CreateVehicleStatusInputBase;
};


export type MutationDeleteArticleArgs = {
  input: DeleteArticleInputBase;
};


export type MutationDeleteCompanyArticleArgs = {
  input: DeleteCompanyArticleInputBase;
};


export type MutationDeleteJobArgs = {
  input: DeleteJobInputBase;
};


export type MutationDeleteMyArticleArgs = {
  input: DeleteMyArticleInputBase;
};


export type MutationDeletePitchArgs = {
  input: DeletePitchInputBase;
};


export type MutationDeletePitchAttachmentArgs = {
  input: DeletePitchAttachmentInputBase;
};


export type MutationDeleteVehicleArgs = {
  input: DeleteVehicleInputBase;
};


export type MutationDeleteVehicleItemArgs = {
  input: DeleteVehicleItemInputBase;
};


export type MutationDeleteVehicleItemPortfolioAttachmentArgs = {
  input: DeleteVehicleItemPortfolioAttachmentInputBase;
};


export type MutationDeleteVehicleItemPortfolioMeetingArgs = {
  input: DeleteVehicleItemPortfolioMeetingInputBase;
};


export type MutationDeleteVehicleItemPortfolioNoteArgs = {
  input: DeleteVehicleItemPortfolioNoteInputBase;
};


export type MutationDeleteVehicleItemRoundArgs = {
  input: DeleteVehicleItemRoundInputBase;
};


export type MutationDeleteVehicleItemRoundAttachmentArgs = {
  input: DeleteVehicleItemRoundAttachmentInputBase;
};


export type MutationDeleteVehicleStatusArgs = {
  input: DeleteVehicleStatusInputBase;
};


export type MutationDuplicateJobArgs = {
  input: DuplicateJobInputBase;
};


export type MutationInitializePmsArgs = {
  input: InitializePmsInputBase;
};


export type MutationLeaveServiceArgs = {
  input: LeaveServiceInputBase;
};


export type MutationMarkAllMessagesAsReadArgs = {
  input: MarkAllMessagesAsReadInputBase;
};


export type MutationMarkNotificationsAsReadArgs = {
  input: MarkNotificationsAsReadInputBase;
};


export type MutationMarkPitchAsReadArgs = {
  input: MarkPitchAsReadInputBase;
};


export type MutationRemoveCompanyMemberArgs = {
  input: RemoveCompanyMemberInputBase;
};


export type MutationRemoveCompanyReferenceArgs = {
  input: RemoveCompanyReferenceInputBase;
};


export type MutationRemoveExperienceArgs = {
  input: RemoveExperienceInputBase;
};


export type MutationRemoveInvestmentArgs = {
  input: RemoveInvestmentInputBase;
};


export type MutationRemoveInvestorArgs = {
  input: RemoveInvestorInputBase;
};


export type MutationRemoveMyJobBookmarkArgs = {
  input: RemoveMyJobBookmarkInputBase;
};


export type MutationRemovePitchAttachmentFromPitchArgs = {
  input: RemovePitchAttachmentFromPitchInputBase;
};


export type MutationRemoveProductArgs = {
  input: RemoveProductInputBase;
};


export type MutationRemoveUserReferenceArgs = {
  input: RemoveUserReferenceInputBase;
};


export type MutationRemoveVehicleMemberArgs = {
  input: RemoveVehicleMemberInputBase;
};


export type MutationToggleArticleLikedStateArgs = {
  input: ToggleArticleLikedStateInputBase;
};


export type MutationToggleFollowCompanyArgs = {
  input: ToggleFollowCompanyInputBase;
};


export type MutationToggleFollowUserArgs = {
  input: ToggleFollowUserInputBase;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInputBase;
};


export type MutationUpdateCompanyArticleArgs = {
  input: UpdateCompanyArticleInputBase;
};


export type MutationUpdateCompanyMemberArgs = {
  input: UpdateCompanyMemberInputBase;
};


export type MutationUpdateCompanyNotificationSettingsArgs = {
  input: UpdateCompanyNotificationSettingsInputBase;
};


export type MutationUpdateCompanyReferenceArgs = {
  input: UpdateCompanyReferenceInputBase;
};


export type MutationUpdateExperienceArgs = {
  input: UpdateExperienceInputBase;
};


export type MutationUpdateInvestmentArgs = {
  input: UpdateInvestmentInputBase;
};


export type MutationUpdateInvestorArgs = {
  input: UpdateInvestorInputBase;
};


export type MutationUpdateJobArgs = {
  input: UpdateJobInputBase;
};


export type MutationUpdateMeArgs = {
  input: UpdateMeInputBase;
};


export type MutationUpdateMyArticleArgs = {
  input: UpdateMyArticleInputBase;
};


export type MutationUpdateMyCompanyReferenceArgs = {
  input: UpdateMyCompanyReferenceInputBase;
};


export type MutationUpdateMyProfileArgs = {
  input: UpdateMyProfileInputBase;
};


export type MutationUpdateMyReferenceArgs = {
  input: UpdateMyReferenceInputBase;
};


export type MutationUpdatePitchArgs = {
  input: UpdatePitchInputBase;
};


export type MutationUpdatePitchAttachmentArgs = {
  input: UpdatePitchAttachmentInputBase;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInputBase;
};


export type MutationUpdateUserNotificationSettingsArgs = {
  input: UpdateUserNotificationSettingsInputBase;
};


export type MutationUpdateUserReferenceArgs = {
  input: UpdateUserReferenceInputBase;
};


export type MutationUpdateVehicleArgs = {
  input: UpdateVehicleInputBase;
};


export type MutationUpdateVehicleItemArgs = {
  input: UpdateVehicleItemInputBase;
};


export type MutationUpdateVehicleItemPortfolioArgs = {
  input: UpdateVehicleItemPortfolioInputBase;
};


export type MutationUpdateVehicleItemPortfolioMeetingArgs = {
  input: UpdateVehicleItemPortfolioMeetingInputBase;
};


export type MutationUpdateVehicleItemPortfolioNoteArgs = {
  input: UpdateVehicleItemPortfolioNoteInputBase;
};


export type MutationUpdateVehicleItemRoundArgs = {
  input: UpdateVehicleItemRoundInputBase;
};


export type MutationUpdateVehicleMemberArgs = {
  input: UpdateVehicleMemberInputBase;
};


export type MutationUpdateVehicleStatusArgs = {
  input: UpdateVehicleStatusInputBase;
};

export type MyCompanyBase = {
  __typename?: 'MyCompany';
  aboutUs?: Maybe<Scalars['String']>;
  articles?: Maybe<ArticleConnection>;
  companyMembers?: Maybe<Array<MyCompanyMemberBase>>;
  companySize?: Maybe<CompanySize>;
  conceptPitch?: Maybe<Scalars['String']>;
  currencyUnit?: Maybe<CurrencyUnit>;
  denyNewContact?: Maybe<Scalars['Boolean']>;
  excludeFromSearch?: Maybe<Scalars['Boolean']>;
  facebookUrl?: Maybe<Scalars['String']>;
  fundraisingStatus?: Maybe<FundraisingStatus>;
  hasStripeCustomerId?: Maybe<Scalars['Boolean']>;
  headerImage?: Maybe<Scalars['String']>;
  highlightedJobListings?: Maybe<JobConnection>;
  id?: Maybe<Scalars['ID']>;
  instagramUrl?: Maybe<Scalars['String']>;
  investmentTargetMarkets?: Maybe<Array<MarketBase>>;
  investmentTargetRounds?: Maybe<Array<RoundBase>>;
  investments?: Maybe<Array<InvestmentBase>>;
  isVc?: Maybe<Scalars['Boolean']>;
  jobApplicationsCount?: Maybe<Scalars['Int']>;
  jobBookmarksCount?: Maybe<Scalars['Int']>;
  jobFootprintsCount?: Maybe<Scalars['Int']>;
  jobs?: Maybe<JobConnection>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<LocationBase>>;
  logo?: Maybe<Scalars['String']>;
  markets?: Maybe<Array<MarketBase>>;
  maxInvestmentAmount?: Maybe<Scalars['BigInt']>;
  minInvestmentAmount?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  pitches?: Maybe<Array<MyPitchBase>>;
  pmsPlan?: Maybe<PmsPlanBase>;
  products?: Maybe<Array<ProductBase>>;
  receivedInvestments?: Maybe<Array<InvestmentBase>>;
  recruitPlan?: Maybe<RecruitPlan>;
  round?: Maybe<RoundBase>;
  slug: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  totalFundingAmount?: Maybe<Scalars['BigInt']>;
  twitterUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};


export type MyCompanyArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MyCompanyHighlightedJobListingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MyCompanyJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MyCompanyMemberBase = {
  __typename?: 'MyCompanyMember';
  company?: Maybe<MyCompanyBase>;
  id?: Maybe<Scalars['ID']>;
  invitedByUser?: Maybe<UserBase>;
  role: CompanyMemberRole;
  user?: Maybe<UserBase>;
};

export type MyPitchBase = {
  __typename?: 'MyPitch';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdBy?: Maybe<UserBase>;
  currencyUnit?: Maybe<CurrencyUnit>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instrument?: Maybe<PitchInstrumentBase>;
  permission: PitchPermission;
  pitchAttachments?: Maybe<Array<PitchAttachmentBase>>;
  pitchReaders?: Maybe<Array<PitchReaderBase>>;
  roundName: Scalars['String'];
  roundSize?: Maybe<Scalars['BigInt']>;
  slug: Scalars['String'];
  status: PitchStatus;
  targetClosingDate?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  valuationCap?: Maybe<Scalars['BigInt']>;
  valuationCapType?: Maybe<PitchValuationCapBase>;
};

export type NewJobOpeningNotificationBase = {
  __typename?: 'NewJobOpeningNotification';
  company: CompanyBase;
  id: Scalars['ID'];
};

export type NewMessageNotificationBase = {
  __typename?: 'NewMessageNotification';
  id: Scalars['ID'];
  message: MessageBase;
};

export type NewRecruitingMessageNotificationBase = {
  __typename?: 'NewRecruitingMessageNotification';
  company: CompanyBase;
  id: Scalars['ID'];
  message: MessageBase;
};

export type NewUserFollowerNotificationBase = {
  __typename?: 'NewUserFollowerNotification';
  id: Scalars['ID'];
  user: UserBase;
};

export type NotificationBase = {
  __typename?: 'Notification';
  category: NotificationCategory;
  createdAt: Scalars['ISO8601DateTime'];
  fundraisingStatusUpdatedNotification?: Maybe<FundraisingStatusUpdatedNotificationBase>;
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  jobSeekingStatusUpdatedNotification?: Maybe<JobSeekingStatusUpdatedNotificationBase>;
  newJobOpeningNotification?: Maybe<NewJobOpeningNotificationBase>;
  newMessageNotification?: Maybe<NewMessageNotificationBase>;
  newRecruitingMessageNotification?: Maybe<NewRecruitingMessageNotificationBase>;
  newUserFollowerNotification?: Maybe<NewUserFollowerNotificationBase>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum NotificationCategory {
  FUNDRAISING_STATUS_UPDATED = 'FUNDRAISING_STATUS_UPDATED',
  JOB_SEEKING_STATUS_UPDATED = 'JOB_SEEKING_STATUS_UPDATED',
  MESSAGE = 'MESSAGE',
  NEWS = 'NEWS',
  NEW_JOB_OPENING = 'NEW_JOB_OPENING',
  RECRUITING = 'RECRUITING',
  USER_FOLLOWED = 'USER_FOLLOWED'
}

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<NotificationBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<NotificationBase>;
};

export type NumberDashboardItemBase = {
  __typename?: 'NumberDashboardItem';
  value?: Maybe<Scalars['String']>;
};

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PaymentIntentBase = {
  __typename?: 'PaymentIntent';
  clientSecret: Scalars['String'];
  discountAmountOff: Scalars['Int'];
  planAmount: Scalars['Int'];
  subscriptionId: Scalars['ID'];
  totalAmount: Scalars['Int'];
};

export type PieDashboardItemBase = {
  __typename?: 'PieDashboardItem';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['BigInt']>;
};

export type PitchBase = {
  __typename?: 'Pitch';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  currencyUnit?: Maybe<CurrencyUnit>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instrument?: Maybe<PitchInstrumentBase>;
  permission: PitchPermission;
  pitchAttachments?: Maybe<Array<PitchAttachmentBase>>;
  roundName: Scalars['String'];
  roundSize?: Maybe<Scalars['BigInt']>;
  slug: Scalars['String'];
  status: PitchStatus;
  targetClosingDate?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  valuationCap?: Maybe<Scalars['BigInt']>;
  valuationCapType?: Maybe<PitchValuationCapBase>;
};

export type PitchAttachmentBase = {
  __typename?: 'PitchAttachment';
  categoryName: PitchAttachmentCategoryName;
  file?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
};

export enum PitchAttachmentCategoryName {
  ARTICLES_OF_INCORPORATION = 'ARTICLES_OF_INCORPORATION',
  CAPITAL_TABLE = 'CAPITAL_TABLE',
  FINANCIAL_PLAN = 'FINANCIAL_PLAN',
  OTHERS = 'OTHERS',
  PAST_FINANCIAL_STATEMENT = 'PAST_FINANCIAL_STATEMENT',
  PITCH_DECK = 'PITCH_DECK',
  TERM_SHEET = 'TERM_SHEET'
}

/** 資金調達クラウドのピッチ添付資料作成・更新用の属性 */
export type PitchAttachmentInputBase = {
  /** 名前 */
  categoryName: PitchAttachmentCategoryName;
  /** 添付ファイルのURL */
  file?: InputMaybe<Scalars['String']>;
  /** 添付ファイル名 */
  filename?: InputMaybe<Scalars['String']>;
  /** 資料のURL */
  url?: InputMaybe<Scalars['String']>;
};

/** 資金調達クラウドのピッチ作成・更新用の属性 */
export type PitchInputBase = {
  /** 貨幣単位 */
  currencyUnit?: InputMaybe<CurrencyUnit>;
  /** その他 */
  description?: InputMaybe<Scalars['String']>;
  /** 株式の種類 */
  instrument?: InputMaybe<PitchInstrumentBase>;
  /** リンクの閲覧許可 */
  permission: PitchPermission;
  /** ラウンド名 */
  roundName: Scalars['String'];
  /** 調達予定額 */
  roundSize?: InputMaybe<Scalars['BigInt']>;
  /** 公開ステータス */
  status: PitchStatus;
  /** 調達終了予定日 */
  targetClosingDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** バリュエーション */
  valuationCap?: InputMaybe<Scalars['BigInt']>;
  /** バリュエーションタイプ */
  valuationCapType?: InputMaybe<PitchValuationCapBase>;
};

export enum PitchInstrumentBase {
  COMMON_STOCK = 'COMMON_STOCK',
  CONVERTIBLE_EQUITY = 'CONVERTIBLE_EQUITY',
  CONVERTIBLE_NOTE = 'CONVERTIBLE_NOTE',
  OTHERS = 'OTHERS',
  PREFERRED_STOCK = 'PREFERRED_STOCK',
  SAFE = 'SAFE',
  SAFT = 'SAFT'
}

export enum PitchPermission {
  ANYONE_WITH_THE_LINK = 'ANYONE_WITH_THE_LINK',
  RESTRICTED = 'RESTRICTED'
}

export type PitchReaderBase = {
  __typename?: 'PitchReader';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  pitch?: Maybe<MyPitchBase>;
  user?: Maybe<UserBase>;
};

export enum PitchStatus {
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export enum PitchValuationCapBase {
  POST = 'POST',
  PRE = 'PRE'
}

export enum PmsPlanBase {
  BASIC_PLAN = 'BASIC_PLAN',
  NO_CONTRACT = 'NO_CONTRACT'
}

export type PortfolioBase = {
  __typename?: 'Portfolio';
  aboutUs?: Maybe<Scalars['String']>;
  acquisitionChannel?: Maybe<AcquisitionChannelBase>;
  company?: Maybe<CompanyBase>;
  companySize?: Maybe<CompanySize>;
  id?: Maybe<Scalars['ID']>;
  locations?: Maybe<Array<LocationBase>>;
  markets?: Maybe<Array<MarketBase>>;
  portfolioAttachments?: Maybe<Array<PortfolioAttachmentBase>>;
  portfolioMeetings?: Maybe<PortfolioMeetingConnection>;
  portfolioNotes?: Maybe<PortfolioNoteConnection>;
  round?: Maybe<RoundBase>;
};


export type PortfolioPortfolioMeetingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PortfolioPortfolioNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PortfolioAttachmentBase = {
  __typename?: 'PortfolioAttachment';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  file?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  user?: Maybe<UserBase>;
};

/** ポートフォリオのファイルの属性 */
export type PortfolioAttachmentInputBase = {
  /** ファイル */
  file?: InputMaybe<Scalars['String']>;
  /** ファイル名 */
  filename?: InputMaybe<Scalars['String']>;
};

/** The connection type for Portfolio. */
export type PortfolioConnection = {
  __typename?: 'PortfolioConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PortfolioEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PortfolioBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PortfolioEdge = {
  __typename?: 'PortfolioEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PortfolioBase>;
};

/** ポートフォリオの属性 */
export type PortfolioInputBase = {
  /** 概要 */
  aboutUs?: InputMaybe<Scalars['String']>;
  /** チャネル */
  acquisitionChannelId?: InputMaybe<Scalars['ID']>;
  /** 従業員数 */
  companySize?: InputMaybe<CompanySize>;
  /** 所在地 */
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** マーケット */
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  /** ラウンド */
  roundId?: InputMaybe<Scalars['ID']>;
};

export type PortfolioMeetingBase = {
  __typename?: 'PortfolioMeeting';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  participants?: Maybe<Array<UserBase>>;
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
  status?: Maybe<PortfolioMeetingStatusBase>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  user?: Maybe<UserBase>;
};

/** The connection type for PortfolioMeeting. */
export type PortfolioMeetingConnection = {
  __typename?: 'PortfolioMeetingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PortfolioMeetingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PortfolioMeetingBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PortfolioMeetingEdge = {
  __typename?: 'PortfolioMeetingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PortfolioMeetingBase>;
};

/** ポートフォリオミーティングの属性 */
export type PortfolioMeetingInputBase = {
  /** ミーティングについての説明 */
  description?: InputMaybe<Scalars['String']>;
  /** 参加者 */
  participantIds?: InputMaybe<Array<Scalars['ID']>>;
  /** ミーティングが始まる日時 */
  startAt: Scalars['ISO8601DateTime'];
};

export enum PortfolioMeetingStatusBase {
  DONE = 'DONE',
  TODO = 'TODO'
}

export type PortfolioNoteBase = {
  __typename?: 'PortfolioNote';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  user?: Maybe<UserBase>;
};

/** The connection type for PortfolioNote. */
export type PortfolioNoteConnection = {
  __typename?: 'PortfolioNoteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PortfolioNoteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PortfolioNoteBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PortfolioNoteEdge = {
  __typename?: 'PortfolioNoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PortfolioNoteBase>;
};

/** ポートフォリオノートの属性 */
export type PortfolioNoteInputBase = {
  /** 文章 */
  note?: InputMaybe<Scalars['String']>;
};

export type ProductBase = {
  __typename?: 'Product';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** プロダクト作成・更新用の属性 */
export type ProductInputBase = {
  /** プロダクトの説明 */
  description?: InputMaybe<Scalars['String']>;
  /** プロダクトの画像のURL */
  image?: InputMaybe<Scalars['String']>;
  /** プロダクトの名前 */
  name?: InputMaybe<Scalars['String']>;
  /** プロダクトのURL */
  url?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /** キーワード検索して該当のエンジェル投資家を返す */
  angels: UserConnection;
  /** 指定された記事を返す */
  article?: Maybe<ArticleBase>;
  /** 記事の一覧を返す */
  articles: ArticleConnection;
  /** キーワード検索して該当の会社を返す */
  companies: CompanyConnection;
  /** キーワード検索して該当の求人を持つ会社を返す */
  companiesWithJobs: CompanyConnection;
  /** スラッグを指定された会社情報を返す */
  company?: Maybe<CompanyBase>;
  /** 会社記事の一覧を返す */
  companyArticles: ArticleConnection;
  /** 指定した会社の募集一覧を返す */
  companyJobs: JobConnection;
  /** 重み付けの数値が大きい順にエンジェル投資家一覧を返す */
  featuredAngels: Array<UserBase>;
  /** 重み付けの数値が大きい順に求人掲載企業一覧を返す */
  featuredCompaniesWithJobs: Array<CompanyBase>;
  /** 重み付けの数値が大きい順に募集一覧を返す */
  featuredJobs: Array<JobBase>;
  /** 重み付けの数値が大きい順にスタートアップ一覧を返す */
  featuredStartups: Array<CompanyBase>;
  /** 重み付けの数値が大きい順にストーリー一覧を返す */
  featuredStories: Array<ArticleBase>;
  /** 重み付けの数値が大きい順にVC一覧を返す */
  featuredVentureCapitals: Array<CompanyBase>;
  /** フォロワー一覧を返す */
  followers: UserConnection;
  /** フォロー一覧を返す */
  following: FollowableEntityConnection;
  /** 最新の為替レートを返す */
  forexRate?: Maybe<ForexRateBase>;
  /** 指定された募集を返す */
  job: JobBase;
  /** 該当の会社の応募一覧を返す */
  jobApplications: JobApplicationConnection;
  /** 会社の求人がブックマークされた一覧を返す */
  jobBookmarks: JobBookmarkConnection;
  /** 職種の一覧を返す */
  jobCategories: Array<JobCategoryBase>;
  /** 指定した募集の足跡一覧を返す */
  jobFootprints: JobFootprintConnection;
  /** 特徴の一覧を返す */
  jobTags: Array<JobTagBase>;
  /** 募集の一覧を返す */
  jobs: JobConnection;
  /** 指定した地域を返す */
  location: LocationBase;
  /** キーワード検索して地域を返す */
  locations: LocationConnection;
  /** マーケットの一覧を返す */
  markets: Array<MarketBase>;
  /** ログイン中の現在のユーザーを返す */
  me?: Maybe<MeBase>;
  /** 指定されたスレッドを返す */
  messageThread: MessageThreadBase;
  /** ログインユーザーが所属するスレッド一覧を返す */
  messageThreads: Array<MessageThreadBase>;
  /** ユーザー記事の一覧を返す */
  myArticles: ArticleConnection;
  /** スラッグを指定された自社情報を返す */
  myCompany?: Maybe<MyCompanyBase>;
  /** 設定画面で使用し自身の会社のリファレンスを一覧で返す */
  myCompanyReferences: CompanyReferenceConnection;
  /** 保存した求人一覧を返す */
  myJobBookmarks: JobBookmarkConnection;
  /** 設定画面で使用し募集の一覧を返す */
  myJobs: JobConnection;
  /** 自社のピッチを返す */
  myPitches: Array<MyPitchBase>;
  /** 設定画面で使用し自身のリファレンスを一覧で返す */
  myReferences: UserReferenceConnection;
  /** ログインユーザーが所属するスレッド一覧を返す */
  paginatedMessageThreads: MessageThreadConnection;
  /** 重み付けの数値が大きい順に特集一覧を返す */
  pickedUpFeatures: Array<ArticleBase>;
  /** 該当のピッチを返す */
  pitch: PitchBase;
  /** 会社の閲覧可能なピッチを返す */
  pitches: Array<PitchBase>;
  /** like検索して該当の会社を返す */
  searchCompany: CompanyConnection;
  /** like検索して該当のユーザーを返す */
  searchUser: UserConnection;
  /** キーワードを検索してスキルを返す */
  skills: SkillConnection;
  /** 補助金の一覧を返す */
  subsidies: SubsidyConnection;
  /** 指定された補助金を返す */
  subsidy?: Maybe<SubsidyBase>;
  /** 指定した補助金利用目的を返す */
  subsidyPurpose: SubsidyPurposeBase;
  /** 補助金利用目的の一覧を返す */
  subsidyPurposes: Array<SubsidyPurposeBase>;
  /** ログイン名で指定されたユーザーを返す */
  user?: Maybe<UserBase>;
  /** ユーザー記事の一覧を返す */
  userArticles: ArticleConnection;
  /** 招待リンクの検証 */
  validInvitationToken: InvitationBase;
  /** ビークルを返す */
  vehicle?: Maybe<VehicleBase>;
  /** ビークルのアナリティクスを一覧で返す */
  vehicleAnalytics: Array<DashboardBase>;
  /** ビークルアイテムを返す */
  vehicleItem?: Maybe<VehicleItemBase>;
  /** ビークルアイテムを一覧で返す */
  vehicleItems: VehicleItemConnection;
};


export type QueryAngelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  first?: InputMaybe<Scalars['Int']>;
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']>>;
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<UserOrderBase>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryArticleArgs = {
  slug: Scalars['ID'];
};


export type QueryArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySize?: InputMaybe<CompanySize>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  first?: InputMaybe<Scalars['Int']>;
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']>>;
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']>>;
  isVc?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<CompanyOrderBase>;
  query?: InputMaybe<Scalars['String']>;
  roundIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryCompaniesWithJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  angelUsername?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  companyLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  companySize?: InputMaybe<CompanySize>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  equityGrant?: InputMaybe<Array<Scalars['Boolean']>>;
  first?: InputMaybe<Scalars['Int']>;
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']>>;
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']>>;
  isVc?: InputMaybe<Scalars['Boolean']>;
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  jobLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  last?: InputMaybe<Scalars['Int']>;
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  maxMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  minMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  query?: InputMaybe<Scalars['String']>;
  roundIds?: InputMaybe<Array<Scalars['ID']>>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  typeOfPosition?: InputMaybe<Array<JobTypeOfPosition>>;
  vcSlug?: InputMaybe<Scalars['ID']>;
  workExperience?: InputMaybe<JobWorkExperience>;
  workingForm?: InputMaybe<Array<JobWorkingForm>>;
};


export type QueryCompanyArgs = {
  slug: Scalars['ID'];
};


export type QueryCompanyArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['ID']>;
};


export type QueryCompanyJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryFollowersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  entityType: FollowableEntityEntityType;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
};


export type QueryFollowingArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username: Scalars['ID'];
};


export type QueryForexRateArgs = {
  tickerSymbol: TickerSymbol;
};


export type QueryJobArgs = {
  slug: Scalars['ID'];
};


export type QueryJobApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryJobBookmarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  jobSlug?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryJobFootprintsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  jobSlug?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  equityGrant?: InputMaybe<Array<Scalars['Boolean']>>;
  first?: InputMaybe<Scalars['Int']>;
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  maxMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  minMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  query?: InputMaybe<Scalars['String']>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  typeOfPosition?: InputMaybe<Array<JobTypeOfPosition>>;
  workExperience?: InputMaybe<JobWorkExperience>;
  workingForm?: InputMaybe<Array<JobWorkingForm>>;
};


export type QueryLocationArgs = {
  id: Scalars['ID'];
};


export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMessageThreadArgs = {
  slug: Scalars['ID'];
};


export type QueryMyArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyCompanyArgs = {
  slug: Scalars['ID'];
};


export type QueryMyCompanyReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
};


export type QueryMyJobBookmarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyPitchesArgs = {
  companySlug: Scalars['ID'];
};


export type QueryMyReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedMessageThreadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryPitchArgs = {
  slug: Scalars['ID'];
};


export type QueryPitchesArgs = {
  companySlug: Scalars['ID'];
};


export type QuerySearchCompanyArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySearchUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySkillsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerySubsidiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationsId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  subsidyPurposeIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerySubsidyArgs = {
  id: Scalars['ID'];
};


export type QuerySubsidyPurposeArgs = {
  id: Scalars['ID'];
};


export type QueryUserArgs = {
  username: Scalars['ID'];
};


export type QueryUserArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['ID']>;
};


export type QueryValidInvitationTokenArgs = {
  token: Scalars['String'];
};


export type QueryVehicleArgs = {
  slug: Scalars['ID'];
};


export type QueryVehicleAnalyticsArgs = {
  vehicleSlug: Scalars['ID'];
};


export type QueryVehicleItemArgs = {
  id: Scalars['ID'];
};


export type QueryVehicleItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  vehicleSlug: Scalars['ID'];
  vehicleStatusIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum RecruitPlan {
  BASIC_PLAN = 'BASIC_PLAN',
  NO_CONTRACT = 'NO_CONTRACT'
}

export enum RecruitPrice {
  ONE_YEAR = 'ONE_YEAR',
  SIX_MONTHS = 'SIX_MONTHS'
}

/** 求人サービスのサブスクリプション作成用の属性 */
export type RecruitSubscriptionInputBase = {
  companyName: Scalars['String'];
  couponCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  priceType: RecruitPrice;
  representativeName: Scalars['String'];
  representativePosition?: InputMaybe<Scalars['String']>;
  representativeRuby?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of RemoveCompanyMember */
export type RemoveCompanyMemberInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveCompanyReference */
export type RemoveCompanyReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveExperience */
export type RemoveExperienceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveInvestment */
export type RemoveInvestmentInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveInvestor */
export type RemoveInvestorInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveMyJobBookmark */
export type RemoveMyJobBookmarkInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  jobId: Scalars['ID'];
};

/** Autogenerated input type of RemovePitchAttachmentFromPitch */
export type RemovePitchAttachmentFromPitchInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pitchAttachmentId: Scalars['ID'];
  pitchId: Scalars['ID'];
};

/** Autogenerated input type of RemoveProduct */
export type RemoveProductInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveUserReference */
export type RemoveUserReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveVehicleMember */
export type RemoveVehicleMemberInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RoundBase = {
  __typename?: 'Round';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

export type SkillBase = {
  __typename?: 'Skill';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['ID'];
};

/** The connection type for Skill. */
export type SkillConnection = {
  __typename?: 'SkillConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SkillEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SkillBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SkillEdge = {
  __typename?: 'SkillEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SkillBase>;
};

/** スキル作成用の属性 */
export type SkillInputBase = {
  /** スキル名 */
  name: Scalars['String'];
};

export type SubsidyBase = {
  __typename?: 'Subsidy';
  agencyName?: Maybe<Scalars['String']>;
  applicationEndAt?: Maybe<Scalars['ISO8601DateTime']>;
  applicationStartAt?: Maybe<Scalars['ISO8601DateTime']>;
  body?: Maybe<Scalars['String']>;
  category?: Maybe<SubsidyCategoryBase>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  locations?: Maybe<Array<LocationBase>>;
  maximumAmount?: Maybe<Scalars['BigInt']>;
  maximumAmountSuffix?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  status?: Maybe<SubsidyStatusBase>;
  subsidyObjectInString?: Maybe<Scalars['String']>;
  subsidyObjects?: Maybe<Array<SubsidyObjectBase>>;
  subsidyPurposes?: Maybe<Array<SubsidyPurposeBase>>;
  subsidyPurposesInString?: Maybe<Scalars['String']>;
  subsidyRate?: Maybe<Scalars['String']>;
  subsidyRateNote?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum SubsidyCategoryBase {
  GENGAKU = 'GENGAKU',
  HOJOKIN = 'HOJOKIN',
  JOSEIKIN = 'JOSEIKIN',
  KYORYOKUKIN = 'KYORYOKUKIN',
  KYUFUKIN = 'KYUFUKIN',
  OTHERS = 'OTHERS',
  SHIENKIN = 'SHIENKIN',
  YUSHI = 'YUSHI'
}

/** The connection type for Subsidy. */
export type SubsidyConnection = {
  __typename?: 'SubsidyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubsidyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SubsidyBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SubsidyEdge = {
  __typename?: 'SubsidyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SubsidyBase>;
};

export type SubsidyObjectBase = {
  __typename?: 'SubsidyObject';
  createdAt: Scalars['ISO8601DateTime'];
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SubsidyPurposeBase = {
  __typename?: 'SubsidyPurpose';
  createdAt: Scalars['ISO8601DateTime'];
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum SubsidyStatusBase {
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export enum TickerSymbol {
  JPYUSD = 'JPYUSD',
  USDJPY = 'USDJPY'
}

/** Autogenerated input type of ToggleArticleLikedState */
export type ToggleArticleLikedStateInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};

/** Autogenerated input type of ToggleFollowCompany */
export type ToggleFollowCompanyInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};

/** Autogenerated input type of ToggleFollowUser */
export type ToggleFollowUserInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  username: Scalars['ID'];
};

export type TopicBase = {
  __typename?: 'Topic';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCompanyArticle */
export type UpdateCompanyArticleInputBase = {
  attributes: ArticleInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateCompany */
export type UpdateCompanyInputBase = {
  attributes: CompanyInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateCompanyMember */
export type UpdateCompanyMemberInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  role: CompanyMemberRole;
};

/** Autogenerated input type of UpdateCompanyNotificationSettings */
export type UpdateCompanyNotificationSettingsInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  notificationIds: Array<Scalars['ID']>;
};

/** Autogenerated input type of UpdateCompanyReference */
export type UpdateCompanyReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateExperience */
export type UpdateExperienceInputBase = {
  attributes: ExperienceInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateInvestment */
export type UpdateInvestmentInputBase = {
  attributes: InvestmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateInvestor */
export type UpdateInvestorInputBase = {
  attributes: InvestorInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateJob */
export type UpdateJobInputBase = {
  attributes: JobInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateMe */
export type UpdateMeInputBase = {
  attributes: UserInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateMyArticle */
export type UpdateMyArticleInputBase = {
  attributes: ArticleInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateMyCompanyReference */
export type UpdateMyCompanyReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  status: CompanyReferenceStatus;
};

/** Autogenerated input type of UpdateMyProfile */
export type UpdateMyProfileInputBase = {
  attributes: UserProfileInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateMyReference */
export type UpdateMyReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  status: UserReferenceStatus;
};

/** Autogenerated input type of UpdatePitchAttachment */
export type UpdatePitchAttachmentInputBase = {
  attributes: PitchAttachmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdatePitch */
export type UpdatePitchInputBase = {
  attributes: PitchInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateProduct */
export type UpdateProductInputBase = {
  attributes: ProductInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateUserNotificationSettings */
export type UpdateUserNotificationSettingsInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  notificationIds: Array<Scalars['ID']>;
  username: Scalars['ID'];
};

/** Autogenerated input type of UpdateUserReference */
export type UpdateUserReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateVehicle */
export type UpdateVehicleInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 通貨単位 */
  currencyUnit?: InputMaybe<CurrencyUnit>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Autogenerated input type of UpdateVehicleItem */
export type UpdateVehicleItemInputBase = {
  attributes?: InputMaybe<VehicleItemInputBase>;
  captainUserId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  vehicleStatusId: Scalars['ID'];
};

/** Autogenerated input type of UpdateVehicleItemPortfolio */
export type UpdateVehicleItemPortfolioInputBase = {
  attributes: PortfolioInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  vehicleItemId: Scalars['ID'];
};

/** Autogenerated input type of UpdateVehicleItemPortfolioMeeting */
export type UpdateVehicleItemPortfolioMeetingInputBase = {
  attributes: PortfolioMeetingInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  vehicleItemId: Scalars['ID'];
};

/** Autogenerated input type of UpdateVehicleItemPortfolioNote */
export type UpdateVehicleItemPortfolioNoteInputBase = {
  attributes: PortfolioNoteInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  vehicleItemId: Scalars['ID'];
};

/** Autogenerated input type of UpdateVehicleItemRound */
export type UpdateVehicleItemRoundInputBase = {
  attributes: VehicleItemRoundInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateVehicleMember */
export type UpdateVehicleMemberInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  role: VehicleMemberRole;
};

/** Autogenerated input type of UpdateVehicleStatus */
export type UpdateVehicleStatusInputBase = {
  attributes: VehicleStatusInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vehicleStatusId?: InputMaybe<Scalars['ID']>;
};

export type UserBase = {
  __typename?: 'User';
  experiences?: Maybe<Array<ExperienceBase>>;
  followersCount?: Maybe<Scalars['Int']>;
  followingCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  investments?: Maybe<Array<InvestmentBase>>;
  isFollower?: Maybe<Scalars['Boolean']>;
  isFollowing?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationSettings?: Maybe<Array<UserNotificationBase>>;
  profile?: Maybe<UserProfileBase>;
  status?: Maybe<UserStatus>;
  userReferences?: Maybe<UserReferenceConnection>;
  username: Scalars['String'];
};


export type UserUserReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<UserBase>;
};

/** ユーザー更新用の属性 */
export type UserInputBase = {
  /** 現在のパスワード */
  currentPassword?: InputMaybe<Scalars['String']>;
  /** メールアドレス */
  email?: InputMaybe<Scalars['String']>;
  /** 本名 */
  name?: InputMaybe<Scalars['String']>;
  /** 新しいパスワード */
  newPassword?: InputMaybe<Scalars['String']>;
  /** 新しいパスワードの確認 */
  newPasswordConfirmation?: InputMaybe<Scalars['String']>;
  /** ユーザー名 */
  username?: InputMaybe<Scalars['String']>;
};

export type UserNotificationBase = {
  __typename?: 'UserNotification';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

/** ユーザーの並び順 */
export type UserOrderBase = {
  /** 昇順・降順 */
  direction: OrderDirection;
  /** ソートするユーザーのフィールド */
  userOrderField: UserOrderField;
};

export enum UserOrderField {
  ANGEL_SCORE = 'ANGEL_SCORE',
  CREATED_AT = 'CREATED_AT',
  GENERAL_SCORE = 'GENERAL_SCORE',
  JOB_SEEKER_SCORE = 'JOB_SEEKER_SCORE'
}

export type UserProfileBase = {
  __typename?: 'UserProfile';
  allowMessageRequestsFrom?: Maybe<UserProfileAllowMessageRequestsFrom>;
  avatar?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['ISO8601Date']>;
  birthdayAccessScope?: Maybe<UserProfileBirthdayAccessScopeBase>;
  currencyUnit?: Maybe<CurrencyUnit>;
  delayOfEmailNotificationsForFollower?: Maybe<UserProfileDelayOfEmailNotificationsForFollower>;
  delayOfEmailNotificationsForMessages?: Maybe<UserProfileDelayOfEmailNotificationsForMessages>;
  denyNewContact?: Maybe<Scalars['Boolean']>;
  desiredCareerPath?: Maybe<UserProfileDesiredCareerPathBase>;
  desiredCommunicationStyle?: Maybe<UserProfileDesiredCommunicationStyleBase>;
  desiredDecisionCulture?: Maybe<UserProfileDesiredDecisionCultureBase>;
  desiredEvaluationCulture?: Maybe<UserProfileDesiredEvaluationCultureBase>;
  desiredManagementCulture?: Maybe<UserProfileDesiredManagementCultureBase>;
  desiredOrientationCulture?: Maybe<UserProfileDesiredOrientationCultureBase>;
  desiredProgressionStyle?: Maybe<UserProfileDesiredProgressionStyleBase>;
  desiredRoleOnTeam?: Maybe<UserProfileDesiredRoleOnTeamBase>;
  desiredTakingOnWorkStyle?: Maybe<UserProfileDesiredTakingOnWorkStyleBase>;
  desiredThingsInNextJob?: Maybe<Scalars['String']>;
  desiredTrainingCulture?: Maybe<UserProfileDesiredTrainingCultureBase>;
  desiredWorkStyle?: Maybe<UserProfileDesiredWorkStyleBase>;
  desiredWorkplaceCulture?: Maybe<UserProfileDesiredWorkplaceCultureBase>;
  facebookUrl?: Maybe<Scalars['String']>;
  githubUrl?: Maybe<Scalars['String']>;
  hasInvestmentsWithJobs?: Maybe<Scalars['Boolean']>;
  headerImage?: Maybe<Scalars['String']>;
  instagramUrl?: Maybe<Scalars['String']>;
  investmentTargetMarkets?: Maybe<Array<MarketBase>>;
  investmentTargetRounds?: Maybe<Array<RoundBase>>;
  isAngel?: Maybe<Scalars['Boolean']>;
  isCofounderDesired?: Maybe<Scalars['Boolean']>;
  isContractorDesired?: Maybe<Scalars['Boolean']>;
  isFulltimeEmployeeDesired?: Maybe<Scalars['Boolean']>;
  isInternDesired?: Maybe<Scalars['Boolean']>;
  isInvestor?: Maybe<Scalars['Boolean']>;
  isJobSeeker: Scalars['Boolean'];
  isJobSeekerMailMagazineAccepted?: Maybe<Scalars['Boolean']>;
  isOptingInToAnnouncement?: Maybe<Scalars['Boolean']>;
  isVerifiedAccount?: Maybe<Scalars['Boolean']>;
  jobCategories?: Maybe<Array<JobCategoryBase>>;
  jobHuntingStatus?: Maybe<UserProfileJobHuntingStatus>;
  jobTitle?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<LocationBase>>;
  maxInvestmentAmount?: Maybe<Scalars['BigInt']>;
  minInvestmentAmount?: Maybe<Scalars['BigInt']>;
  primaryJobCategory?: Maybe<JobCategoryBase>;
  receiveEmailNotificationsForFollower?: Maybe<Scalars['Boolean']>;
  receiveEmailNotificationsForMessages?: Maybe<Scalars['Boolean']>;
  skills?: Maybe<Array<SkillBase>>;
  twitterUrl?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<UserProfileYearsOfExperience>;
};

export enum UserProfileAllowMessageRequestsFrom {
  EVERYONE = 'EVERYONE',
  FOLLOWEE = 'FOLLOWEE'
}

export enum UserProfileBirthdayAccessScopeBase {
  ANYONE = 'ANYONE',
  PRIVATE = 'PRIVATE'
}

export enum UserProfileDelayOfEmailNotificationsForFollower {
  IN_1_HOUR = 'IN_1_HOUR',
  IN_15_MINUTES = 'IN_15_MINUTES',
  IN_30_MINUTES = 'IN_30_MINUTES',
  SOON = 'SOON'
}

export enum UserProfileDelayOfEmailNotificationsForMessages {
  IN_1_HOUR = 'IN_1_HOUR',
  IN_15_MINUTES = 'IN_15_MINUTES',
  IN_30_MINUTES = 'IN_30_MINUTES',
  SOON = 'SOON'
}

export enum UserProfileDesiredCareerPathBase {
  AS_GENERALIST = 'AS_GENERALIST',
  AS_SPECIALIST = 'AS_SPECIALIST',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredCommunicationStyleBase {
  GOOD_LISTENER = 'GOOD_LISTENER',
  GOOD_TALKER = 'GOOD_TALKER',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredDecisionCultureBase {
  EMOTIONAL = 'EMOTIONAL',
  RATIONAL = 'RATIONAL',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredEvaluationCultureBase {
  PERFORMANCE = 'PERFORMANCE',
  SENIORITY = 'SENIORITY',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredManagementCultureBase {
  EMPOWERMENT = 'EMPOWERMENT',
  MANAGEMENT = 'MANAGEMENT',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredOrientationCultureBase {
  INNOVATIVE = 'INNOVATIVE',
  STABLE = 'STABLE',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredProgressionStyleBase {
  ALONE = 'ALONE',
  UNKNOWN = 'UNKNOWN',
  WITH_TEAM = 'WITH_TEAM'
}

export enum UserProfileDesiredRoleOnTeamBase {
  AS_LEADER = 'AS_LEADER',
  AS_SUPPORTER = 'AS_SUPPORTER',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredTakingOnWorkStyleBase {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredTrainingCultureBase {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredWorkStyleBase {
  MACRO_PERSPECTIVE = 'MACRO_PERSPECTIVE',
  MICRO_PERSPECTIVE = 'MICRO_PERSPECTIVE',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredWorkplaceCultureBase {
  BUSINESS_LIKE = 'BUSINESS_LIKE',
  COZY = 'COZY',
  UNKNOWN = 'UNKNOWN'
}

/** ユーザープロフィール更新用の属性 */
export type UserProfileInputBase = {
  /** DMの公開範囲 */
  allowMessageRequestsFrom?: InputMaybe<UserProfileAllowMessageRequestsFrom>;
  /** アバター画像 */
  avatar?: InputMaybe<Scalars['String']>;
  /** 紹介文 */
  bio?: InputMaybe<Scalars['String']>;
  /** 生年月日 */
  birthday?: InputMaybe<Scalars['ISO8601Date']>;
  /** 生年月日の公開範囲 */
  birthdayAccessScope?: InputMaybe<UserProfileBirthdayAccessScopeBase>;
  /** 貨幣単位 */
  currencyUnit?: InputMaybe<CurrencyUnit>;
  /** フォロワーのメール通知タイミング */
  delayOfEmailNotificationsForFollower?: InputMaybe<UserProfileDelayOfEmailNotificationsForFollower>;
  /** メッセージのメール通知タイミング */
  delayOfEmailNotificationsForMessages?: InputMaybe<UserProfileDelayOfEmailNotificationsForMessages>;
  /** メッセージを受け付けるか */
  denyNewContact?: InputMaybe<Scalars['Boolean']>;
  /** 希望するキャリアパス */
  desiredCareerPath?: InputMaybe<UserProfileDesiredCareerPathBase>;
  /** 希望するコミュニケーションスタイル */
  desiredCommunicationStyle?: InputMaybe<UserProfileDesiredCommunicationStyleBase>;
  /** 希望する意思決定風土 */
  desiredDecisionCulture?: InputMaybe<UserProfileDesiredDecisionCultureBase>;
  /** 希望する評価風土 */
  desiredEvaluationCulture?: InputMaybe<UserProfileDesiredEvaluationCultureBase>;
  /** 希望する管理風土 */
  desiredManagementCulture?: InputMaybe<UserProfileDesiredManagementCultureBase>;
  /** 希望する志向風土 */
  desiredOrientationCulture?: InputMaybe<UserProfileDesiredOrientationCultureBase>;
  /** 希望する進行スタイル */
  desiredProgressionStyle?: InputMaybe<UserProfileDesiredProgressionStyleBase>;
  /** 希望するチームにおける役割 */
  desiredRoleOnTeam?: InputMaybe<UserProfileDesiredRoleOnTeamBase>;
  /** 希望する請負スタイル */
  desiredTakingOnWorkStyle?: InputMaybe<UserProfileDesiredTakingOnWorkStyleBase>;
  /** 次の仕事に期待すること */
  desiredThingsInNextJob?: InputMaybe<Scalars['String']>;
  /** 希望する育成風土 */
  desiredTrainingCulture?: InputMaybe<UserProfileDesiredTrainingCultureBase>;
  /** 希望する仕事スタイル */
  desiredWorkStyle?: InputMaybe<UserProfileDesiredWorkStyleBase>;
  /** 希望する職場風土 */
  desiredWorkplaceCulture?: InputMaybe<UserProfileDesiredWorkplaceCultureBase>;
  /** FacebookのURL */
  facebookUrl?: InputMaybe<Scalars['String']>;
  /** GithubのURL */
  githubUrl?: InputMaybe<Scalars['String']>;
  /** ヘッダー画像 */
  headerImage?: InputMaybe<Scalars['String']>;
  /** InstagramのURL */
  instagramUrl?: InputMaybe<Scalars['String']>;
  /** 投資対象領域のID配列 */
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 投資対象ラウンドのID配列 */
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']>>;
  /** エンジェル投資家か */
  isAngel?: InputMaybe<Scalars['Boolean']>;
  /** 共同創業者希望 */
  isCofounderDesired?: InputMaybe<Scalars['Boolean']>;
  /** 外注・副業希望 */
  isContractorDesired?: InputMaybe<Scalars['Boolean']>;
  /** 正社員希望 */
  isFulltimeEmployeeDesired?: InputMaybe<Scalars['Boolean']>;
  /** インターン希望 */
  isInternDesired?: InputMaybe<Scalars['Boolean']>;
  /** 求職者であるか */
  isJobSeeker?: InputMaybe<Scalars['Boolean']>;
  /** 求職者向けメールマガジンの配信を許可するか */
  isJobSeekerMailMagazineAccepted?: InputMaybe<Scalars['Boolean']>;
  /** メール配信設定 */
  isOptingInToAnnouncement?: InputMaybe<Scalars['Boolean']>;
  /** 職種のID配列 */
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 求職ステータス */
  jobHuntingStatus?: InputMaybe<UserProfileJobHuntingStatus>;
  /** 職業名 */
  jobTitle?: InputMaybe<Scalars['String']>;
  /** LinkedInのURL */
  linkedinUrl?: InputMaybe<Scalars['String']>;
  /** 地域のID配列 */
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 最大投資金額 */
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  /** 最小投資金額 */
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  /** 主な職種 */
  primaryJobCategoryId?: InputMaybe<Scalars['ID']>;
  /** フォロワーのメール通知設定 */
  receiveEmailNotificationsForFollower?: InputMaybe<Scalars['Boolean']>;
  /** メッセージのメール通知設定 */
  receiveEmailNotificationsForMessages?: InputMaybe<Scalars['Boolean']>;
  /** スキルのID配列 */
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  /** TwitterのURL */
  twitterUrl?: InputMaybe<Scalars['String']>;
  /** WebサイトのURL */
  websiteUrl?: InputMaybe<Scalars['String']>;
  /** 経験年数 */
  yearsOfExperience?: InputMaybe<UserProfileYearsOfExperience>;
};

export enum UserProfileJobHuntingStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INACTIVE_BUT_OPEN_TO_OFFERS = 'INACTIVE_BUT_OPEN_TO_OFFERS',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileYearsOfExperience {
  EIGHT_YEARS_OR_MORE = 'EIGHT_YEARS_OR_MORE',
  FIVE_YEARS_OR_MORE = 'FIVE_YEARS_OR_MORE',
  FOUR_YEARS_OR_MORE = 'FOUR_YEARS_OR_MORE',
  LESS_THAN_1_YEAR = 'LESS_THAN_1_YEAR',
  NINE_YEARS_OR_MORE = 'NINE_YEARS_OR_MORE',
  ONE_YEAR_OR_MORE = 'ONE_YEAR_OR_MORE',
  SEVEN_YEARS_OR_MORE = 'SEVEN_YEARS_OR_MORE',
  SIX_YEARS_OR_MORE = 'SIX_YEARS_OR_MORE',
  TEN_YEARS_OR_MORE = 'TEN_YEARS_OR_MORE',
  THREE_YEARS_OR_MORE = 'THREE_YEARS_OR_MORE',
  TWO_YEARS_OR_MORE = 'TWO_YEARS_OR_MORE'
}

export type UserReferenceBase = {
  __typename?: 'UserReference';
  comment: Scalars['String'];
  commenter?: Maybe<UserBase>;
  id: Scalars['ID'];
  status: UserReferenceStatus;
};

/** The connection type for UserReference. */
export type UserReferenceConnection = {
  __typename?: 'UserReferenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserReferenceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserReferenceBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserReferenceEdge = {
  __typename?: 'UserReferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<UserReferenceBase>;
};

export enum UserReferenceStatus {
  HIDDEN = 'HIDDEN',
  SHOWN = 'SHOWN'
}

export enum UserRoleBase {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  SUPER_ADMIN = 'SUPER_ADMIN',
  USER = 'USER'
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  FREEZE = 'FREEZE',
  INACTIVE = 'INACTIVE',
  LEAVE = 'LEAVE'
}

export type VehicleBase = {
  __typename?: 'Vehicle';
  currencyUnit?: Maybe<CurrencyUnit>;
  id?: Maybe<Scalars['ID']>;
  investor?: Maybe<InvestorBase>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  vehicleMembers?: Maybe<Array<VehicleMemberBase>>;
  vehicleStatuses?: Maybe<Array<VehicleStatusBase>>;
};

export enum VehicleInvestor {
  COMPANY = 'COMPANY',
  USER = 'USER'
}

export type VehicleItemBase = {
  __typename?: 'VehicleItem';
  captainUser?: Maybe<UserBase>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['ID']>;
  nextMeetingDate?: Maybe<Scalars['ISO8601DateTime']>;
  portfolio?: Maybe<PortfolioBase>;
  user?: Maybe<UserBase>;
  vehicleItemRounds?: Maybe<Array<VehicleItemRoundBase>>;
  vehicleStatus?: Maybe<VehicleStatusBase>;
  weighting?: Maybe<Scalars['String']>;
};

/** The connection type for VehicleItem. */
export type VehicleItemConnection = {
  __typename?: 'VehicleItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VehicleItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<VehicleItemBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VehicleItemEdge = {
  __typename?: 'VehicleItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<VehicleItemBase>;
};

/** ビークルアイテム作成用の属性 */
export type VehicleItemInputBase = {
  /** 重み付け */
  weighting?: InputMaybe<Scalars['String']>;
};

export type VehicleItemRoundBase = {
  __typename?: 'VehicleItemRound';
  currentValuation?: Maybe<Scalars['BigInt']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  instrument?: Maybe<VehicleItemRoundInstrument>;
  investedAt?: Maybe<Scalars['ISO8601DateTime']>;
  investmentAmount?: Maybe<Scalars['BigInt']>;
  postValuation?: Maybe<Scalars['BigInt']>;
  preValuation?: Maybe<Scalars['BigInt']>;
  ratioAtInvestment?: Maybe<Scalars['Float']>;
  round?: Maybe<RoundBase>;
  valuationCap?: Maybe<Scalars['BigInt']>;
  vehicleItemRoundAttachments?: Maybe<Array<VehicleItemRoundAttachmentBase>>;
};

export type VehicleItemRoundAttachmentBase = {
  __typename?: 'VehicleItemRoundAttachment';
  category?: Maybe<VehicleItemRoundAttachmentCategory>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  file?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  user?: Maybe<UserBase>;
};

export enum VehicleItemRoundAttachmentCategory {
  ARTICLES_OF_INCORPORATION = 'ARTICLES_OF_INCORPORATION',
  CAPITAL_TABLE = 'CAPITAL_TABLE',
  FINANCIAL_PLAN = 'FINANCIAL_PLAN',
  OTHERS = 'OTHERS',
  PAST_FINANCIAL_STATEMENT = 'PAST_FINANCIAL_STATEMENT',
  PITCH_DECK = 'PITCH_DECK',
  TERM_SHEET = 'TERM_SHEET'
}

/** ビークルアイテムのファイルの属性 */
export type VehicleItemRoundAttachmentInputBase = {
  /** カテゴリー */
  category?: InputMaybe<VehicleItemRoundAttachmentCategory>;
  /** ファイル */
  file?: InputMaybe<Scalars['String']>;
  /** ファイル名 */
  filename?: InputMaybe<Scalars['String']>;
};

/** ビークルアイテム作成用の詳細属性 */
export type VehicleItemRoundInputBase = {
  /** バリュエーション */
  currentValuation?: InputMaybe<Scalars['BigInt']>;
  /** その他 */
  description?: InputMaybe<Scalars['String']>;
  /** ディスカウント */
  discount?: InputMaybe<Scalars['Float']>;
  /** 株式種類 */
  instrument?: InputMaybe<VehicleItemRoundInstrument>;
  /** 投資した日時 */
  investedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** 投資金額 */
  investmentAmount?: InputMaybe<Scalars['BigInt']>;
  /** ポストバリエーション */
  postValuation?: InputMaybe<Scalars['BigInt']>;
  /** プレバリエーション */
  preValuation?: InputMaybe<Scalars['BigInt']>;
  /** 株式保有率 */
  ratioAtInvestment?: InputMaybe<Scalars['Float']>;
  /** ラウンド */
  roundId?: InputMaybe<Scalars['ID']>;
  /** バリエーションcap */
  valuationCap?: InputMaybe<Scalars['BigInt']>;
};

export enum VehicleItemRoundInstrument {
  COMMON_STOCK = 'COMMON_STOCK',
  CONVERTIBLE_EQUITY = 'CONVERTIBLE_EQUITY',
  CONVERTIBLE_NOTE = 'CONVERTIBLE_NOTE',
  OTHERS = 'OTHERS',
  PREFERRED_STOCK = 'PREFERRED_STOCK',
  SAFE = 'SAFE',
  SAFT = 'SAFT'
}

export type VehicleMemberBase = {
  __typename?: 'VehicleMember';
  id?: Maybe<Scalars['ID']>;
  investorMember?: Maybe<InvestorMemberBase>;
  role?: Maybe<VehicleMemberRole>;
  vehicle?: Maybe<VehicleBase>;
};

export enum VehicleMemberRole {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  READER = 'READER'
}

export type VehicleStatusBase = {
  __typename?: 'VehicleStatus';
  category?: Maybe<VehicleStatusCategory>;
  id?: Maybe<Scalars['ID']>;
  itemsCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  vehicleItems?: Maybe<VehicleItemConnection>;
  weighting?: Maybe<Scalars['String']>;
};


export type VehicleStatusVehicleItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum VehicleStatusCategory {
  DEFAULT = 'DEFAULT',
  INVESTED = 'INVESTED',
  REJECTED = 'REJECTED'
}

/** ビークルステータスの追加・更新用の属性 */
export type VehicleStatusInputBase = {
  /** カテゴリ */
  category?: InputMaybe<VehicleStatusCategory>;
  /** ビークルステータス名 */
  name?: InputMaybe<Scalars['String']>;
  /** 重み付け */
  weighting?: InputMaybe<Scalars['String']>;
};

export type CompanyWithJobsFragmentBase = { __typename?: 'Company', jobs?: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined };

export type HighlightedJobListingsFragmentBase = { __typename?: 'Company', highlightedJobListings?: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined };

export type MinCompanyFieldFragmentBase = { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined };

export type CompanyReferenceFieldsFragmentBase = { __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined };

export type RecievedInvestmentFieldsFragmentBase = { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', bio?: string | null | undefined, avatar?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, twitterUrl?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined };

export type MinJobApplicationFieldsFragmentBase = { __typename?: 'JobApplication', id: string, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageThread: { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined } };

export type JobCategoryFieldsFragmentBase = { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string };

export type JobTagFieldsFragmentBase = { __typename?: 'JobTag', id: string, name: string, slug: string };

export type JobFieldsFragmentBase = { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> };

export type LocationFieldsFragmentBase = { __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string };

export type MarketFieldsFragmentBase = { __typename?: 'Market', id: string, name: string, slug?: string | null | undefined };

export type MessageAttachmentFieldsFragmentBase = { __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string };

export type MinMessageThreadFieldsFragmentBase = { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined };

export type MessageFieldsFragmentBase = { __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, readers?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageAttachments?: Array<{ __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string }> | null | undefined };

export type NotificationFieldsFragmentBase = { __typename?: 'Notification', id: string, category: NotificationCategory, isRead: boolean, createdAt: string, updatedAt: string, jobSeekingStatusUpdatedNotification?: { __typename?: 'JobSeekingStatusUpdatedNotification', id: string, user: { __typename?: 'User', name: string, username: string } } | null | undefined, newJobOpeningNotification?: { __typename?: 'NewJobOpeningNotification', id: string, company: { __typename?: 'Company', name?: string | null | undefined, slug: string } } | null | undefined, newMessageNotification?: { __typename?: 'NewMessageNotification', id: string, message: { __typename?: 'Message', id: string, body: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageThread?: { __typename?: 'MessageThread', slug: string, messageThreadType: MessageThreadType } | null | undefined } } | null | undefined, newRecruitingMessageNotification?: { __typename?: 'NewRecruitingMessageNotification', id: string, company: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, slug: string }, message: { __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageThread?: { __typename?: 'MessageThread', slug: string, messageThreadType: MessageThreadType } | null | undefined } } | null | undefined, newUserFollowerNotification?: { __typename?: 'NewUserFollowerNotification', id: string, user: { __typename?: 'User', name: string, username: string } } | null | undefined };

export type PitchReadersFieldsFragmentBase = { __typename?: 'PitchReader', createdAt?: string | null | undefined, id: string, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined };

export type MinMyPitchFieldsFragmentBase = { __typename?: 'MyPitch', id: string, permission: PitchPermission, roundName: string, slug: string, status: PitchStatus, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, instrument?: PitchInstrumentBase | null | undefined, roundSize?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, valuationCap?: string | null | undefined, valuationCapType?: PitchValuationCapBase | null | undefined, targetClosingDate?: string | null | undefined, description?: string | null | undefined, pitchAttachments?: Array<{ __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined }> | null | undefined, createdBy?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined };

export type MyPitchFieldsFragmentBase = { __typename?: 'MyPitch', id: string, permission: PitchPermission, roundName: string, slug: string, status: PitchStatus, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, instrument?: PitchInstrumentBase | null | undefined, roundSize?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, valuationCap?: string | null | undefined, valuationCapType?: PitchValuationCapBase | null | undefined, targetClosingDate?: string | null | undefined, description?: string | null | undefined, pitchAttachments?: Array<{ __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined }> | null | undefined, pitchReaders?: Array<{ __typename?: 'PitchReader', createdAt?: string | null | undefined, id: string, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined }> | null | undefined, createdBy?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined };

export type PitchFieldsFragmentBase = { __typename?: 'Pitch', id: string, permission: PitchPermission, roundName: string, slug: string, status: PitchStatus, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, instrument?: PitchInstrumentBase | null | undefined, roundSize?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, valuationCap?: string | null | undefined, valuationCapType?: PitchValuationCapBase | null | undefined, targetClosingDate?: string | null | undefined, description?: string | null | undefined, pitchAttachments?: Array<{ __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined }> | null | undefined };

export type InvestorFieldsFragmentBase = { __typename?: 'Investor', id?: string | null | undefined, investorSlug?: string | null | undefined, investorType?: VehicleInvestor | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, acquisitionChannels?: Array<{ __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined }> | null | undefined };

export type MinVehicleFieldsFragmentBase = { __typename?: 'Vehicle', id?: string | null | undefined, name?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, slug?: string | null | undefined, investor?: { __typename?: 'Investor', id?: string | null | undefined, investorSlug?: string | null | undefined, investorType?: VehicleInvestor | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, acquisitionChannels?: Array<{ __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined }> | null | undefined } | null | undefined, vehicleStatuses?: Array<{ __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined }> | null | undefined };

export type MinVehicleItemFieldsFragmentBase = { __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, isVc?: boolean | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined };

export type MinVehicleItemPortfolioFieldsFragmentBase = { __typename?: 'Portfolio', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', name?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, slug: string, url?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined };

export type PortfolioMeetingsFragmentBase = { __typename?: 'Portfolio', portfolioMeetings?: { __typename?: 'PortfolioMeetingConnection', nodes?: Array<{ __typename?: 'PortfolioMeeting', createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, startAt?: string | null | undefined, status?: PortfolioMeetingStatusBase | null | undefined, updatedAt?: string | null | undefined, participants?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined };

export type PortfolioNotesFragmentBase = { __typename?: 'Portfolio', portfolioNotes?: { __typename?: 'PortfolioNoteConnection', nodes?: Array<{ __typename?: 'PortfolioNote', createdAt?: string | null | undefined, id?: string | null | undefined, note?: string | null | undefined, updatedAt?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined };

export type VehicleFieldsFragmentBase = { __typename?: 'Vehicle', id?: string | null | undefined, name?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, investor?: { __typename?: 'Investor', id?: string | null | undefined, investorSlug?: string | null | undefined, investorType?: VehicleInvestor | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, acquisitionChannels?: Array<{ __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined }> | null | undefined } | null | undefined, vehicleMembers?: Array<{ __typename?: 'VehicleMember', id?: string | null | undefined, role?: VehicleMemberRole | null | undefined, investorMember?: { __typename?: 'InvestorMember', id?: string | null | undefined, role?: InvestorMemberRole | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, vehicle?: { __typename?: 'Vehicle', id?: string | null | undefined, name?: string | null | undefined } | null | undefined }> | null | undefined, vehicleStatuses?: Array<{ __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined, vehicleItems?: { __typename?: 'VehicleItemConnection', nodes?: Array<{ __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, isVc?: boolean | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined }> | null | undefined };

export type VehicleItemFieldsFragmentBase = { __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', name?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, slug: string, url?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, portfolioAttachments?: Array<{ __typename?: 'PortfolioAttachment', createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, portfolioNotes?: { __typename?: 'PortfolioNoteConnection', nodes?: Array<{ __typename?: 'PortfolioNote', createdAt?: string | null | undefined, id?: string | null | undefined, note?: string | null | undefined, updatedAt?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, portfolioMeetings?: { __typename?: 'PortfolioMeetingConnection', nodes?: Array<{ __typename?: 'PortfolioMeeting', createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, startAt?: string | null | undefined, status?: PortfolioMeetingStatusBase | null | undefined, updatedAt?: string | null | undefined, participants?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined } | null | undefined };

export type VehicleItemPortfolioAttachmentFieldsFragmentBase = { __typename?: 'PortfolioAttachment', createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined };

export type VehicleItemPortfolioFieldsFragmentBase = { __typename?: 'Portfolio', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', name?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, slug: string, url?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, portfolioAttachments?: Array<{ __typename?: 'PortfolioAttachment', createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, portfolioNotes?: { __typename?: 'PortfolioNoteConnection', nodes?: Array<{ __typename?: 'PortfolioNote', createdAt?: string | null | undefined, id?: string | null | undefined, note?: string | null | undefined, updatedAt?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, portfolioMeetings?: { __typename?: 'PortfolioMeetingConnection', nodes?: Array<{ __typename?: 'PortfolioMeeting', createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, startAt?: string | null | undefined, status?: PortfolioMeetingStatusBase | null | undefined, updatedAt?: string | null | undefined, participants?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined };

export type VehicleItemPortfolioMeetingFieldsFragmentBase = { __typename?: 'PortfolioMeeting', createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, startAt?: string | null | undefined, status?: PortfolioMeetingStatusBase | null | undefined, updatedAt?: string | null | undefined, participants?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined };

export type VehicleItemPortfolioNoteFieldsFragmentBase = { __typename?: 'PortfolioNote', createdAt?: string | null | undefined, id?: string | null | undefined, note?: string | null | undefined, updatedAt?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined };

export type VehicleItemRoundAttachmentFieldsFragmentBase = { __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined };

export type VehicleItemRoundFieldsFragmentBase = { __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined };

export type VehicleMemberFieldsFragmentBase = { __typename?: 'VehicleMember', id?: string | null | undefined, role?: VehicleMemberRole | null | undefined, investorMember?: { __typename?: 'InvestorMember', id?: string | null | undefined, role?: InvestorMemberRole | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, vehicle?: { __typename?: 'Vehicle', id?: string | null | undefined, name?: string | null | undefined } | null | undefined };

export type VehicleStatusFieldsFragmentBase = { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined, vehicleItems?: { __typename?: 'VehicleItemConnection', nodes?: Array<{ __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, isVc?: boolean | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined };

export type ProductFieldsFragmentBase = { __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined };

export type RoundFieldsFragmentBase = { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined };

export type SkillFieldsFragmentBase = { __typename?: 'Skill', id: string, name: string, slug: string };

export type SubsidyFieldsFragmentBase = { __typename?: 'Subsidy', agencyName?: string | null | undefined, applicationEndAt?: string | null | undefined, applicationStartAt?: string | null | undefined, body?: string | null | undefined, category?: SubsidyCategoryBase | null | undefined, createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, maximumAmount?: string | null | undefined, maximumAmountSuffix?: string | null | undefined, sourceUrl?: string | null | undefined, status?: SubsidyStatusBase | null | undefined, subsidyObjectInString?: string | null | undefined, subsidyPurposesInString?: string | null | undefined, subsidyRate?: string | null | undefined, subsidyRateNote?: string | null | undefined, summary?: string | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, subsidyObjects?: Array<{ __typename?: 'SubsidyObject', createdAt: string, id?: string | null | undefined, name?: string | null | undefined, updatedAt: string }> | null | undefined, subsidyPurposes?: Array<{ __typename?: 'SubsidyPurpose', createdAt: string, id?: string | null | undefined, name?: string | null | undefined, updatedAt: string }> | null | undefined };

export type UserReferenceFieldsFragmentBase = { __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined };

export type MinUserFieldsFragmentBase = { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined };

export type AddAngelInvestmentInvitationMutationVariables = Exact<{
  input: AddAngelInvestmentInvitationInputBase;
}>;


export type AddAngelInvestmentInvitationMutation = { __typename?: 'Mutation', addAngelInvestmentInvitation?: { __typename?: 'InvitationLink', url: string } | null | undefined };

export type AddAngelInvitationMutationVariables = Exact<{
  input: AddAngelInvitationInputBase;
}>;


export type AddAngelInvitationMutation = { __typename?: 'Mutation', addAngelInvitation?: { __typename?: 'InvitationLink', url: string } | null | undefined };

export type AddCompanyInvestmentMutationVariables = Exact<{
  input: AddCompanyInvestmentInputBase;
}>;


export type AddCompanyInvestmentMutation = { __typename?: 'Mutation', addCompanyInvestment?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined } | null | undefined };

export type AddCompanyMemberMutationVariables = Exact<{
  input: AddCompanyMemberInputBase;
}>;


export type AddCompanyMemberMutation = { __typename?: 'Mutation', addCompanyMember?: { __typename?: 'MyCompanyMember', id?: string | null | undefined, role: CompanyMemberRole, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined } | null | undefined };

export type AddCompanyReferenceMutationVariables = Exact<{
  input: AddCompanyReferenceInputBase;
}>;


export type AddCompanyReferenceMutation = { __typename?: 'Mutation', addCompanyReference?: { __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type AddExperienceMutationVariables = Exact<{
  input: AddExperienceInputBase;
}>;


export type AddExperienceMutation = { __typename?: 'Mutation', addExperience?: { __typename?: 'Experience', current: boolean, description?: string | null | undefined, endedAt?: string | null | undefined, id: string, startedAt?: string | null | undefined, status: string, title?: string | null | undefined, addedByUser: { __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, company: { __typename?: 'Company', id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined } } | null | undefined };

export type AddFootprintToJobMutationVariables = Exact<{
  input: AddFootprintToJobInputBase;
}>;


export type AddFootprintToJobMutation = { __typename?: 'Mutation', addFootprintToJob?: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined };

export type AddInvestorMutationVariables = Exact<{
  input: AddInvestorInputBase;
}>;


export type AddInvestorMutation = { __typename?: 'Mutation', addInvestor?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, companyMembers?: Array<{ __typename?: 'CompanyMember', id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', jobTitle?: string | null | undefined, bio?: string | null | undefined, avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined }> | null | undefined } | null | undefined, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, twitterUrl?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', name?: string | null | undefined, logo?: string | null | undefined, slug: string, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined } | null | undefined };

export type AddMemberInvitationMutationVariables = Exact<{
  input: AddMemberInvitationInputBase;
}>;


export type AddMemberInvitationMutation = { __typename?: 'Mutation', addMemberInvitation?: { __typename?: 'InvitationLink', url: string } | null | undefined };

export type AddMyInvestmentMutationVariables = Exact<{
  input: AddMyInvestmentInputBase;
}>;


export type AddMyInvestmentMutation = { __typename?: 'Mutation', addMyInvestment?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined };

export type AddMyJobBookmarkMutationVariables = Exact<{
  input: AddMyJobBookmarkInputBase;
}>;


export type AddMyJobBookmarkMutation = { __typename?: 'Mutation', addMyJobBookmark?: { __typename?: 'JobBookmark', id?: string | null | undefined, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type AddPitchAttachmentMutationVariables = Exact<{
  input: AddPitchAttachmentInputBase;
}>;


export type AddPitchAttachmentMutation = { __typename?: 'Mutation', addPitchAttachment?: { __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined } | null | undefined };

export type AddProductMutationVariables = Exact<{
  input: AddProductInputBase;
}>;


export type AddProductMutation = { __typename?: 'Mutation', addProduct?: { __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined } | null | undefined };

export type AddUserReferenceMutationVariables = Exact<{
  input: AddUserReferenceInputBase;
}>;


export type AddUserReferenceMutation = { __typename?: 'Mutation', addUserReference?: { __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type AddVcInvestmentInvitationMutationVariables = Exact<{
  input: AddVcInvestmentInvitationInputBase;
}>;


export type AddVcInvestmentInvitationMutation = { __typename?: 'Mutation', addVcInvestmentInvitation?: { __typename?: 'InvitationLink', url: string } | null | undefined };

export type AddVcInvitationMutationVariables = Exact<{
  input: AddVcInvitationInputBase;
}>;


export type AddVcInvitationMutation = { __typename?: 'Mutation', addVcInvitation?: { __typename?: 'InvitationLink', url: string } | null | undefined };

export type AddVehicleItemPortfolioAttachmentMutationVariables = Exact<{
  input: AddVehicleItemPortfolioAttachmentInputBase;
}>;


export type AddVehicleItemPortfolioAttachmentMutation = { __typename?: 'Mutation', addVehicleItemPortfolioAttachment?: { __typename?: 'PortfolioAttachment', createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type AddVehicleItemRoundAttachmentMutationVariables = Exact<{
  input: AddVehicleItemRoundAttachmentInputBase;
}>;


export type AddVehicleItemRoundAttachmentMutation = { __typename?: 'Mutation', addVehicleItemRoundAttachment?: { __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type AddVehicleMemberMutationVariables = Exact<{
  input: AddVehicleMemberInputBase;
}>;


export type AddVehicleMemberMutation = { __typename?: 'Mutation', addVehicleMember?: { __typename?: 'VehicleMember', id?: string | null | undefined, role?: VehicleMemberRole | null | undefined, investorMember?: { __typename?: 'InvestorMember', id?: string | null | undefined, role?: InvestorMemberRole | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, vehicle?: { __typename?: 'Vehicle', id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined };

export type ApplyForJobMutationVariables = Exact<{
  input: ApplyForJobInputBase;
}>;


export type ApplyForJobMutation = { __typename?: 'Mutation', applyForJob?: { __typename?: 'JobApplication', id: string, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageThread: { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined } } | null | undefined };

export type CreateArticleAttachmentMutationVariables = Exact<{
  input: CreateArticleAttachmentInputBase;
}>;


export type CreateArticleAttachmentMutation = { __typename?: 'Mutation', createArticleAttachment?: { __typename?: 'ArticleAttachment', id: string, image: string } | null | undefined };

export type CreateBillingPortalSessionMutationVariables = Exact<{
  input: CreateBillingPortalSessionInputBase;
}>;


export type CreateBillingPortalSessionMutation = { __typename?: 'Mutation', createBillingPortalSession?: { __typename?: 'BillingPortal', sessionUrl: string } | null | undefined };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInputBase;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany?: { __typename?: 'Company', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined } | null | undefined };

export type CreateCompanyArticleMutationVariables = Exact<{
  input: CreateCompanyArticleInputBase;
}>;


export type CreateCompanyArticleMutation = { __typename?: 'Mutation', createCompanyArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type CreateJobMutationVariables = Exact<{
  input: CreateJobInputBase;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJob?: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined };

export type CreateJobAttachmentMutationVariables = Exact<{
  input: CreateJobAttachmentInputBase;
}>;


export type CreateJobAttachmentMutation = { __typename?: 'Mutation', createJobAttachment?: { __typename?: 'JobAttachment', id: string, image: string } | null | undefined };

export type CreateMessageThreadMutationVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  input: CreateMessageThreadInputBase;
}>;


export type CreateMessageThreadMutation = { __typename?: 'Mutation', createMessageThread?: { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, messages?: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, readers?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined }> | null | undefined, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageAttachments?: Array<{ __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined }> | null | undefined } | null | undefined };

export type CreateMyArticleMutationVariables = Exact<{
  input: CreateMyArticleInputBase;
}>;


export type CreateMyArticleMutation = { __typename?: 'Mutation', createMyArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type CreateMyCompanyMutationVariables = Exact<{
  input: CreateMyCompanyInputBase;
}>;


export type CreateMyCompanyMutation = { __typename?: 'Mutation', createMyCompany?: { __typename?: 'MyCompany', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, companyMembers?: Array<{ __typename?: 'MyCompanyMember', role: CompanyMemberRole, company?: { __typename?: 'MyCompany', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, companyMembers?: Array<{ __typename?: 'MyCompanyMember', id?: string | null | undefined, role: CompanyMemberRole, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, receivedInvestments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', bio?: string | null | undefined, avatar?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, twitterUrl?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, products?: Array<{ __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined };

export type CreatePitchMutationVariables = Exact<{
  input: CreatePitchInputBase;
}>;


export type CreatePitchMutation = { __typename?: 'Mutation', createPitch?: { __typename?: 'MyPitch', id: string, permission: PitchPermission, roundName: string, slug: string, status: PitchStatus, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, instrument?: PitchInstrumentBase | null | undefined, roundSize?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, valuationCap?: string | null | undefined, valuationCapType?: PitchValuationCapBase | null | undefined, targetClosingDate?: string | null | undefined, description?: string | null | undefined, pitchAttachments?: Array<{ __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined }> | null | undefined, createdBy?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type CreateRecruitSubscriptionMutationVariables = Exact<{
  input: CreateRecruitSubscriptionInputBase;
}>;


export type CreateRecruitSubscriptionMutation = { __typename?: 'Mutation', createRecruitSubscription?: { __typename?: 'PaymentIntent', clientSecret: string, subscriptionId: string, planAmount: number, discountAmountOff: number, totalAmount: number } | null | undefined };

export type CreateSkillMutationVariables = Exact<{
  input: CreateSkillInputBase;
}>;


export type CreateSkillMutation = { __typename?: 'Mutation', createSkill?: { __typename?: 'Skill', id: string, name: string, slug: string } | null | undefined };

export type CreateVehicleMutationVariables = Exact<{
  input: CreateVehicleInputBase;
}>;


export type CreateVehicleMutation = { __typename?: 'Mutation', createVehicle?: { __typename?: 'Vehicle', id?: string | null | undefined, name?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, slug?: string | null | undefined, investor?: { __typename?: 'Investor', id?: string | null | undefined, investorSlug?: string | null | undefined, investorType?: VehicleInvestor | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, acquisitionChannels?: Array<{ __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined }> | null | undefined } | null | undefined, vehicleStatuses?: Array<{ __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined }> | null | undefined } | null | undefined };

export type CreateVehicleItemMutationVariables = Exact<{
  afterPortfolioNotes?: InputMaybe<Scalars['String']>;
  beforePortfolioNotes?: InputMaybe<Scalars['String']>;
  firstPortfolioNotes?: InputMaybe<Scalars['Int']>;
  lastPortfolioNotes?: InputMaybe<Scalars['Int']>;
  afterPortfolioMeetings?: InputMaybe<Scalars['String']>;
  beforePortfolioMeetings?: InputMaybe<Scalars['String']>;
  firstPortfolioMeetings?: InputMaybe<Scalars['Int']>;
  lastPortfolioMeetings?: InputMaybe<Scalars['Int']>;
  input: CreateVehicleItemInputBase;
}>;


export type CreateVehicleItemMutation = { __typename?: 'Mutation', createVehicleItem?: { __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', name?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, slug: string, url?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, portfolioAttachments?: Array<{ __typename?: 'PortfolioAttachment', createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, portfolioNotes?: { __typename?: 'PortfolioNoteConnection', nodes?: Array<{ __typename?: 'PortfolioNote', createdAt?: string | null | undefined, id?: string | null | undefined, note?: string | null | undefined, updatedAt?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, portfolioMeetings?: { __typename?: 'PortfolioMeetingConnection', nodes?: Array<{ __typename?: 'PortfolioMeeting', createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, startAt?: string | null | undefined, status?: PortfolioMeetingStatusBase | null | undefined, updatedAt?: string | null | undefined, participants?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined } | null | undefined } | null | undefined };

export type CreateVehicleItemPortfolioMeetingMutationVariables = Exact<{
  input: CreateVehicleItemPortfolioMeetingInputBase;
}>;


export type CreateVehicleItemPortfolioMeetingMutation = { __typename?: 'Mutation', createVehicleItemPortfolioMeeting?: { __typename?: 'PortfolioMeeting', createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, startAt?: string | null | undefined, status?: PortfolioMeetingStatusBase | null | undefined, updatedAt?: string | null | undefined, participants?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type CreateVehicleItemPortfolioNoteMutationVariables = Exact<{
  input: CreateVehicleItemPortfolioNoteInputBase;
}>;


export type CreateVehicleItemPortfolioNoteMutation = { __typename?: 'Mutation', createVehicleItemPortfolioNote?: { __typename?: 'PortfolioNote', createdAt?: string | null | undefined, id?: string | null | undefined, note?: string | null | undefined, updatedAt?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type CreateVehicleItemRoundMutationVariables = Exact<{
  input: CreateVehicleItemRoundInputBase;
}>;


export type CreateVehicleItemRoundMutation = { __typename?: 'Mutation', createVehicleItemRound?: { __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type CreateVehicleStatusMutationVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  input: CreateVehicleStatusInputBase;
}>;


export type CreateVehicleStatusMutation = { __typename?: 'Mutation', createVehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined, vehicleItems?: { __typename?: 'VehicleItemConnection', nodes?: Array<{ __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, isVc?: boolean | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type DeleteCompanyArticleMutationVariables = Exact<{
  input: DeleteCompanyArticleInputBase;
}>;


export type DeleteCompanyArticleMutation = { __typename?: 'Mutation', deleteCompanyArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type DeleteJobMutationVariables = Exact<{
  input: DeleteJobInputBase;
}>;


export type DeleteJobMutation = { __typename?: 'Mutation', deleteJob?: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined };

export type DeleteMyArticleMutationVariables = Exact<{
  input: DeleteMyArticleInputBase;
}>;


export type DeleteMyArticleMutation = { __typename?: 'Mutation', deleteMyArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type DeletePitchMutationVariables = Exact<{
  input: DeletePitchInputBase;
}>;


export type DeletePitchMutation = { __typename?: 'Mutation', deletePitch?: { __typename?: 'MyPitch', id: string, permission: PitchPermission, roundName: string, slug: string, status: PitchStatus, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, instrument?: PitchInstrumentBase | null | undefined, roundSize?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, valuationCap?: string | null | undefined, valuationCapType?: PitchValuationCapBase | null | undefined, targetClosingDate?: string | null | undefined, description?: string | null | undefined, pitchAttachments?: Array<{ __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined }> | null | undefined, createdBy?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type DeletePitchAttachmentMutationVariables = Exact<{
  input: DeletePitchAttachmentInputBase;
}>;


export type DeletePitchAttachmentMutation = { __typename?: 'Mutation', deletePitchAttachment?: { __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined } | null | undefined };

export type DeleteVehicleMutationVariables = Exact<{
  input: DeleteVehicleInputBase;
}>;


export type DeleteVehicleMutation = { __typename?: 'Mutation', deleteVehicle?: { __typename?: 'Vehicle', id?: string | null | undefined, name?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, slug?: string | null | undefined, investor?: { __typename?: 'Investor', id?: string | null | undefined, investorSlug?: string | null | undefined, investorType?: VehicleInvestor | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, acquisitionChannels?: Array<{ __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined }> | null | undefined } | null | undefined, vehicleStatuses?: Array<{ __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined }> | null | undefined } | null | undefined };

export type DeleteVehicleItemMutationVariables = Exact<{
  afterPortfolioNotes?: InputMaybe<Scalars['String']>;
  beforePortfolioNotes?: InputMaybe<Scalars['String']>;
  firstPortfolioNotes?: InputMaybe<Scalars['Int']>;
  lastPortfolioNotes?: InputMaybe<Scalars['Int']>;
  afterPortfolioMeetings?: InputMaybe<Scalars['String']>;
  beforePortfolioMeetings?: InputMaybe<Scalars['String']>;
  firstPortfolioMeetings?: InputMaybe<Scalars['Int']>;
  lastPortfolioMeetings?: InputMaybe<Scalars['Int']>;
  input: DeleteVehicleItemInputBase;
}>;


export type DeleteVehicleItemMutation = { __typename?: 'Mutation', deleteVehicleItem?: { __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', name?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, slug: string, url?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, portfolioAttachments?: Array<{ __typename?: 'PortfolioAttachment', createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, portfolioNotes?: { __typename?: 'PortfolioNoteConnection', nodes?: Array<{ __typename?: 'PortfolioNote', createdAt?: string | null | undefined, id?: string | null | undefined, note?: string | null | undefined, updatedAt?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, portfolioMeetings?: { __typename?: 'PortfolioMeetingConnection', nodes?: Array<{ __typename?: 'PortfolioMeeting', createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, startAt?: string | null | undefined, status?: PortfolioMeetingStatusBase | null | undefined, updatedAt?: string | null | undefined, participants?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined } | null | undefined } | null | undefined };

export type DeleteVehicleItemPortfolioAttachmentMutationVariables = Exact<{
  input: DeleteVehicleItemPortfolioAttachmentInputBase;
}>;


export type DeleteVehicleItemPortfolioAttachmentMutation = { __typename?: 'Mutation', deleteVehicleItemPortfolioAttachment?: { __typename?: 'PortfolioAttachment', createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type DeleteVehicleItemPortfolioMeetingMutationVariables = Exact<{
  input: DeleteVehicleItemPortfolioMeetingInputBase;
}>;


export type DeleteVehicleItemPortfolioMeetingMutation = { __typename?: 'Mutation', deleteVehicleItemPortfolioMeeting?: { __typename?: 'PortfolioMeeting', createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, startAt?: string | null | undefined, status?: PortfolioMeetingStatusBase | null | undefined, updatedAt?: string | null | undefined, participants?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type DeleteVehicleItemPortfolioNoteMutationVariables = Exact<{
  input: DeleteVehicleItemPortfolioNoteInputBase;
}>;


export type DeleteVehicleItemPortfolioNoteMutation = { __typename?: 'Mutation', deleteVehicleItemPortfolioNote?: { __typename?: 'PortfolioNote', createdAt?: string | null | undefined, id?: string | null | undefined, note?: string | null | undefined, updatedAt?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type DeleteVehicleItemRoundMutationVariables = Exact<{
  input: DeleteVehicleItemRoundInputBase;
}>;


export type DeleteVehicleItemRoundMutation = { __typename?: 'Mutation', deleteVehicleItemRound?: { __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type DeleteVehicleItemRoundAttachmentMutationVariables = Exact<{
  input: DeleteVehicleItemRoundAttachmentInputBase;
}>;


export type DeleteVehicleItemRoundAttachmentMutation = { __typename?: 'Mutation', deleteVehicleItemRoundAttachment?: { __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type DeleteVehicleStatusMutationVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  input: DeleteVehicleStatusInputBase;
}>;


export type DeleteVehicleStatusMutation = { __typename?: 'Mutation', deleteVehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined, vehicleItems?: { __typename?: 'VehicleItemConnection', nodes?: Array<{ __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, isVc?: boolean | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type DuplicateJobMutationVariables = Exact<{
  input: DuplicateJobInputBase;
}>;


export type DuplicateJobMutation = { __typename?: 'Mutation', duplicateJob?: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined };

export type InitializePmsMutationVariables = Exact<{
  input: InitializePmsInputBase;
}>;


export type InitializePmsMutation = { __typename?: 'Mutation', initializePms?: { __typename?: 'InvestorMember', role?: InvestorMemberRole | null | undefined, investor?: { __typename?: 'Investor', id?: string | null | undefined, investorSlug?: string | null | undefined, investorType?: VehicleInvestor | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, acquisitionChannels?: Array<{ __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined }> | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type LeaveServiceMutationVariables = Exact<{
  input: LeaveServiceInputBase;
}>;


export type LeaveServiceMutation = { __typename?: 'Mutation', leaveService?: { __typename?: 'Me', email: string, id?: string | null | undefined, name: string, status?: string | null | undefined, uid?: string | null | undefined, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, twitterUrl?: string | null | undefined } | null | undefined } | null | undefined };

export type MarkAllMessagesAsReadMutationVariables = Exact<{
  input: MarkAllMessagesAsReadInputBase;
}>;


export type MarkAllMessagesAsReadMutation = { __typename?: 'Mutation', markAllMessagesAsRead?: { __typename?: 'MarkAllMessagesAsReadPayload', clientMutationId?: string | null | undefined } | null | undefined };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  input: MarkNotificationsAsReadInputBase;
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation', markNotificationsAsRead?: { __typename?: 'MarkNotificationsAsReadPayload', clientMutationId?: string | null | undefined, hasUnreadNotifications?: boolean | null | undefined, notifications?: Array<{ __typename?: 'Notification', category: NotificationCategory, createdAt: string, id: string, isRead: boolean, updatedAt: string, newMessageNotification?: { __typename?: 'NewMessageNotification', id: string, message: { __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string } } } | null | undefined }> | null | undefined } | null | undefined };

export type MarkPitchAsReadMutationVariables = Exact<{
  input: MarkPitchAsReadInputBase;
}>;


export type MarkPitchAsReadMutation = { __typename?: 'Mutation', markPitchAsRead?: { __typename?: 'Pitch', id: string, permission: PitchPermission, roundName: string, slug: string, status: PitchStatus, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, instrument?: PitchInstrumentBase | null | undefined, roundSize?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, valuationCap?: string | null | undefined, valuationCapType?: PitchValuationCapBase | null | undefined, targetClosingDate?: string | null | undefined, description?: string | null | undefined, pitchAttachments?: Array<{ __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined }> | null | undefined } | null | undefined };

export type RemoveCompanyMemberMutationVariables = Exact<{
  input: RemoveCompanyMemberInputBase;
}>;


export type RemoveCompanyMemberMutation = { __typename?: 'Mutation', removeCompanyMember?: { __typename?: 'MyCompanyMember', id?: string | null | undefined, role: CompanyMemberRole, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined } | null | undefined };

export type RemoveCompanyReferenceMutationVariables = Exact<{
  input: RemoveCompanyReferenceInputBase;
}>;


export type RemoveCompanyReferenceMutation = { __typename?: 'Mutation', removeCompanyReference?: { __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type RemoveExperienceMutationVariables = Exact<{
  input: RemoveExperienceInputBase;
}>;


export type RemoveExperienceMutation = { __typename?: 'Mutation', removeExperience?: { __typename?: 'Experience', current: boolean, description?: string | null | undefined, endedAt?: string | null | undefined, id: string, startedAt?: string | null | undefined, status: string, title?: string | null | undefined, addedByUser: { __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, denyNewContact?: boolean | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, company: { __typename?: 'Company', id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string } | null | undefined } } | null | undefined };

export type RemoveInvestmentMutationVariables = Exact<{
  input: RemoveInvestmentInputBase;
}>;


export type RemoveInvestmentMutation = { __typename?: 'Mutation', removeInvestment?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined } | null | undefined };

export type RemoveInvestorMutationVariables = Exact<{
  input: RemoveInvestorInputBase;
}>;


export type RemoveInvestorMutation = { __typename?: 'Mutation', removeInvestor?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined } | null | undefined };

export type RemoveMyJobBookmarkMutationVariables = Exact<{
  input: RemoveMyJobBookmarkInputBase;
}>;


export type RemoveMyJobBookmarkMutation = { __typename?: 'Mutation', removeMyJobBookmark?: { __typename?: 'JobBookmark', id?: string | null | undefined, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type RemovePitchAttachmentFromPitchMutationVariables = Exact<{
  input: RemovePitchAttachmentFromPitchInputBase;
}>;


export type RemovePitchAttachmentFromPitchMutation = { __typename?: 'Mutation', removePitchAttachmentFromPitch?: { __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined } | null | undefined };

export type RemoveProductMutationVariables = Exact<{
  input: RemoveProductInputBase;
}>;


export type RemoveProductMutation = { __typename?: 'Mutation', removeProduct?: { __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined } | null | undefined };

export type RemoveUserReferenceMutationVariables = Exact<{
  input: RemoveUserReferenceInputBase;
}>;


export type RemoveUserReferenceMutation = { __typename?: 'Mutation', removeUserReference?: { __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type RemoveVehicleMemberMutationVariables = Exact<{
  input: RemoveVehicleMemberInputBase;
}>;


export type RemoveVehicleMemberMutation = { __typename?: 'Mutation', removeVehicleMember?: { __typename?: 'VehicleMember', id?: string | null | undefined, role?: VehicleMemberRole | null | undefined, investorMember?: { __typename?: 'InvestorMember', id?: string | null | undefined, role?: InvestorMemberRole | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, vehicle?: { __typename?: 'Vehicle', id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined };

export type ToggleArticleLikedStateMutationVariables = Exact<{
  input: ToggleArticleLikedStateInputBase;
}>;


export type ToggleArticleLikedStateMutation = { __typename?: 'Mutation', toggleArticleLikedState?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, isLiked?: boolean | null | undefined, likedUsersCount?: number | null | undefined, ogImage?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, fundraisingManualFields?: { __typename?: 'FundraisingManual', id: string, step: number, subcategory: FundraisingManualSubcategory } | null | undefined } | null | undefined };

export type ToggleFollowCompanyMutationVariables = Exact<{
  input: ToggleFollowCompanyInputBase;
}>;


export type ToggleFollowCompanyMutation = { __typename?: 'Mutation', toggleFollowCompany?: { __typename?: 'Company', slug: string, followersCount?: number | null | undefined, isFollowing?: boolean | null | undefined, notificationSettings?: Array<{ __typename?: 'CompanyNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined } | null | undefined };

export type ToggleFollowUserMutationVariables = Exact<{
  input: ToggleFollowUserInputBase;
}>;


export type ToggleFollowUserMutation = { __typename?: 'Mutation', toggleFollowUser?: { __typename?: 'User', username: string, name: string, followersCount?: number | null | undefined, followingCount?: number | null | undefined, isFollowing?: boolean | null | undefined, notificationSettings?: Array<{ __typename?: 'UserNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined } | null | undefined };

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInputBase;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany?: { __typename?: 'MyCompany', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, headerImage?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateCompanyArticleMutationVariables = Exact<{
  input: UpdateCompanyArticleInputBase;
}>;


export type UpdateCompanyArticleMutation = { __typename?: 'Mutation', updateCompanyArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type UpdateCompanyMemberMutationVariables = Exact<{
  input: UpdateCompanyMemberInputBase;
}>;


export type UpdateCompanyMemberMutation = { __typename?: 'Mutation', updateCompanyMember?: { __typename?: 'MyCompanyMember', id?: string | null | undefined, role: CompanyMemberRole, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined } | null | undefined };

export type UpdateCompanyNotificationSettingsMutationVariables = Exact<{
  input: UpdateCompanyNotificationSettingsInputBase;
}>;


export type UpdateCompanyNotificationSettingsMutation = { __typename?: 'Mutation', updateCompanyNotificationSettings?: { __typename?: 'Company', slug: string, notificationSettings?: Array<{ __typename?: 'CompanyNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined } | null | undefined };

export type UpdateCompanyReferenceMutationVariables = Exact<{
  input: UpdateCompanyReferenceInputBase;
}>;


export type UpdateCompanyReferenceMutation = { __typename?: 'Mutation', updateCompanyReference?: { __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateExperienceMutationVariables = Exact<{
  input: UpdateExperienceInputBase;
}>;


export type UpdateExperienceMutation = { __typename?: 'Mutation', updateExperience?: { __typename?: 'Experience', current: boolean, description?: string | null | undefined, endedAt?: string | null | undefined, id: string, startedAt?: string | null | undefined, status: string, title?: string | null | undefined, addedByUser: { __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, denyNewContact?: boolean | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, company: { __typename?: 'Company', id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string } | null | undefined } } | null | undefined };

export type UpdateInvestmentMutationVariables = Exact<{
  input: UpdateInvestmentInputBase;
}>;


export type UpdateInvestmentMutation = { __typename?: 'Mutation', updateInvestment?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateInvestorMutationVariables = Exact<{
  input: UpdateInvestorInputBase;
}>;


export type UpdateInvestorMutation = { __typename?: 'Mutation', updateInvestor?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, companyMembers?: Array<{ __typename?: 'CompanyMember', id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', jobTitle?: string | null | undefined, bio?: string | null | undefined, avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined }> | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateJobMutationVariables = Exact<{
  input: UpdateJobInputBase;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob?: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined };

export type UpdateMeMutationVariables = Exact<{
  input: UpdateMeInputBase;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe?: { __typename?: 'Me', username: string, name: string, email: string } | null | undefined };

export type UpdateMyArticleMutationVariables = Exact<{
  input: UpdateMyArticleInputBase;
}>;


export type UpdateMyArticleMutation = { __typename?: 'Mutation', updateMyArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type UpdateMyCompanyReferenceMutationVariables = Exact<{
  input: UpdateMyCompanyReferenceInputBase;
}>;


export type UpdateMyCompanyReferenceMutation = { __typename?: 'Mutation', updateMyCompanyReference?: { __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateMyProfileMutationVariables = Exact<{
  input: UpdateMyProfileInputBase;
}>;


export type UpdateMyProfileMutation = { __typename?: 'Mutation', updateMyProfile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, birthday?: any | null | undefined, birthdayAccessScope?: UserProfileBirthdayAccessScopeBase | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, delayOfEmailNotificationsForFollower?: UserProfileDelayOfEmailNotificationsForFollower | null | undefined, delayOfEmailNotificationsForMessages?: UserProfileDelayOfEmailNotificationsForMessages | null | undefined, denyNewContact?: boolean | null | undefined, desiredCareerPath?: UserProfileDesiredCareerPathBase | null | undefined, desiredCommunicationStyle?: UserProfileDesiredCommunicationStyleBase | null | undefined, desiredDecisionCulture?: UserProfileDesiredDecisionCultureBase | null | undefined, desiredEvaluationCulture?: UserProfileDesiredEvaluationCultureBase | null | undefined, desiredManagementCulture?: UserProfileDesiredManagementCultureBase | null | undefined, desiredThingsInNextJob?: string | null | undefined, desiredOrientationCulture?: UserProfileDesiredOrientationCultureBase | null | undefined, desiredProgressionStyle?: UserProfileDesiredProgressionStyleBase | null | undefined, desiredRoleOnTeam?: UserProfileDesiredRoleOnTeamBase | null | undefined, desiredTakingOnWorkStyle?: UserProfileDesiredTakingOnWorkStyleBase | null | undefined, desiredTrainingCulture?: UserProfileDesiredTrainingCultureBase | null | undefined, desiredWorkStyle?: UserProfileDesiredWorkStyleBase | null | undefined, desiredWorkplaceCulture?: UserProfileDesiredWorkplaceCultureBase | null | undefined, facebookUrl?: string | null | undefined, githubUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isCofounderDesired?: boolean | null | undefined, isContractorDesired?: boolean | null | undefined, isFulltimeEmployeeDesired?: boolean | null | undefined, isInternDesired?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isJobSeeker: boolean, isJobSeekerMailMagazineAccepted?: boolean | null | undefined, isOptingInToAnnouncement?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, receiveEmailNotificationsForFollower?: boolean | null | undefined, receiveEmailNotificationsForMessages?: boolean | null | undefined, twitterUrl?: string | null | undefined, websiteUrl?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, jobCategories?: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> | null | undefined } | null | undefined };

export type UpdateMyReferenceMutationVariables = Exact<{
  input: UpdateMyReferenceInputBase;
}>;


export type UpdateMyReferenceMutation = { __typename?: 'Mutation', updateMyReference?: { __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdatePitchMutationVariables = Exact<{
  input: UpdatePitchInputBase;
}>;


export type UpdatePitchMutation = { __typename?: 'Mutation', updatePitch?: { __typename?: 'MyPitch', id: string, permission: PitchPermission, roundName: string, slug: string, status: PitchStatus, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, instrument?: PitchInstrumentBase | null | undefined, roundSize?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, valuationCap?: string | null | undefined, valuationCapType?: PitchValuationCapBase | null | undefined, targetClosingDate?: string | null | undefined, description?: string | null | undefined, pitchAttachments?: Array<{ __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined }> | null | undefined, createdBy?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdatePitchAttachmentMutationVariables = Exact<{
  input: UpdatePitchAttachmentInputBase;
}>;


export type UpdatePitchAttachmentMutation = { __typename?: 'Mutation', updatePitchAttachment?: { __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined } | null | undefined };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInputBase;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct?: { __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined } | null | undefined };

export type UpdateUserNotificationSettingsMutationVariables = Exact<{
  input: UpdateUserNotificationSettingsInputBase;
}>;


export type UpdateUserNotificationSettingsMutation = { __typename?: 'Mutation', updateUserNotificationSettings?: { __typename?: 'User', name: string, username: string, notificationSettings?: Array<{ __typename?: 'UserNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined } | null | undefined };

export type UpdateUserReferenceMutationVariables = Exact<{
  input: UpdateUserReferenceInputBase;
}>;


export type UpdateUserReferenceMutation = { __typename?: 'Mutation', updateUserReference?: { __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateVehicleMutationVariables = Exact<{
  input: UpdateVehicleInputBase;
}>;


export type UpdateVehicleMutation = { __typename?: 'Mutation', updateVehicle?: { __typename?: 'Vehicle', id?: string | null | undefined, name?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, slug?: string | null | undefined, investor?: { __typename?: 'Investor', id?: string | null | undefined, investorSlug?: string | null | undefined, investorType?: VehicleInvestor | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, acquisitionChannels?: Array<{ __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined }> | null | undefined } | null | undefined, vehicleStatuses?: Array<{ __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined }> | null | undefined } | null | undefined };

export type UpdateVehicleItemMutationVariables = Exact<{
  afterPortfolioNotes?: InputMaybe<Scalars['String']>;
  beforePortfolioNotes?: InputMaybe<Scalars['String']>;
  firstPortfolioNotes?: InputMaybe<Scalars['Int']>;
  lastPortfolioNotes?: InputMaybe<Scalars['Int']>;
  afterPortfolioMeetings?: InputMaybe<Scalars['String']>;
  beforePortfolioMeetings?: InputMaybe<Scalars['String']>;
  firstPortfolioMeetings?: InputMaybe<Scalars['Int']>;
  lastPortfolioMeetings?: InputMaybe<Scalars['Int']>;
  input: UpdateVehicleItemInputBase;
}>;


export type UpdateVehicleItemMutation = { __typename?: 'Mutation', updateVehicleItem?: { __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', name?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, slug: string, url?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, portfolioAttachments?: Array<{ __typename?: 'PortfolioAttachment', createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, portfolioNotes?: { __typename?: 'PortfolioNoteConnection', nodes?: Array<{ __typename?: 'PortfolioNote', createdAt?: string | null | undefined, id?: string | null | undefined, note?: string | null | undefined, updatedAt?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, portfolioMeetings?: { __typename?: 'PortfolioMeetingConnection', nodes?: Array<{ __typename?: 'PortfolioMeeting', createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, startAt?: string | null | undefined, status?: PortfolioMeetingStatusBase | null | undefined, updatedAt?: string | null | undefined, participants?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateVehicleItemPortfolioMutationVariables = Exact<{
  afterPortfolioNotes?: InputMaybe<Scalars['String']>;
  beforePortfolioNotes?: InputMaybe<Scalars['String']>;
  firstPortfolioNotes?: InputMaybe<Scalars['Int']>;
  lastPortfolioNotes?: InputMaybe<Scalars['Int']>;
  afterPortfolioMeetings?: InputMaybe<Scalars['String']>;
  beforePortfolioMeetings?: InputMaybe<Scalars['String']>;
  firstPortfolioMeetings?: InputMaybe<Scalars['Int']>;
  lastPortfolioMeetings?: InputMaybe<Scalars['Int']>;
  input: UpdateVehicleItemPortfolioInputBase;
}>;


export type UpdateVehicleItemPortfolioMutation = { __typename?: 'Mutation', updateVehicleItemPortfolio?: { __typename?: 'Portfolio', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', name?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, slug: string, url?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, portfolioAttachments?: Array<{ __typename?: 'PortfolioAttachment', createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, portfolioNotes?: { __typename?: 'PortfolioNoteConnection', nodes?: Array<{ __typename?: 'PortfolioNote', createdAt?: string | null | undefined, id?: string | null | undefined, note?: string | null | undefined, updatedAt?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, portfolioMeetings?: { __typename?: 'PortfolioMeetingConnection', nodes?: Array<{ __typename?: 'PortfolioMeeting', createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, startAt?: string | null | undefined, status?: PortfolioMeetingStatusBase | null | undefined, updatedAt?: string | null | undefined, participants?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type UpdateVehicleItemPortfolioMeetingMutationVariables = Exact<{
  input: UpdateVehicleItemPortfolioMeetingInputBase;
}>;


export type UpdateVehicleItemPortfolioMeetingMutation = { __typename?: 'Mutation', updateVehicleItemPortfolioMeeting?: { __typename?: 'PortfolioMeeting', createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, startAt?: string | null | undefined, status?: PortfolioMeetingStatusBase | null | undefined, updatedAt?: string | null | undefined, participants?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateVehicleItemPortfolioNoteMutationVariables = Exact<{
  input: UpdateVehicleItemPortfolioNoteInputBase;
}>;


export type UpdateVehicleItemPortfolioNoteMutation = { __typename?: 'Mutation', updateVehicleItemPortfolioNote?: { __typename?: 'PortfolioNote', createdAt?: string | null | undefined, id?: string | null | undefined, note?: string | null | undefined, updatedAt?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateVehicleItemRoundMutationVariables = Exact<{
  input: UpdateVehicleItemRoundInputBase;
}>;


export type UpdateVehicleItemRoundMutation = { __typename?: 'Mutation', updateVehicleItemRound?: { __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type UpdateVehicleMemberMutationVariables = Exact<{
  input: UpdateVehicleMemberInputBase;
}>;


export type UpdateVehicleMemberMutation = { __typename?: 'Mutation', updateVehicleMember?: { __typename?: 'VehicleMember', id?: string | null | undefined, role?: VehicleMemberRole | null | undefined, investorMember?: { __typename?: 'InvestorMember', id?: string | null | undefined, role?: InvestorMemberRole | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, vehicle?: { __typename?: 'Vehicle', id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateVehicleStatusMutationVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  input: UpdateVehicleStatusInputBase;
}>;


export type UpdateVehicleStatusMutation = { __typename?: 'Mutation', updateVehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined, vehicleItems?: { __typename?: 'VehicleItemConnection', nodes?: Array<{ __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, isVc?: boolean | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type FetchAngelsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  locationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  orderBy?: InputMaybe<UserOrderBase>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type FetchAngelsQuery = { __typename?: 'Query', angels: { __typename?: 'UserConnection', nodes?: Array<{ __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, twitterUrl?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, isJobSeeker: boolean, hasInvestmentsWithJobs?: boolean | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchArticleQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type FetchArticleQuery = { __typename?: 'Query', article?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, isLiked?: boolean | null | undefined, likedUsersCount?: number | null | undefined, ogImage?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, opinionsUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, fundraisingManualFields?: { __typename?: 'FundraisingManual', id: string, step: number, subcategory: FundraisingManualSubcategory } | null | undefined } | null | undefined };

export type FetchArticlesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type FetchArticlesQuery = { __typename?: 'Query', articles: { __typename?: 'ArticleConnection', nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, isLiked?: boolean | null | undefined, likedUsersCount?: number | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, opinionsUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, fundraisingManualFields?: { __typename?: 'FundraisingManual', id: string, step: number, subcategory: FundraisingManualSubcategory } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchMessageThreadsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchMessageThreadsQuery = { __typename?: 'Query', messageThreads: Array<{ __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, messages?: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, readers?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageAttachments?: Array<{ __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, jobApplication?: { __typename?: 'JobApplication', id: string, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageThread: { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined } } | null | undefined }> };

export type FetchMessageThreadQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchMessageThreadQuery = { __typename?: 'Query', messageThread: { __typename?: 'MessageThread', id?: string | null | undefined, slug: string, messages?: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, readers?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageAttachments?: Array<{ __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } };

export type FetchCompaniesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  companySize?: InputMaybe<CompanySize>;
  roundIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  locationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  isVc?: InputMaybe<Scalars['Boolean']>;
  marketIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  orderBy?: InputMaybe<CompanyOrderBase>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type FetchCompaniesQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyConnection', nodes?: Array<{ __typename?: 'Company', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, followersCount?: number | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, hasInvestmentsWithJobs?: boolean | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchCompaniesWithJobsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  afterJobs?: InputMaybe<Scalars['String']>;
  beforeJobs?: InputMaybe<Scalars['String']>;
  firstJobs?: InputMaybe<Scalars['Int']>;
  lastJobs?: InputMaybe<Scalars['Int']>;
  angelUsername?: InputMaybe<Scalars['ID']>;
  companyLocationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  companySize?: InputMaybe<CompanySize>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  equityGrant?: InputMaybe<Array<Scalars['Boolean']> | Scalars['Boolean']>;
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  isVc?: InputMaybe<Scalars['Boolean']>;
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  jobLocationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  marketIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  maxMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  minMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  query?: InputMaybe<Scalars['String']>;
  roundIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  skillIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  typeOfPosition?: InputMaybe<Array<JobTypeOfPosition> | JobTypeOfPosition>;
  vcSlug?: InputMaybe<Scalars['ID']>;
  workExperience?: InputMaybe<JobWorkExperience>;
  workingForm?: InputMaybe<Array<JobWorkingForm> | JobWorkingForm>;
}>;


export type FetchCompaniesWithJobsQuery = { __typename?: 'Query', companiesWithJobs: { __typename?: 'CompanyConnection', nodes?: Array<{ __typename?: 'Company', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, receivedInvestments?: Array<{ __typename?: 'Investment', id: string, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined } | null | undefined }> | null | undefined, highlightedJobListings?: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchCompanyQueryVariables = Exact<{
  afterJobs?: InputMaybe<Scalars['String']>;
  beforeJobs?: InputMaybe<Scalars['String']>;
  firstJobs?: InputMaybe<Scalars['Int']>;
  lastJobs?: InputMaybe<Scalars['Int']>;
  afterReferences?: InputMaybe<Scalars['String']>;
  beforeReferences?: InputMaybe<Scalars['String']>;
  firstReferences?: InputMaybe<Scalars['Int']>;
  lastReferences?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, facebookUrl?: string | null | undefined, followersCount?: number | null | undefined, headerImage?: string | null | undefined, instagramUrl?: string | null | undefined, isFollowing?: boolean | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, companyMembers?: Array<{ __typename?: 'CompanyMember', id?: string | null | undefined, user?: { __typename?: 'User', isFollower?: boolean | null | undefined, id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, companyReferences?: { __typename?: 'CompanyReferenceConnection', nodes?: Array<{ __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, notificationSettings?: Array<{ __typename?: 'CompanyNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined, products?: Array<{ __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, receivedInvestments?: Array<{ __typename?: 'Investment', id: string, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, jobs?: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type FetchCompanyArticlesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchCompanyArticlesQuery = { __typename?: 'Query', companyArticles: { __typename?: 'ArticleConnection', nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchCompanyForViewerQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type FetchCompanyForViewerQuery = { __typename?: 'Query', company?: { __typename?: 'Company', isFollowing?: boolean | null | undefined, slug: string, companyMembers?: Array<{ __typename?: 'CompanyMember', id?: string | null | undefined, user?: { __typename?: 'User', isFollower?: boolean | null | undefined, id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, notificationSettings?: Array<{ __typename?: 'CompanyNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined } | null | undefined };

export type FetchCompanyJobsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  companySlug: Scalars['ID'];
}>;


export type FetchCompanyJobsQuery = { __typename?: 'Query', companyJobs: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchFeaturedAngelsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFeaturedAngelsQuery = { __typename?: 'Query', featuredAngels: Array<{ __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, twitterUrl?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, isJobSeeker: boolean, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined } | null | undefined }> };

export type FetchFeaturedCompaniesWithJobsQueryVariables = Exact<{
  afterJobs?: InputMaybe<Scalars['String']>;
  beforeJobs?: InputMaybe<Scalars['String']>;
  firstJobs?: InputMaybe<Scalars['Int']>;
  lastJobs?: InputMaybe<Scalars['Int']>;
}>;


export type FetchFeaturedCompaniesWithJobsQuery = { __typename?: 'Query', featuredCompaniesWithJobs: Array<{ __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, receivedInvestments?: Array<{ __typename?: 'Investment', id: string, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined } | null | undefined }> | null | undefined, jobs?: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined }> };

export type FetchFeaturedJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFeaturedJobsQuery = { __typename?: 'Query', featuredJobs: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }> };

export type FetchFeaturedStartupsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFeaturedStartupsQuery = { __typename?: 'Query', featuredStartups: Array<{ __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined }> };

export type FetchFeaturedStoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFeaturedStoriesQuery = { __typename?: 'Query', featuredStories: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, ogImage?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, opinionsUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined }> };

export type FetchFeaturedVentureCapitalsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFeaturedVentureCapitalsQuery = { __typename?: 'Query', featuredVentureCapitals: Array<{ __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined }> };

export type FetchFollowersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  entityType: FollowableEntityEntityType;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchFollowersQuery = { __typename?: 'Query', followers: { __typename?: 'UserConnection', nodes?: Array<{ __typename?: 'User', isFollowing?: boolean | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, isJobSeeker: boolean, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchFollowingQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username: Scalars['ID'];
}>;


export type FetchFollowingQuery = { __typename?: 'Query', following: { __typename?: 'FollowableEntityConnection', nodes?: Array<{ __typename?: 'FollowableEntity', category: FollowableEntityCategory, description?: string | null | undefined, entityType: FollowableEntityEntityType, image?: string | null | undefined, isFollowing?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, name: string, shortDescription?: string | null | undefined, slug: string } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchForexRateQueryVariables = Exact<{
  tickerSymbol: TickerSymbol;
}>;


export type FetchForexRateQuery = { __typename?: 'Query', forexRate?: { __typename?: 'ForexRate', id?: string | null | undefined, rate?: string | null | undefined, tickerSymbol?: TickerSymbol | null | undefined } | null | undefined };

export type FetchForexRatesQueryVariables = Exact<{
  tickerSymbol1: TickerSymbol;
  tickerSymbol2: TickerSymbol;
}>;


export type FetchForexRatesQuery = { __typename?: 'Query', forexRate1?: { __typename?: 'ForexRate', id?: string | null | undefined, rate?: string | null | undefined, tickerSymbol?: TickerSymbol | null | undefined } | null | undefined, forexRate2?: { __typename?: 'ForexRate', id?: string | null | undefined, rate?: string | null | undefined, tickerSymbol?: TickerSymbol | null | undefined } | null | undefined };

export type FetchJobQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type FetchJobQuery = { __typename?: 'Query', job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } };

export type FetchJobApplicationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after1?: InputMaybe<Scalars['String']>;
  before1?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  first1?: InputMaybe<Scalars['Int']>;
  last1?: InputMaybe<Scalars['Int']>;
}>;


export type FetchJobApplicationsQuery = { __typename?: 'Query', jobApplications: { __typename?: 'JobApplicationConnection', nodes?: Array<{ __typename?: 'JobApplication', id: string, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, messageThread: { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, messages?: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, readers?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageAttachments?: Array<{ __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined }, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchJobBookmarksQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  jobSlug?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchJobBookmarksQuery = { __typename?: 'Query', jobBookmarks: { __typename?: 'JobBookmarkConnection', nodes?: Array<{ __typename?: 'JobBookmark', createdAt?: string | null | undefined, id?: string | null | undefined, updatedAt?: string | null | undefined, job: { __typename?: 'Job', body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchJobCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchJobCategoriesQuery = { __typename?: 'Query', jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }> };

export type FetchJobFootprintsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  jobSlug?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchJobFootprintsQuery = { __typename?: 'Query', jobFootprints: { __typename?: 'JobFootprintConnection', nodes?: Array<{ __typename?: 'JobFootprint', createdAt?: string | null | undefined, id: string, referer?: string | null | undefined, job?: { __typename?: 'Job', createdAt: string, id: string, slug: string, status: JobStatus, thumbnail: string, title: string, typeOfPosition: JobTypeOfPosition, updatedAt: string, body: string, currencyUnit: CurrencyUnit, workExperience: JobWorkExperience, workingForm: JobWorkingForm, equityGrant: boolean, tokenGrant: boolean, maxMonthlySalary: string, minMonthlySalary: string, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchJobTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchJobTagsQuery = { __typename?: 'Query', jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }> };

export type FetchJobsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  equityGrant?: InputMaybe<Array<Scalars['Boolean']> | Scalars['Boolean']>;
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  locationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  maxMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  minMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  query?: InputMaybe<Scalars['String']>;
  skillIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  typeOfPosition?: InputMaybe<Array<JobTypeOfPosition> | JobTypeOfPosition>;
  workExperience?: InputMaybe<JobWorkExperience>;
  workingForm?: InputMaybe<Array<JobWorkingForm> | JobWorkingForm>;
}>;


export type FetchJobsQuery = { __typename?: 'Query', jobs: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchLocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchLocationQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string } };

export type FetchLocationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type FetchLocationsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', nodes?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string } | null | undefined> | null | undefined } };

export type FetchMarketsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMarketsQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> };

export type FetchMeQueryVariables = Exact<{
  articlesAfter?: InputMaybe<Scalars['String']>;
  articlesBefore?: InputMaybe<Scalars['String']>;
  articlesFirst?: InputMaybe<Scalars['Int']>;
  articlesLast?: InputMaybe<Scalars['Int']>;
  notificationsAfter?: InputMaybe<Scalars['String']>;
  notificationsBefore?: InputMaybe<Scalars['String']>;
  notificationsFirst?: InputMaybe<Scalars['Int']>;
  notificationsLast?: InputMaybe<Scalars['Int']>;
}>;


export type FetchMeQuery = { __typename?: 'Query', me?: { __typename?: 'Me', id?: string | null | undefined, email: string, invitationOf?: InvitationOfBase | null | undefined, isFirstSignIn?: boolean | null | undefined, name: string, pmsPlan?: PmsPlanBase | null | undefined, role?: UserRoleBase | null | undefined, username: string, hasUnreadNotifications?: boolean | null | undefined, companyMembers?: Array<{ __typename?: 'MyCompanyMember', role: CompanyMemberRole, id?: string | null | undefined, company?: { __typename?: 'MyCompany', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, headerImage?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, jobApplicationsCount?: number | null | undefined, jobBookmarksCount?: number | null | undefined, jobFootprintsCount?: number | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, pmsPlan?: PmsPlanBase | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, recruitPlan?: RecruitPlan | null | undefined, hasStripeCustomerId?: boolean | null | undefined, articles?: { __typename?: 'ArticleConnection', edges?: Array<{ __typename?: 'ArticleEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, companyMembers?: Array<{ __typename?: 'MyCompanyMember', id?: string | null | undefined, role: CompanyMemberRole, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, receivedInvestments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', bio?: string | null | undefined, avatar?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, twitterUrl?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, pitches?: Array<{ __typename?: 'MyPitch', id: string, permission: PitchPermission, roundName: string, slug: string, status: PitchStatus, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, instrument?: PitchInstrumentBase | null | undefined, roundSize?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, valuationCap?: string | null | undefined, valuationCapType?: PitchValuationCapBase | null | undefined, targetClosingDate?: string | null | undefined, description?: string | null | undefined, pitchAttachments?: Array<{ __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined }> | null | undefined, pitchReaders?: Array<{ __typename?: 'PitchReader', createdAt?: string | null | undefined, id: string, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined }> | null | undefined, createdBy?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, products?: Array<{ __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, experiences?: Array<{ __typename?: 'Experience', current: boolean, description?: string | null | undefined, endedAt?: string | null | undefined, id: string, startedAt?: string | null | undefined, status: string, title?: string | null | undefined, addedByUser: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, company: { __typename?: 'Company', id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined } }> | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, birthday?: any | null | undefined, birthdayAccessScope?: UserProfileBirthdayAccessScopeBase | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, delayOfEmailNotificationsForFollower?: UserProfileDelayOfEmailNotificationsForFollower | null | undefined, delayOfEmailNotificationsForMessages?: UserProfileDelayOfEmailNotificationsForMessages | null | undefined, denyNewContact?: boolean | null | undefined, desiredCareerPath?: UserProfileDesiredCareerPathBase | null | undefined, desiredCommunicationStyle?: UserProfileDesiredCommunicationStyleBase | null | undefined, desiredDecisionCulture?: UserProfileDesiredDecisionCultureBase | null | undefined, desiredEvaluationCulture?: UserProfileDesiredEvaluationCultureBase | null | undefined, desiredManagementCulture?: UserProfileDesiredManagementCultureBase | null | undefined, desiredThingsInNextJob?: string | null | undefined, desiredOrientationCulture?: UserProfileDesiredOrientationCultureBase | null | undefined, desiredProgressionStyle?: UserProfileDesiredProgressionStyleBase | null | undefined, desiredRoleOnTeam?: UserProfileDesiredRoleOnTeamBase | null | undefined, desiredTakingOnWorkStyle?: UserProfileDesiredTakingOnWorkStyleBase | null | undefined, desiredTrainingCulture?: UserProfileDesiredTrainingCultureBase | null | undefined, desiredWorkStyle?: UserProfileDesiredWorkStyleBase | null | undefined, desiredWorkplaceCulture?: UserProfileDesiredWorkplaceCultureBase | null | undefined, facebookUrl?: string | null | undefined, githubUrl?: string | null | undefined, headerImage?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isCofounderDesired?: boolean | null | undefined, isContractorDesired?: boolean | null | undefined, isFulltimeEmployeeDesired?: boolean | null | undefined, isInternDesired?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isJobSeeker: boolean, isJobSeekerMailMagazineAccepted?: boolean | null | undefined, isOptingInToAnnouncement?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, receiveEmailNotificationsForFollower?: boolean | null | undefined, receiveEmailNotificationsForMessages?: boolean | null | undefined, twitterUrl?: string | null | undefined, websiteUrl?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, jobCategories?: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> | null | undefined } | null | undefined, notifications?: { __typename?: 'NotificationConnection', edges?: Array<{ __typename?: 'NotificationEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Notification', id: string, category: NotificationCategory, isRead: boolean, createdAt: string, updatedAt: string, jobSeekingStatusUpdatedNotification?: { __typename?: 'JobSeekingStatusUpdatedNotification', id: string, user: { __typename?: 'User', name: string, username: string } } | null | undefined, newJobOpeningNotification?: { __typename?: 'NewJobOpeningNotification', id: string, company: { __typename?: 'Company', name?: string | null | undefined, slug: string } } | null | undefined, newMessageNotification?: { __typename?: 'NewMessageNotification', id: string, message: { __typename?: 'Message', id: string, body: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageThread?: { __typename?: 'MessageThread', slug: string, messageThreadType: MessageThreadType } | null | undefined } } | null | undefined, newRecruitingMessageNotification?: { __typename?: 'NewRecruitingMessageNotification', id: string, company: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, slug: string }, message: { __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageThread?: { __typename?: 'MessageThread', slug: string, messageThreadType: MessageThreadType } | null | undefined } } | null | undefined, newUserFollowerNotification?: { __typename?: 'NewUserFollowerNotification', id: string, user: { __typename?: 'User', name: string, username: string } } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, investorMembers?: Array<{ __typename?: 'InvestorMember', role?: InvestorMemberRole | null | undefined, investor?: { __typename?: 'Investor', id?: string | null | undefined, investorSlug?: string | null | undefined, investorType?: VehicleInvestor | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, vehicleMembers?: Array<{ __typename?: 'VehicleMember', role?: VehicleMemberRole | null | undefined, vehicle?: { __typename?: 'Vehicle', id?: string | null | undefined, slug?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } | null | undefined };

export type FetchMyArticlesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchMyArticlesQuery = { __typename?: 'Query', myArticles: { __typename?: 'ArticleConnection', nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchMyCompanyQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchMyCompanyQuery = { __typename?: 'Query', myCompany?: { __typename?: 'MyCompany', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, jobApplicationsCount?: number | null | undefined, jobBookmarksCount?: number | null | undefined, jobFootprintsCount?: number | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, pmsPlan?: PmsPlanBase | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, recruitPlan?: RecruitPlan | null | undefined, hasStripeCustomerId?: boolean | null | undefined, articles?: { __typename?: 'ArticleConnection', edges?: Array<{ __typename?: 'ArticleEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, companyMembers?: Array<{ __typename?: 'MyCompanyMember', id?: string | null | undefined, role: CompanyMemberRole, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, receivedInvestments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', bio?: string | null | undefined, avatar?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, twitterUrl?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, pitches?: Array<{ __typename?: 'MyPitch', id: string, permission: PitchPermission, roundName: string, slug: string, status: PitchStatus, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, instrument?: PitchInstrumentBase | null | undefined, roundSize?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, valuationCap?: string | null | undefined, valuationCapType?: PitchValuationCapBase | null | undefined, targetClosingDate?: string | null | undefined, description?: string | null | undefined, pitchAttachments?: Array<{ __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined }> | null | undefined, pitchReaders?: Array<{ __typename?: 'PitchReader', createdAt?: string | null | undefined, id: string, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined }> | null | undefined, createdBy?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, products?: Array<{ __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined };

export type FetchMyCompanyArticlesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchMyCompanyArticlesQuery = { __typename?: 'Query', myCompany?: { __typename?: 'MyCompany', articles?: { __typename?: 'ArticleConnection', edges?: Array<{ __typename?: 'ArticleEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type FetchMyCompanyReferencesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchMyCompanyReferencesQuery = { __typename?: 'Query', myCompanyReferences: { __typename?: 'CompanyReferenceConnection', nodes?: Array<{ __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchMyInvestorMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMyInvestorMembersQuery = { __typename?: 'Query', me?: { __typename?: 'Me', id?: string | null | undefined, email: string, name: string, username: string, investorMembers?: Array<{ __typename?: 'InvestorMember', role?: InvestorMemberRole | null | undefined, investor?: { __typename?: 'Investor', id?: string | null | undefined, investorSlug?: string | null | undefined, investorType?: VehicleInvestor | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, vehicleMembers?: Array<{ __typename?: 'VehicleMember', role?: VehicleMemberRole | null | undefined, vehicle?: { __typename?: 'Vehicle', id?: string | null | undefined, slug?: string | null | undefined, name?: string | null | undefined } | null | undefined }> | null | undefined }> | null | undefined } | null | undefined };

export type FetchMyJobBookmarksQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchMyJobBookmarksQuery = { __typename?: 'Query', myJobBookmarks: { __typename?: 'JobBookmarkConnection', nodes?: Array<{ __typename?: 'JobBookmark', id?: string | null | undefined, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchMyJobsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  companySlug: Scalars['ID'];
}>;


export type FetchMyJobsQuery = { __typename?: 'Query', myJobs: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchMyPitchesQueryVariables = Exact<{
  companySlug: Scalars['ID'];
}>;


export type FetchMyPitchesQuery = { __typename?: 'Query', myPitches: Array<{ __typename?: 'MyPitch', id: string, permission: PitchPermission, roundName: string, slug: string, status: PitchStatus, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, instrument?: PitchInstrumentBase | null | undefined, roundSize?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, valuationCap?: string | null | undefined, valuationCapType?: PitchValuationCapBase | null | undefined, targetClosingDate?: string | null | undefined, description?: string | null | undefined, pitchAttachments?: Array<{ __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined }> | null | undefined, pitchReaders?: Array<{ __typename?: 'PitchReader', createdAt?: string | null | undefined, id: string, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined }> | null | undefined, createdBy?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> };

export type FetchMyReferencesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchMyReferencesQuery = { __typename?: 'Query', myReferences: { __typename?: 'UserReferenceConnection', nodes?: Array<{ __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchNotificationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchNotificationsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', email: string, name: string, username: string, notifications?: { __typename?: 'NotificationConnection', nodes?: Array<{ __typename?: 'Notification', id: string, category: NotificationCategory, isRead: boolean, createdAt: string, updatedAt: string, jobSeekingStatusUpdatedNotification?: { __typename?: 'JobSeekingStatusUpdatedNotification', id: string, user: { __typename?: 'User', name: string, username: string } } | null | undefined, newJobOpeningNotification?: { __typename?: 'NewJobOpeningNotification', id: string, company: { __typename?: 'Company', name?: string | null | undefined, slug: string } } | null | undefined, newMessageNotification?: { __typename?: 'NewMessageNotification', id: string, message: { __typename?: 'Message', id: string, body: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageThread?: { __typename?: 'MessageThread', slug: string, messageThreadType: MessageThreadType } | null | undefined } } | null | undefined, newRecruitingMessageNotification?: { __typename?: 'NewRecruitingMessageNotification', id: string, company: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, slug: string }, message: { __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageThread?: { __typename?: 'MessageThread', slug: string, messageThreadType: MessageThreadType } | null | undefined } } | null | undefined, newUserFollowerNotification?: { __typename?: 'NewUserFollowerNotification', id: string, user: { __typename?: 'User', name: string, username: string } } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type FetchPaginatedMessageThreadsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  messagesAfter?: InputMaybe<Scalars['String']>;
  messagesBefore?: InputMaybe<Scalars['String']>;
  messagesFirst?: InputMaybe<Scalars['Int']>;
  messagesLast?: InputMaybe<Scalars['Int']>;
}>;


export type FetchPaginatedMessageThreadsQuery = { __typename?: 'Query', paginatedMessageThreads: { __typename?: 'MessageThreadConnection', nodes?: Array<{ __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, messages?: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, readers?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageAttachments?: Array<{ __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, jobApplication?: { __typename?: 'JobApplication', id: string, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageThread: { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined } } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchPickedUpFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPickedUpFeaturesQuery = { __typename?: 'Query', pickedUpFeatures: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, ogImage?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, opinionsUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined }> };

export type FetchPitchQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type FetchPitchQuery = { __typename?: 'Query', pitch: { __typename?: 'Pitch', id: string, permission: PitchPermission, roundName: string, slug: string, status: PitchStatus, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, instrument?: PitchInstrumentBase | null | undefined, roundSize?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, valuationCap?: string | null | undefined, valuationCapType?: PitchValuationCapBase | null | undefined, targetClosingDate?: string | null | undefined, description?: string | null | undefined, pitchAttachments?: Array<{ __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined }> | null | undefined } };

export type FetchPitchesQueryVariables = Exact<{
  companySlug: Scalars['ID'];
}>;


export type FetchPitchesQuery = { __typename?: 'Query', pitches: Array<{ __typename?: 'Pitch', id: string, permission: PitchPermission, roundName: string, slug: string, status: PitchStatus, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, instrument?: PitchInstrumentBase | null | undefined, roundSize?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, valuationCap?: string | null | undefined, valuationCapType?: PitchValuationCapBase | null | undefined, targetClosingDate?: string | null | undefined, description?: string | null | undefined, pitchAttachments?: Array<{ __typename?: 'PitchAttachment', categoryName: PitchAttachmentCategoryName, file?: string | null | undefined, filename?: string | null | undefined, id: string, url?: string | null | undefined }> | null | undefined }> };

export type FetchSkillsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type FetchSkillsQuery = { __typename?: 'Query', skills: { __typename?: 'SkillConnection', nodes?: Array<{ __typename?: 'Skill', id: string, name: string, slug: string } | null | undefined> | null | undefined } };

export type FetchSubsidiesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationsId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  subsidyPurposeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type FetchSubsidiesQuery = { __typename?: 'Query', subsidies: { __typename?: 'SubsidyConnection', nodes?: Array<{ __typename?: 'Subsidy', agencyName?: string | null | undefined, applicationEndAt?: string | null | undefined, applicationStartAt?: string | null | undefined, body?: string | null | undefined, category?: SubsidyCategoryBase | null | undefined, createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, maximumAmount?: string | null | undefined, maximumAmountSuffix?: string | null | undefined, sourceUrl?: string | null | undefined, status?: SubsidyStatusBase | null | undefined, subsidyObjectInString?: string | null | undefined, subsidyPurposesInString?: string | null | undefined, subsidyRate?: string | null | undefined, subsidyRateNote?: string | null | undefined, summary?: string | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, subsidyObjects?: Array<{ __typename?: 'SubsidyObject', createdAt: string, id?: string | null | undefined, name?: string | null | undefined, updatedAt: string }> | null | undefined, subsidyPurposes?: Array<{ __typename?: 'SubsidyPurpose', createdAt: string, id?: string | null | undefined, name?: string | null | undefined, updatedAt: string }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchSubsidyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchSubsidyQuery = { __typename?: 'Query', subsidy?: { __typename?: 'Subsidy', agencyName?: string | null | undefined, applicationEndAt?: string | null | undefined, applicationStartAt?: string | null | undefined, body?: string | null | undefined, category?: SubsidyCategoryBase | null | undefined, createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, maximumAmount?: string | null | undefined, maximumAmountSuffix?: string | null | undefined, sourceUrl?: string | null | undefined, status?: SubsidyStatusBase | null | undefined, subsidyObjectInString?: string | null | undefined, subsidyPurposesInString?: string | null | undefined, subsidyRate?: string | null | undefined, subsidyRateNote?: string | null | undefined, summary?: string | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, subsidyObjects?: Array<{ __typename?: 'SubsidyObject', createdAt: string, id?: string | null | undefined, name?: string | null | undefined, updatedAt: string }> | null | undefined, subsidyPurposes?: Array<{ __typename?: 'SubsidyPurpose', createdAt: string, id?: string | null | undefined, name?: string | null | undefined, updatedAt: string }> | null | undefined } | null | undefined };

export type FetchSubsidyPurposeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchSubsidyPurposeQuery = { __typename?: 'Query', subsidyPurpose: { __typename?: 'SubsidyPurpose', createdAt: string, id?: string | null | undefined, name?: string | null | undefined, updatedAt: string } };

export type FetchSubsidyPurposesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchSubsidyPurposesQuery = { __typename?: 'Query', subsidyPurposes: Array<{ __typename?: 'SubsidyPurpose', createdAt: string, id?: string | null | undefined, name?: string | null | undefined, updatedAt: string }> };

export type FetchUserQueryVariables = Exact<{
  afterReferences?: InputMaybe<Scalars['String']>;
  beforeReferences?: InputMaybe<Scalars['String']>;
  firstReferences?: InputMaybe<Scalars['Int']>;
  lastReferences?: InputMaybe<Scalars['Int']>;
  username: Scalars['ID'];
}>;


export type FetchUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', followersCount?: number | null | undefined, followingCount?: number | null | undefined, isFollower?: boolean | null | undefined, isFollowing?: boolean | null | undefined, name: string, username: string, status?: UserStatus | null | undefined, experiences?: Array<{ __typename?: 'Experience', current: boolean, description?: string | null | undefined, endedAt?: string | null | undefined, id: string, startedAt?: string | null | undefined, status: string, title?: string | null | undefined, addedByUser: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, company: { __typename?: 'Company', id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined } }> | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, notificationSettings?: Array<{ __typename?: 'UserNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, birthday?: any | null | undefined, birthdayAccessScope?: UserProfileBirthdayAccessScopeBase | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, desiredCareerPath?: UserProfileDesiredCareerPathBase | null | undefined, desiredCommunicationStyle?: UserProfileDesiredCommunicationStyleBase | null | undefined, desiredDecisionCulture?: UserProfileDesiredDecisionCultureBase | null | undefined, desiredEvaluationCulture?: UserProfileDesiredEvaluationCultureBase | null | undefined, desiredManagementCulture?: UserProfileDesiredManagementCultureBase | null | undefined, desiredThingsInNextJob?: string | null | undefined, desiredOrientationCulture?: UserProfileDesiredOrientationCultureBase | null | undefined, desiredProgressionStyle?: UserProfileDesiredProgressionStyleBase | null | undefined, desiredRoleOnTeam?: UserProfileDesiredRoleOnTeamBase | null | undefined, desiredTakingOnWorkStyle?: UserProfileDesiredTakingOnWorkStyleBase | null | undefined, desiredTrainingCulture?: UserProfileDesiredTrainingCultureBase | null | undefined, desiredWorkStyle?: UserProfileDesiredWorkStyleBase | null | undefined, desiredWorkplaceCulture?: UserProfileDesiredWorkplaceCultureBase | null | undefined, facebookUrl?: string | null | undefined, githubUrl?: string | null | undefined, headerImage?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isCofounderDesired?: boolean | null | undefined, isContractorDesired?: boolean | null | undefined, isFulltimeEmployeeDesired?: boolean | null | undefined, isInternDesired?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isJobSeeker: boolean, isJobSeekerMailMagazineAccepted?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, twitterUrl?: string | null | undefined, websiteUrl?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, jobCategories?: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> | null | undefined } | null | undefined, userReferences?: { __typename?: 'UserReferenceConnection', nodes?: Array<{ __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type FetchUserArticlesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['ID']>;
}>;


export type FetchUserArticlesQuery = { __typename?: 'Query', userArticles: { __typename?: 'ArticleConnection', nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchUserForViewerQueryVariables = Exact<{
  username: Scalars['ID'];
}>;


export type FetchUserForViewerQuery = { __typename?: 'Query', user?: { __typename?: 'User', isFollower?: boolean | null | undefined, isFollowing?: boolean | null | undefined, name: string, username: string, notificationSettings?: Array<{ __typename?: 'UserNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined } | null | undefined };

export type FetchVehicleQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchVehicleQuery = { __typename?: 'Query', vehicle?: { __typename?: 'Vehicle', id?: string | null | undefined, name?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, investor?: { __typename?: 'Investor', id?: string | null | undefined, investorSlug?: string | null | undefined, investorType?: VehicleInvestor | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, acquisitionChannels?: Array<{ __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined }> | null | undefined } | null | undefined, vehicleMembers?: Array<{ __typename?: 'VehicleMember', id?: string | null | undefined, role?: VehicleMemberRole | null | undefined, investorMember?: { __typename?: 'InvestorMember', id?: string | null | undefined, role?: InvestorMemberRole | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, vehicle?: { __typename?: 'Vehicle', id?: string | null | undefined, name?: string | null | undefined } | null | undefined }> | null | undefined, vehicleStatuses?: Array<{ __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined, vehicleItems?: { __typename?: 'VehicleItemConnection', nodes?: Array<{ __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, isVc?: boolean | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined }> | null | undefined } | null | undefined };

export type FetchVehicleAnalyticsQueryVariables = Exact<{
  vehicleSlug: Scalars['ID'];
}>;


export type FetchVehicleAnalyticsQuery = { __typename?: 'Query', vehicleAnalytics: Array<{ __typename?: 'Dashboard', name?: string | null | undefined, dashboardItems?: Array<{ __typename?: 'DashboardItem', category?: DashboardCategory | null | undefined, name?: string | null | undefined, numberDashboardItem?: { __typename?: 'NumberDashboardItem', value?: string | null | undefined } | null | undefined, pieDashboardItems?: Array<{ __typename?: 'PieDashboardItem', name?: string | null | undefined, value?: string | null | undefined }> | null | undefined }> | null | undefined }> };

export type FetchVehicleItemQueryVariables = Exact<{
  afterPortfolioNotes?: InputMaybe<Scalars['String']>;
  beforePortfolioNotes?: InputMaybe<Scalars['String']>;
  firstPortfolioNotes?: InputMaybe<Scalars['Int']>;
  lastPortfolioNotes?: InputMaybe<Scalars['Int']>;
  afterPortfolioMeetings?: InputMaybe<Scalars['String']>;
  beforePortfolioMeetings?: InputMaybe<Scalars['String']>;
  firstPortfolioMeetings?: InputMaybe<Scalars['Int']>;
  lastPortfolioMeetings?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
}>;


export type FetchVehicleItemQuery = { __typename?: 'Query', vehicleItem?: { __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', name?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, slug: string, url?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, portfolioAttachments?: Array<{ __typename?: 'PortfolioAttachment', createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, portfolioNotes?: { __typename?: 'PortfolioNoteConnection', nodes?: Array<{ __typename?: 'PortfolioNote', createdAt?: string | null | undefined, id?: string | null | undefined, note?: string | null | undefined, updatedAt?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, portfolioMeetings?: { __typename?: 'PortfolioMeetingConnection', nodes?: Array<{ __typename?: 'PortfolioMeeting', createdAt?: string | null | undefined, description?: string | null | undefined, id?: string | null | undefined, startAt?: string | null | undefined, status?: PortfolioMeetingStatusBase | null | undefined, updatedAt?: string | null | undefined, participants?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, itemsCount?: number | null | undefined, name?: string | null | undefined, weighting?: string | null | undefined } | null | undefined } | null | undefined };

export type FetchVehicleItemsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  vehicleSlug: Scalars['ID'];
  vehicleStatusIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type FetchVehicleItemsQuery = { __typename?: 'Query', vehicleItems: { __typename?: 'VehicleItemConnection', nodes?: Array<{ __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, isVc?: boolean | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchVehicleItemsForAllStatusesQueryVariables = Exact<{
  after1?: InputMaybe<Scalars['String']>;
  before1?: InputMaybe<Scalars['String']>;
  first1?: InputMaybe<Scalars['Int']>;
  last1?: InputMaybe<Scalars['Int']>;
  query1?: InputMaybe<Scalars['String']>;
  vehicleSlug: Scalars['ID'];
  vehicleStatusIds1?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  after2?: InputMaybe<Scalars['String']>;
  before2?: InputMaybe<Scalars['String']>;
  first2?: InputMaybe<Scalars['Int']>;
  last2?: InputMaybe<Scalars['Int']>;
  query2?: InputMaybe<Scalars['String']>;
  vehicleStatusIds2?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  after3?: InputMaybe<Scalars['String']>;
  before3?: InputMaybe<Scalars['String']>;
  first3?: InputMaybe<Scalars['Int']>;
  last3?: InputMaybe<Scalars['Int']>;
  query3?: InputMaybe<Scalars['String']>;
  vehicleStatusIds3?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  after4?: InputMaybe<Scalars['String']>;
  before4?: InputMaybe<Scalars['String']>;
  first4?: InputMaybe<Scalars['Int']>;
  last4?: InputMaybe<Scalars['Int']>;
  query4?: InputMaybe<Scalars['String']>;
  vehicleStatusIds4?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type FetchVehicleItemsForAllStatusesQuery = { __typename?: 'Query', vehicleItems1: { __typename?: 'VehicleItemConnection', nodes?: Array<{ __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, isVc?: boolean | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } }, vehicleItems2: { __typename?: 'VehicleItemConnection', nodes?: Array<{ __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, isVc?: boolean | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } }, vehicleItems3: { __typename?: 'VehicleItemConnection', nodes?: Array<{ __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, isVc?: boolean | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } }, vehicleItems4: { __typename?: 'VehicleItemConnection', nodes?: Array<{ __typename?: 'VehicleItem', createdAt?: string | null | undefined, id?: string | null | undefined, nextMeetingDate?: string | null | undefined, weighting?: string | null | undefined, captainUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, portfolio?: { __typename?: 'Portfolio', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, isVc?: boolean | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, acquisitionChannel?: { __typename?: 'AcquisitionChannel', id?: string | null | undefined, name?: string | null | undefined } | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, vehicleItemRounds?: Array<{ __typename?: 'VehicleItemRound', currentValuation?: string | null | undefined, description?: string | null | undefined, discount?: number | null | undefined, id?: string | null | undefined, instrument?: VehicleItemRoundInstrument | null | undefined, investedAt?: string | null | undefined, investmentAmount?: string | null | undefined, postValuation?: string | null | undefined, preValuation?: string | null | undefined, ratioAtInvestment?: number | null | undefined, valuationCap?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, vehicleItemRoundAttachments?: Array<{ __typename?: 'VehicleItemRoundAttachment', category?: VehicleItemRoundAttachmentCategory | null | undefined, createdAt?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined }> | null | undefined, vehicleStatus?: { __typename?: 'VehicleStatus', category?: VehicleStatusCategory | null | undefined, id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type SearchCompanyQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
}>;


export type SearchCompanyQuery = { __typename?: 'Query', searchCompany: { __typename?: 'CompanyConnection', nodes?: Array<{ __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined } | null | undefined> | null | undefined } };

export type SearchUserQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchUserQuery = { __typename?: 'Query', searchUser: { __typename?: 'UserConnection', edges?: Array<{ __typename?: 'UserEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, twitterUrl?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, isJobSeeker: boolean, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type ValidInvitationTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type ValidInvitationTokenQuery = { __typename?: 'Query', validInvitationToken: { __typename?: 'Invitation', invitationOf: InvitationOfBase, isValid: boolean } };

export const LocationFieldsFragmentDocBase = gql`
    fragment locationFields on Location {
  id
  locationType
  name
  shortDescription
  slug
}
    `;
export const MarketFieldsFragmentDocBase = gql`
    fragment marketFields on Market {
  id
  name
  slug
}
    `;
export const RoundFieldsFragmentDocBase = gql`
    fragment roundFields on Round {
  id
  name
  slug
}
    `;
export const MinCompanyFieldFragmentDocBase = gql`
    fragment minCompanyField on Company {
  aboutUs
  companySize
  conceptPitch
  currencyUnit
  denyNewContact
  excludeFromSearch
  facebookUrl
  id
  instagramUrl
  isVc
  linkedinUrl
  locations {
    ...locationFields
  }
  logo
  markets {
    ...marketFields
  }
  maxInvestmentAmount
  minInvestmentAmount
  name
  round {
    ...roundFields
  }
  slug
  status
  totalFundingAmount
  twitterUrl
  url
  youtubeUrl
}
    ${LocationFieldsFragmentDocBase}
${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}`;
export const JobCategoryFieldsFragmentDocBase = gql`
    fragment jobCategoryFields on JobCategory {
  id
  jobCategoryType
  name
  slug
}
    `;
export const JobTagFieldsFragmentDocBase = gql`
    fragment jobTagFields on JobTag {
  id
  name
  slug
}
    `;
export const MinUserFieldsFragmentDocBase = gql`
    fragment minUserFields on User {
  id
  name
  profile {
    allowMessageRequestsFrom
    avatar
    bio
    isVerifiedAccount
    jobTitle
    isJobSeeker
    jobHuntingStatus
    denyNewContact
  }
  status
  username
}
    `;
export const SkillFieldsFragmentDocBase = gql`
    fragment skillFields on Skill {
  id
  name
  slug
}
    `;
export const JobFieldsFragmentDocBase = gql`
    fragment jobFields on Job {
  address
  body
  company {
    ...minCompanyField
  }
  createdAt
  currencyUnit
  equityGrant
  id
  jobCategories {
    ...jobCategoryFields
  }
  jobTags {
    ...jobTagFields
  }
  locations {
    ...locationFields
  }
  maxMonthlySalary
  minMonthlySalary
  primaryJobCategory {
    ...jobCategoryFields
  }
  primaryRecruitingContact {
    ...minUserFields
  }
  skills {
    ...skillFields
  }
  slug
  status
  thumbnail
  title
  tokenGrant
  typeOfPosition
  updatedAt
  workExperience
  workingForm
}
    ${MinCompanyFieldFragmentDocBase}
${JobCategoryFieldsFragmentDocBase}
${JobTagFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}
${SkillFieldsFragmentDocBase}`;
export const CompanyWithJobsFragmentDocBase = gql`
    fragment companyWithJobs on Company {
  jobs(after: $afterJobs, before: $beforeJobs, first: $firstJobs, last: $lastJobs) {
    nodes {
      ...jobFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}`;
export const HighlightedJobListingsFragmentDocBase = gql`
    fragment highlightedJobListings on Company {
  highlightedJobListings(
    after: $afterJobs
    before: $beforeJobs
    first: $firstJobs
    last: $lastJobs
  ) {
    nodes {
      ...jobFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}`;
export const CompanyReferenceFieldsFragmentDocBase = gql`
    fragment companyReferenceFields on CompanyReference {
  comment
  commenter {
    ...minUserFields
  }
  id
  status
}
    ${MinUserFieldsFragmentDocBase}`;
export const RecievedInvestmentFieldsFragmentDocBase = gql`
    fragment recievedInvestmentFields on Investment {
  angel {
    id
    name
    profile {
      bio
      avatar
      isVerifiedAccount
      twitterUrl
      isJobSeeker
    }
    username
  }
  company {
    aboutUs
    companySize
    conceptPitch
    id
    isVc
    logo
    name
    slug
    status
    totalFundingAmount
    url
  }
  companyInvestedFrom {
    aboutUs
    id
    logo
    name
    slug
    status
    investments {
      id
      company {
        aboutUs
        companySize
        conceptPitch
        id
        isVc
        logo
        name
        slug
        status
        totalFundingAmount
        url
      }
      investedAt
      isLeadInvestor
      referenceUrl
      round {
        id
        slug
        name
      }
      investorComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
    }
  }
  id
  investedAt
  isLeadInvestor
  referenceUrl
  startupComment {
    comment
    commenter {
      id
      name
      status
      username
    }
    commenterType
  }
  investorComment {
    comment
    commenter {
      id
      name
      status
      username
    }
    commenterType
  }
}
    `;
export const MinMessageThreadFieldsFragmentDocBase = gql`
    fragment minMessageThreadFields on MessageThread {
  id
  messageThreadType
  name
  slug
  users {
    ...minUserFields
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const MinJobApplicationFieldsFragmentDocBase = gql`
    fragment minJobApplicationFields on JobApplication {
  id
  job {
    ...jobFields
  }
  user {
    ...minUserFields
  }
  messageThread {
    ...minMessageThreadFields
  }
}
    ${JobFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}
${MinMessageThreadFieldsFragmentDocBase}`;
export const MessageAttachmentFieldsFragmentDocBase = gql`
    fragment messageAttachmentFields on MessageAttachment {
  file
  id
  filename
  mimeType
}
    `;
export const MessageFieldsFragmentDocBase = gql`
    fragment messageFields on Message {
  body
  createdAt
  id
  updatedAt
  readers {
    ...minUserFields
  }
  user {
    ...minUserFields
  }
  messageAttachments {
    ...messageAttachmentFields
  }
}
    ${MinUserFieldsFragmentDocBase}
${MessageAttachmentFieldsFragmentDocBase}`;
export const NotificationFieldsFragmentDocBase = gql`
    fragment notificationFields on Notification {
  id
  category
  isRead
  jobSeekingStatusUpdatedNotification {
    id
    user {
      name
      username
    }
  }
  newJobOpeningNotification {
    company {
      name
      slug
    }
    id
  }
  newMessageNotification {
    id
    message {
      id
      body
      createdAt
      updatedAt
      user {
        id
        name
        username
        profile {
          avatar
          isJobSeeker
        }
      }
      messageThread {
        slug
        messageThreadType
      }
    }
  }
  newRecruitingMessageNotification {
    company {
      id
      logo
      slug
    }
    id
    message {
      body
      createdAt
      id
      updatedAt
      user {
        id
        name
        username
        profile {
          avatar
          isJobSeeker
        }
      }
      messageThread {
        slug
        messageThreadType
      }
    }
  }
  newUserFollowerNotification {
    id
    user {
      name
      username
    }
  }
  createdAt
  updatedAt
}
    `;
export const MinMyPitchFieldsFragmentDocBase = gql`
    fragment minMyPitchFields on MyPitch {
  id
  permission
  pitchAttachments {
    categoryName
    file
    filename
    id
    url
  }
  roundName
  slug
  status
  createdAt
  updatedAt
  instrument
  roundSize
  currencyUnit
  valuationCap
  valuationCapType
  targetClosingDate
  description
  createdBy {
    ...minUserFields
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const PitchReadersFieldsFragmentDocBase = gql`
    fragment pitchReadersFields on PitchReader {
  createdAt
  id
  user {
    id
    name
    profile {
      avatar
      bio
      isAngel
      isInvestor
      isVerifiedAccount
      jobTitle
      isJobSeeker
    }
    status
    username
  }
}
    `;
export const MyPitchFieldsFragmentDocBase = gql`
    fragment myPitchFields on MyPitch {
  id
  permission
  pitchAttachments {
    categoryName
    file
    filename
    id
    url
  }
  roundName
  slug
  status
  createdAt
  updatedAt
  instrument
  roundSize
  currencyUnit
  valuationCap
  valuationCapType
  targetClosingDate
  description
  pitchReaders {
    ...pitchReadersFields
  }
  createdBy {
    ...minUserFields
  }
}
    ${PitchReadersFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const PitchFieldsFragmentDocBase = gql`
    fragment pitchFields on Pitch {
  id
  permission
  pitchAttachments {
    categoryName
    file
    filename
    id
    url
  }
  roundName
  slug
  status
  createdAt
  updatedAt
  instrument
  roundSize
  currencyUnit
  valuationCap
  valuationCapType
  targetClosingDate
  description
}
    `;
export const InvestorFieldsFragmentDocBase = gql`
    fragment investorFields on Investor {
  company {
    ...minCompanyField
  }
  id
  investorSlug
  investorType
  user {
    ...minUserFields
  }
  acquisitionChannels {
    id
    name
  }
}
    ${MinCompanyFieldFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const MinVehicleFieldsFragmentDocBase = gql`
    fragment minVehicleFields on Vehicle {
  id
  investor {
    ...investorFields
  }
  name
  currencyUnit
  slug
  vehicleStatuses {
    category
    id
    itemsCount
    name
    weighting
  }
}
    ${InvestorFieldsFragmentDocBase}`;
export const VehicleMemberFieldsFragmentDocBase = gql`
    fragment vehicleMemberFields on VehicleMember {
  id
  investorMember {
    id
    role
    user {
      ...minUserFields
    }
  }
  role
  vehicle {
    id
    name
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const MinVehicleItemPortfolioFieldsFragmentDocBase = gql`
    fragment minVehicleItemPortfolioFields on Portfolio {
  aboutUs
  acquisitionChannel {
    id
    name
  }
  company {
    name
    aboutUs
    companySize
    id
    isVc
    locations {
      id
      locationType
      name
      shortDescription
      slug
    }
    markets {
      id
      name
      slug
    }
    round {
      id
      name
      slug
    }
    slug
    url
  }
  companySize
  id
  locations {
    id
    locationType
    name
    shortDescription
    slug
  }
  markets {
    id
    name
    slug
  }
  round {
    id
    name
    slug
  }
}
    `;
export const VehicleItemRoundAttachmentFieldsFragmentDocBase = gql`
    fragment vehicleItemRoundAttachmentFields on VehicleItemRoundAttachment {
  category
  createdAt
  file
  filename
  id
  user {
    ...minUserFields
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const VehicleItemRoundFieldsFragmentDocBase = gql`
    fragment vehicleItemRoundFields on VehicleItemRound {
  currentValuation
  description
  discount
  id
  instrument
  investedAt
  investmentAmount
  postValuation
  preValuation
  ratioAtInvestment
  round {
    ...roundFields
  }
  valuationCap
  vehicleItemRoundAttachments {
    ...vehicleItemRoundAttachmentFields
  }
}
    ${RoundFieldsFragmentDocBase}
${VehicleItemRoundAttachmentFieldsFragmentDocBase}`;
export const MinVehicleItemFieldsFragmentDocBase = gql`
    fragment minVehicleItemFields on VehicleItem {
  captainUser {
    ...minUserFields
  }
  createdAt
  id
  nextMeetingDate
  portfolio {
    company {
      id
      logo
      name
      slug
      url
    }
    id
  }
  portfolio {
    ...minVehicleItemPortfolioFields
  }
  vehicleItemRounds {
    ...vehicleItemRoundFields
  }
  vehicleStatus {
    category
    id
    name
  }
  weighting
}
    ${MinUserFieldsFragmentDocBase}
${MinVehicleItemPortfolioFieldsFragmentDocBase}
${VehicleItemRoundFieldsFragmentDocBase}`;
export const VehicleStatusFieldsFragmentDocBase = gql`
    fragment vehicleStatusFields on VehicleStatus {
  category
  id
  itemsCount
  name
  vehicleItems(after: $after, before: $before, first: $first, last: $last) {
    nodes {
      ...minVehicleItemFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
  weighting
}
    ${MinVehicleItemFieldsFragmentDocBase}`;
export const VehicleFieldsFragmentDocBase = gql`
    fragment vehicleFields on Vehicle {
  id
  investor {
    ...investorFields
  }
  name
  currencyUnit
  vehicleMembers {
    ...vehicleMemberFields
  }
  vehicleStatuses {
    ...vehicleStatusFields
  }
}
    ${InvestorFieldsFragmentDocBase}
${VehicleMemberFieldsFragmentDocBase}
${VehicleStatusFieldsFragmentDocBase}`;
export const VehicleItemPortfolioAttachmentFieldsFragmentDocBase = gql`
    fragment vehicleItemPortfolioAttachmentFields on PortfolioAttachment {
  createdAt
  file
  filename
  id
  user {
    ...minUserFields
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const VehicleItemPortfolioNoteFieldsFragmentDocBase = gql`
    fragment vehicleItemPortfolioNoteFields on PortfolioNote {
  createdAt
  id
  note
  updatedAt
  user {
    ...minUserFields
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const PortfolioNotesFragmentDocBase = gql`
    fragment portfolioNotes on Portfolio {
  portfolioNotes(
    after: $afterPortfolioNotes
    before: $beforePortfolioNotes
    first: $firstPortfolioNotes
    last: $lastPortfolioNotes
  ) {
    nodes {
      ...vehicleItemPortfolioNoteFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${VehicleItemPortfolioNoteFieldsFragmentDocBase}`;
export const VehicleItemPortfolioMeetingFieldsFragmentDocBase = gql`
    fragment vehicleItemPortfolioMeetingFields on PortfolioMeeting {
  createdAt
  description
  id
  participants {
    ...minUserFields
  }
  startAt
  status
  updatedAt
  user {
    ...minUserFields
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const PortfolioMeetingsFragmentDocBase = gql`
    fragment portfolioMeetings on Portfolio {
  portfolioMeetings(
    after: $afterPortfolioMeetings
    before: $beforePortfolioMeetings
    first: $firstPortfolioMeetings
    last: $lastPortfolioMeetings
  ) {
    nodes {
      ...vehicleItemPortfolioMeetingFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${VehicleItemPortfolioMeetingFieldsFragmentDocBase}`;
export const VehicleItemPortfolioFieldsFragmentDocBase = gql`
    fragment vehicleItemPortfolioFields on Portfolio {
  aboutUs
  acquisitionChannel {
    id
    name
  }
  company {
    name
    aboutUs
    companySize
    id
    isVc
    locations {
      id
      locationType
      name
      shortDescription
      slug
    }
    logo
    markets {
      id
      name
      slug
    }
    round {
      id
      name
      slug
    }
    slug
    url
  }
  companySize
  id
  locations {
    id
    locationType
    name
    shortDescription
    slug
  }
  markets {
    id
    name
    slug
  }
  portfolioAttachments {
    ...vehicleItemPortfolioAttachmentFields
  }
  ...portfolioNotes
  ...portfolioMeetings
  round {
    id
    name
    slug
  }
}
    ${VehicleItemPortfolioAttachmentFieldsFragmentDocBase}
${PortfolioNotesFragmentDocBase}
${PortfolioMeetingsFragmentDocBase}`;
export const VehicleItemFieldsFragmentDocBase = gql`
    fragment vehicleItemFields on VehicleItem {
  captainUser {
    ...minUserFields
  }
  createdAt
  id
  nextMeetingDate
  portfolio {
    ...vehicleItemPortfolioFields
  }
  user {
    ...minUserFields
  }
  vehicleItemRounds {
    ...vehicleItemRoundFields
  }
  vehicleStatus {
    category
    id
    itemsCount
    name
    weighting
  }
  weighting
}
    ${MinUserFieldsFragmentDocBase}
${VehicleItemPortfolioFieldsFragmentDocBase}
${VehicleItemRoundFieldsFragmentDocBase}`;
export const ProductFieldsFragmentDocBase = gql`
    fragment productFields on Product {
  description
  id
  image
  name
  url
}
    `;
export const SubsidyFieldsFragmentDocBase = gql`
    fragment subsidyFields on Subsidy {
  agencyName
  applicationEndAt
  applicationStartAt
  body
  category
  createdAt
  description
  id
  locations {
    ...locationFields
  }
  maximumAmount
  maximumAmountSuffix
  sourceUrl
  status
  subsidyObjectInString
  subsidyObjects {
    createdAt
    id
    name
    updatedAt
  }
  subsidyPurposes {
    createdAt
    id
    name
    updatedAt
  }
  subsidyPurposesInString
  subsidyRate
  subsidyRateNote
  summary
  title
  updatedAt
}
    ${LocationFieldsFragmentDocBase}`;
export const UserReferenceFieldsFragmentDocBase = gql`
    fragment userReferenceFields on UserReference {
  comment
  commenter {
    ...minUserFields
  }
  id
  status
}
    ${MinUserFieldsFragmentDocBase}`;
export const AddAngelInvestmentInvitationDocument = gql`
    mutation addAngelInvestmentInvitation($input: AddAngelInvestmentInvitationInput!) {
  addAngelInvestmentInvitation(input: $input) {
    url
  }
}
    `;
export const AddAngelInvitationDocument = gql`
    mutation addAngelInvitation($input: AddAngelInvitationInput!) {
  addAngelInvitation(input: $input) {
    url
  }
}
    `;
export const AddCompanyInvestmentDocument = gql`
    mutation addCompanyInvestment($input: AddCompanyInvestmentInput!) {
  addCompanyInvestment(input: $input) {
    company {
      aboutUs
      companySize
      conceptPitch
      denyNewContact
      id
      isVc
      logo
      name
      round {
        id
        name
        slug
      }
      slug
      status
      totalFundingAmount
      url
    }
    id
    investedAt
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
    investorComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
  }
}
    `;
export const AddCompanyMemberDocument = gql`
    mutation addCompanyMember($input: AddCompanyMemberInput!) {
  addCompanyMember(input: $input) {
    id
    invitedByUser {
      id
      name
      profile {
        avatar
        bio
        jobTitle
        isJobSeeker
      }
      username
    }
    role
    user {
      id
      name
      profile {
        avatar
        bio
        jobTitle
        isJobSeeker
      }
      username
    }
  }
}
    `;
export const AddCompanyReferenceDocument = gql`
    mutation addCompanyReference($input: AddCompanyReferenceInput!) {
  addCompanyReference(input: $input) {
    ...companyReferenceFields
  }
}
    ${CompanyReferenceFieldsFragmentDocBase}`;
export const AddExperienceDocument = gql`
    mutation addExperience($input: AddExperienceInput!) {
  addExperience(input: $input) {
    addedByUser {
      name
      profile {
        avatar
        isAngel
        isInvestor
        jobTitle
        isJobSeeker
      }
      username
    }
    company {
      id
      isVc
      logo
      name
      slug
      status
      url
    }
    current
    description
    endedAt
    id
    startedAt
    status
    title
  }
}
    `;
export const AddFootprintToJobDocument = gql`
    mutation addFootprintToJob($input: AddFootprintToJobInput!) {
  addFootprintToJob(input: $input) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const AddInvestorDocument = gql`
    mutation addInvestor($input: AddInvestorInput!) {
  addInvestor(input: $input) {
    company {
      aboutUs
      companyMembers {
        id
        user {
          id
          name
          profile {
            jobTitle
            bio
            avatar
            isJobSeeker
          }
          username
        }
      }
      companySize
      conceptPitch
      denyNewContact
      facebookUrl
      id
      instagramUrl
      isVc
      linkedinUrl
      logo
      name
      slug
      totalFundingAmount
      twitterUrl
      url
    }
    angel {
      id
      name
      status
      username
      profile {
        avatar
        twitterUrl
        isJobSeeker
      }
    }
    companyInvestedFrom {
      name
      logo
      slug
      url
    }
    id
    investedAt
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
    startupComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
  }
}
    `;
export const AddMemberInvitationDocument = gql`
    mutation addMemberInvitation($input: AddMemberInvitationInput!) {
  addMemberInvitation(input: $input) {
    url
  }
}
    `;
export const AddMyInvestmentDocument = gql`
    mutation addMyInvestment($input: AddMyInvestmentInput!) {
  addMyInvestment(input: $input) {
    company {
      aboutUs
      companySize
      conceptPitch
      denyNewContact
      id
      isVc
      logo
      name
      round {
        id
        name
        slug
      }
      slug
      status
      totalFundingAmount
      twitterUrl
      url
    }
    id
    investedAt
    investorComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
  }
}
    `;
export const AddMyJobBookmarkDocument = gql`
    mutation addMyJobBookmark($input: AddMyJobBookmarkInput!) {
  addMyJobBookmark(input: $input) {
    id
    job {
      ...jobFields
    }
    user {
      ...minUserFields
    }
    createdAt
    updatedAt
  }
}
    ${JobFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const AddPitchAttachmentDocument = gql`
    mutation addPitchAttachment($input: AddPitchAttachmentInput!) {
  addPitchAttachment(input: $input) {
    categoryName
    file
    filename
    id
    url
  }
}
    `;
export const AddProductDocument = gql`
    mutation addProduct($input: AddProductInput!) {
  addProduct(input: $input) {
    description
    id
    image
    name
    url
  }
}
    `;
export const AddUserReferenceDocument = gql`
    mutation addUserReference($input: AddUserReferenceInput!) {
  addUserReference(input: $input) {
    ...userReferenceFields
  }
}
    ${UserReferenceFieldsFragmentDocBase}`;
export const AddVcInvestmentInvitationDocument = gql`
    mutation addVcInvestmentInvitation($input: AddVcInvestmentInvitationInput!) {
  addVcInvestmentInvitation(input: $input) {
    url
  }
}
    `;
export const AddVcInvitationDocument = gql`
    mutation addVcInvitation($input: AddVcInvitationInput!) {
  addVcInvitation(input: $input) {
    url
  }
}
    `;
export const AddVehicleItemPortfolioAttachmentDocument = gql`
    mutation addVehicleItemPortfolioAttachment($input: AddVehicleItemPortfolioAttachmentInput!) {
  addVehicleItemPortfolioAttachment(input: $input) {
    ...vehicleItemPortfolioAttachmentFields
  }
}
    ${VehicleItemPortfolioAttachmentFieldsFragmentDocBase}`;
export const AddVehicleItemRoundAttachmentDocument = gql`
    mutation addVehicleItemRoundAttachment($input: AddVehicleItemRoundAttachmentInput!) {
  addVehicleItemRoundAttachment(input: $input) {
    ...vehicleItemRoundAttachmentFields
  }
}
    ${VehicleItemRoundAttachmentFieldsFragmentDocBase}`;
export const AddVehicleMemberDocument = gql`
    mutation addVehicleMember($input: AddVehicleMemberInput!) {
  addVehicleMember(input: $input) {
    ...vehicleMemberFields
  }
}
    ${VehicleMemberFieldsFragmentDocBase}`;
export const ApplyForJobDocument = gql`
    mutation applyForJob($input: ApplyForJobInput!) {
  applyForJob(input: $input) {
    ...minJobApplicationFields
  }
}
    ${MinJobApplicationFieldsFragmentDocBase}`;
export const CreateArticleAttachmentDocument = gql`
    mutation createArticleAttachment($input: CreateArticleAttachmentInput!) {
  createArticleAttachment(input: $input) {
    id
    image
  }
}
    `;
export const CreateBillingPortalSessionDocument = gql`
    mutation createBillingPortalSession($input: CreateBillingPortalSessionInput!) {
  createBillingPortalSession(input: $input) {
    sessionUrl
  }
}
    `;
export const CreateCompanyDocument = gql`
    mutation createCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    id
    aboutUs
    companySize
    conceptPitch
    denyNewContact
    facebookUrl
    instagramUrl
    isVc
    linkedinUrl
    logo
    name
    slug
    status
    totalFundingAmount
    twitterUrl
    url
  }
}
    `;
export const CreateCompanyArticleDocument = gql`
    mutation createCompanyArticle($input: CreateCompanyArticleInput!) {
  createCompanyArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const CreateJobDocument = gql`
    mutation createJob($input: CreateJobInput!) {
  createJob(input: $input) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const CreateJobAttachmentDocument = gql`
    mutation createJobAttachment($input: CreateJobAttachmentInput!) {
  createJobAttachment(input: $input) {
    id
    image
  }
}
    `;
export const CreateMessageThreadDocument = gql`
    mutation createMessageThread($after: String, $before: String, $first: Int, $last: Int, $input: CreateMessageThreadInput!) {
  createMessageThread(input: $input) {
    id
    messages(after: $after, before: $before, first: $first, last: $last) {
      edges {
        cursor
      }
      nodes {
        body
        createdAt
        id
        updatedAt
        readers {
          id
          name
          profile {
            avatar
            jobTitle
            isJobSeeker
          }
          username
        }
        user {
          id
          name
          profile {
            avatar
            jobTitle
            isJobSeeker
          }
          username
        }
        messageAttachments {
          file
          id
          filename
          mimeType
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    messageThreadType
    name
    slug
    users {
      id
      name
      profile {
        avatar
        jobTitle
        isJobSeeker
      }
      username
    }
  }
}
    `;
export const CreateMyArticleDocument = gql`
    mutation createMyArticle($input: CreateMyArticleInput!) {
  createMyArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const CreateMyCompanyDocument = gql`
    mutation createMyCompany($input: CreateMyCompanyInput!) {
  createMyCompany(input: $input) {
    aboutUs
    companySize
    companyMembers {
      company {
        aboutUs
        companyMembers {
          id
          invitedByUser {
            ...minUserFields
          }
          role
          user {
            ...minUserFields
          }
        }
        receivedInvestments {
          ...recievedInvestmentFields
        }
        companySize
        conceptPitch
        denyNewContact
        facebookUrl
        id
        instagramUrl
        investmentTargetMarkets {
          ...marketFields
        }
        investmentTargetRounds {
          ...roundFields
        }
        investments {
          id
          company {
            aboutUs
            companySize
            conceptPitch
            denyNewContact
            id
            isVc
            logo
            name
            slug
            status
            totalFundingAmount
            url
          }
          investedAt
          isLeadInvestor
          referenceUrl
          round {
            id
            slug
            name
          }
        }
        isVc
        linkedinUrl
        locations {
          ...locationFields
        }
        logo
        maxInvestmentAmount
        minInvestmentAmount
        name
        round {
          ...roundFields
        }
        products {
          ...productFields
        }
        slug
        status
        totalFundingAmount
        twitterUrl
        url
        markets {
          ...marketFields
        }
      }
      invitedByUser {
        ...minUserFields
      }
      role
    }
    conceptPitch
    denyNewContact
    facebookUrl
    instagramUrl
    investmentTargetMarkets {
      ...marketFields
    }
    investmentTargetRounds {
      ...roundFields
    }
    isVc
    linkedinUrl
    locations {
      ...locationFields
    }
    logo
    maxInvestmentAmount
    minInvestmentAmount
    name
    round {
      ...roundFields
    }
    slug
    status
    totalFundingAmount
    twitterUrl
    url
    markets {
      ...marketFields
    }
  }
}
    ${MinUserFieldsFragmentDocBase}
${RecievedInvestmentFieldsFragmentDocBase}
${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}
${ProductFieldsFragmentDocBase}`;
export const CreatePitchDocument = gql`
    mutation createPitch($input: CreatePitchInput!) {
  createPitch(input: $input) {
    ...minMyPitchFields
  }
}
    ${MinMyPitchFieldsFragmentDocBase}`;
export const CreateRecruitSubscriptionDocument = gql`
    mutation createRecruitSubscription($input: CreateRecruitSubscriptionInput!) {
  createRecruitSubscription(input: $input) {
    clientSecret
    subscriptionId
    planAmount
    discountAmountOff
    totalAmount
  }
}
    `;
export const CreateSkillDocument = gql`
    mutation createSkill($input: CreateSkillInput!) {
  createSkill(input: $input) {
    ...skillFields
  }
}
    ${SkillFieldsFragmentDocBase}`;
export const CreateVehicleDocument = gql`
    mutation createVehicle($input: CreateVehicleInput!) {
  createVehicle(input: $input) {
    ...minVehicleFields
  }
}
    ${MinVehicleFieldsFragmentDocBase}`;
export const CreateVehicleItemDocument = gql`
    mutation createVehicleItem($afterPortfolioNotes: String, $beforePortfolioNotes: String, $firstPortfolioNotes: Int, $lastPortfolioNotes: Int, $afterPortfolioMeetings: String, $beforePortfolioMeetings: String, $firstPortfolioMeetings: Int, $lastPortfolioMeetings: Int, $input: CreateVehicleItemInput!) {
  createVehicleItem(input: $input) {
    ...vehicleItemFields
  }
}
    ${VehicleItemFieldsFragmentDocBase}`;
export const CreateVehicleItemPortfolioMeetingDocument = gql`
    mutation createVehicleItemPortfolioMeeting($input: CreateVehicleItemPortfolioMeetingInput!) {
  createVehicleItemPortfolioMeeting(input: $input) {
    ...vehicleItemPortfolioMeetingFields
  }
}
    ${VehicleItemPortfolioMeetingFieldsFragmentDocBase}`;
export const CreateVehicleItemPortfolioNoteDocument = gql`
    mutation createVehicleItemPortfolioNote($input: CreateVehicleItemPortfolioNoteInput!) {
  createVehicleItemPortfolioNote(input: $input) {
    ...vehicleItemPortfolioNoteFields
  }
}
    ${VehicleItemPortfolioNoteFieldsFragmentDocBase}`;
export const CreateVehicleItemRoundDocument = gql`
    mutation createVehicleItemRound($input: CreateVehicleItemRoundInput!) {
  createVehicleItemRound(input: $input) {
    ...vehicleItemRoundFields
  }
}
    ${VehicleItemRoundFieldsFragmentDocBase}`;
export const CreateVehicleStatusDocument = gql`
    mutation createVehicleStatus($after: String, $before: String, $first: Int, $last: Int, $input: CreateVehicleStatusInput!) {
  createVehicleStatus(input: $input) {
    ...vehicleStatusFields
  }
}
    ${VehicleStatusFieldsFragmentDocBase}`;
export const DeleteCompanyArticleDocument = gql`
    mutation deleteCompanyArticle($input: DeleteCompanyArticleInput!) {
  deleteCompanyArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const DeleteJobDocument = gql`
    mutation deleteJob($input: DeleteJobInput!) {
  deleteJob(input: $input) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const DeleteMyArticleDocument = gql`
    mutation deleteMyArticle($input: DeleteMyArticleInput!) {
  deleteMyArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const DeletePitchDocument = gql`
    mutation deletePitch($input: DeletePitchInput!) {
  deletePitch(input: $input) {
    ...minMyPitchFields
  }
}
    ${MinMyPitchFieldsFragmentDocBase}`;
export const DeletePitchAttachmentDocument = gql`
    mutation deletePitchAttachment($input: DeletePitchAttachmentInput!) {
  deletePitchAttachment(input: $input) {
    categoryName
    file
    filename
    id
    url
  }
}
    `;
export const DeleteVehicleDocument = gql`
    mutation deleteVehicle($input: DeleteVehicleInput!) {
  deleteVehicle(input: $input) {
    ...minVehicleFields
  }
}
    ${MinVehicleFieldsFragmentDocBase}`;
export const DeleteVehicleItemDocument = gql`
    mutation deleteVehicleItem($afterPortfolioNotes: String, $beforePortfolioNotes: String, $firstPortfolioNotes: Int, $lastPortfolioNotes: Int, $afterPortfolioMeetings: String, $beforePortfolioMeetings: String, $firstPortfolioMeetings: Int, $lastPortfolioMeetings: Int, $input: DeleteVehicleItemInput!) {
  deleteVehicleItem(input: $input) {
    ...vehicleItemFields
  }
}
    ${VehicleItemFieldsFragmentDocBase}`;
export const DeleteVehicleItemPortfolioAttachmentDocument = gql`
    mutation deleteVehicleItemPortfolioAttachment($input: DeleteVehicleItemPortfolioAttachmentInput!) {
  deleteVehicleItemPortfolioAttachment(input: $input) {
    ...vehicleItemPortfolioAttachmentFields
  }
}
    ${VehicleItemPortfolioAttachmentFieldsFragmentDocBase}`;
export const DeleteVehicleItemPortfolioMeetingDocument = gql`
    mutation deleteVehicleItemPortfolioMeeting($input: DeleteVehicleItemPortfolioMeetingInput!) {
  deleteVehicleItemPortfolioMeeting(input: $input) {
    ...vehicleItemPortfolioMeetingFields
  }
}
    ${VehicleItemPortfolioMeetingFieldsFragmentDocBase}`;
export const DeleteVehicleItemPortfolioNoteDocument = gql`
    mutation deleteVehicleItemPortfolioNote($input: DeleteVehicleItemPortfolioNoteInput!) {
  deleteVehicleItemPortfolioNote(input: $input) {
    ...vehicleItemPortfolioNoteFields
  }
}
    ${VehicleItemPortfolioNoteFieldsFragmentDocBase}`;
export const DeleteVehicleItemRoundDocument = gql`
    mutation deleteVehicleItemRound($input: DeleteVehicleItemRoundInput!) {
  deleteVehicleItemRound(input: $input) {
    ...vehicleItemRoundFields
  }
}
    ${VehicleItemRoundFieldsFragmentDocBase}`;
export const DeleteVehicleItemRoundAttachmentDocument = gql`
    mutation deleteVehicleItemRoundAttachment($input: DeleteVehicleItemRoundAttachmentInput!) {
  deleteVehicleItemRoundAttachment(input: $input) {
    ...vehicleItemRoundAttachmentFields
  }
}
    ${VehicleItemRoundAttachmentFieldsFragmentDocBase}`;
export const DeleteVehicleStatusDocument = gql`
    mutation deleteVehicleStatus($after: String, $before: String, $first: Int, $last: Int, $input: DeleteVehicleStatusInput!) {
  deleteVehicleStatus(input: $input) {
    ...vehicleStatusFields
  }
}
    ${VehicleStatusFieldsFragmentDocBase}`;
export const DuplicateJobDocument = gql`
    mutation duplicateJob($input: DuplicateJobInput!) {
  duplicateJob(input: $input) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const InitializePmsDocument = gql`
    mutation initializePms($input: InitializePmsInput!) {
  initializePms(input: $input) {
    role
    investor {
      ...investorFields
    }
    user {
      ...minUserFields
    }
  }
}
    ${InvestorFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const LeaveServiceDocument = gql`
    mutation leaveService($input: LeaveServiceInput!) {
  leaveService(input: $input) {
    email
    id
    name
    profile {
      avatar
      bio
      denyNewContact
      facebookUrl
      instagramUrl
      isAngel
      isInvestor
      jobTitle
      linkedinUrl
      twitterUrl
    }
    status
    uid
    username
  }
}
    `;
export const MarkAllMessagesAsReadDocument = gql`
    mutation markAllMessagesAsRead($input: MarkAllMessagesAsReadInput!) {
  markAllMessagesAsRead(input: $input) {
    clientMutationId
  }
}
    `;
export const MarkNotificationsAsReadDocument = gql`
    mutation markNotificationsAsRead($input: MarkNotificationsAsReadInput!) {
  markNotificationsAsRead(input: $input) {
    clientMutationId
    hasUnreadNotifications
    notifications {
      category
      createdAt
      id
      isRead
      newMessageNotification {
        id
        message {
          body
          createdAt
          id
          updatedAt
          user {
            id
            name
            username
          }
        }
      }
      updatedAt
    }
  }
}
    `;
export const MarkPitchAsReadDocument = gql`
    mutation markPitchAsRead($input: MarkPitchAsReadInput!) {
  markPitchAsRead(input: $input) {
    ...pitchFields
  }
}
    ${PitchFieldsFragmentDocBase}`;
export const RemoveCompanyMemberDocument = gql`
    mutation removeCompanyMember($input: RemoveCompanyMemberInput!) {
  removeCompanyMember(input: $input) {
    id
    invitedByUser {
      id
      name
      profile {
        avatar
        bio
        jobTitle
        isJobSeeker
      }
      username
    }
    role
    user {
      id
      name
      profile {
        avatar
        bio
        jobTitle
        isJobSeeker
      }
      username
    }
  }
}
    `;
export const RemoveCompanyReferenceDocument = gql`
    mutation removeCompanyReference($input: RemoveCompanyReferenceInput!) {
  removeCompanyReference(input: $input) {
    ...companyReferenceFields
  }
}
    ${CompanyReferenceFieldsFragmentDocBase}`;
export const RemoveExperienceDocument = gql`
    mutation removeExperience($input: RemoveExperienceInput!) {
  removeExperience(input: $input) {
    addedByUser {
      name
      profile {
        avatar
        bio
        denyNewContact
        isAngel
        isInvestor
        jobTitle
        isJobSeeker
      }
      username
    }
    company {
      id
      isVc
      logo
      name
      round {
        id
        name
      }
      slug
      status
      url
    }
    current
    description
    endedAt
    id
    startedAt
    status
    title
  }
}
    `;
export const RemoveInvestmentDocument = gql`
    mutation removeInvestment($input: RemoveInvestmentInput!) {
  removeInvestment(input: $input) {
    company {
      aboutUs
      companySize
      conceptPitch
      denyNewContact
      id
      isVc
      logo
      name
      round {
        id
        name
        slug
      }
      slug
      status
      totalFundingAmount
      url
    }
    id
    investedAt
    investorComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
    startupComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
  }
}
    `;
export const RemoveInvestorDocument = gql`
    mutation removeInvestor($input: RemoveInvestorInput!) {
  removeInvestor(input: $input) {
    company {
      aboutUs
      companySize
      conceptPitch
      denyNewContact
      id
      isVc
      logo
      name
      round {
        id
        name
        slug
      }
      slug
      status
      totalFundingAmount
      url
    }
    id
    investedAt
    investorComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
    startupComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
  }
}
    `;
export const RemoveMyJobBookmarkDocument = gql`
    mutation removeMyJobBookmark($input: RemoveMyJobBookmarkInput!) {
  removeMyJobBookmark(input: $input) {
    id
    job {
      ...jobFields
    }
    user {
      ...minUserFields
    }
    createdAt
    updatedAt
  }
}
    ${JobFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const RemovePitchAttachmentFromPitchDocument = gql`
    mutation removePitchAttachmentFromPitch($input: RemovePitchAttachmentFromPitchInput!) {
  removePitchAttachmentFromPitch(input: $input) {
    categoryName
    file
    filename
    id
    url
  }
}
    `;
export const RemoveProductDocument = gql`
    mutation removeProduct($input: RemoveProductInput!) {
  removeProduct(input: $input) {
    description
    id
    image
    name
    url
  }
}
    `;
export const RemoveUserReferenceDocument = gql`
    mutation removeUserReference($input: RemoveUserReferenceInput!) {
  removeUserReference(input: $input) {
    ...userReferenceFields
  }
}
    ${UserReferenceFieldsFragmentDocBase}`;
export const RemoveVehicleMemberDocument = gql`
    mutation removeVehicleMember($input: RemoveVehicleMemberInput!) {
  removeVehicleMember(input: $input) {
    ...vehicleMemberFields
  }
}
    ${VehicleMemberFieldsFragmentDocBase}`;
export const ToggleArticleLikedStateDocument = gql`
    mutation toggleArticleLikedState($input: ToggleArticleLikedStateInput!) {
  toggleArticleLikedState(input: $input) {
    category {
      id
      name
      slug
    }
    company {
      id
      logo
      name
      slug
    }
    content
    createdAt
    description
    isLiked
    likedUsersCount
    ogImage
    slug
    status
    thumbnail
    originalArticleUrl
    originalSiteName
    title
    topics {
      id
      name
      slug
    }
    fundraisingManualFields {
      id
      step
      subcategory
    }
    updatedAt
  }
}
    `;
export const ToggleFollowCompanyDocument = gql`
    mutation toggleFollowCompany($input: ToggleFollowCompanyInput!) {
  toggleFollowCompany(input: $input) {
    slug
    followersCount
    isFollowing
    notificationSettings {
      id
      name
      slug
    }
  }
}
    `;
export const ToggleFollowUserDocument = gql`
    mutation toggleFollowUser($input: ToggleFollowUserInput!) {
  toggleFollowUser(input: $input) {
    username
    name
    followersCount
    followingCount
    isFollowing
    notificationSettings {
      id
      name
      slug
    }
  }
}
    `;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    aboutUs
    companySize
    conceptPitch
    currencyUnit
    denyNewContact
    facebookUrl
    headerImage
    id
    instagramUrl
    investmentTargetMarkets {
      id
      name
      slug
    }
    investmentTargetRounds {
      id
      name
      slug
    }
    isVc
    linkedinUrl
    locations {
      id
      locationType
      name
      shortDescription
      slug
    }
    logo
    markets {
      id
      name
      slug
    }
    maxInvestmentAmount
    minInvestmentAmount
    name
    round {
      id
      name
      slug
    }
    slug
    status
    totalFundingAmount
    twitterUrl
    url
  }
}
    `;
export const UpdateCompanyArticleDocument = gql`
    mutation updateCompanyArticle($input: UpdateCompanyArticleInput!) {
  updateCompanyArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const UpdateCompanyMemberDocument = gql`
    mutation updateCompanyMember($input: UpdateCompanyMemberInput!) {
  updateCompanyMember(input: $input) {
    id
    invitedByUser {
      id
      name
      profile {
        avatar
        bio
        jobTitle
        isJobSeeker
      }
      username
    }
    role
    user {
      id
      name
      profile {
        avatar
        bio
        jobTitle
        isJobSeeker
      }
      username
    }
  }
}
    `;
export const UpdateCompanyNotificationSettingsDocument = gql`
    mutation updateCompanyNotificationSettings($input: UpdateCompanyNotificationSettingsInput!) {
  updateCompanyNotificationSettings(input: $input) {
    slug
    notificationSettings {
      id
      name
      slug
    }
  }
}
    `;
export const UpdateCompanyReferenceDocument = gql`
    mutation updateCompanyReference($input: UpdateCompanyReferenceInput!) {
  updateCompanyReference(input: $input) {
    ...companyReferenceFields
  }
}
    ${CompanyReferenceFieldsFragmentDocBase}`;
export const UpdateExperienceDocument = gql`
    mutation updateExperience($input: UpdateExperienceInput!) {
  updateExperience(input: $input) {
    addedByUser {
      name
      profile {
        avatar
        bio
        denyNewContact
        isAngel
        isInvestor
        jobTitle
        isJobSeeker
      }
      username
    }
    company {
      id
      isVc
      logo
      name
      round {
        id
        name
      }
      slug
      status
      url
    }
    current
    description
    endedAt
    id
    startedAt
    status
    title
  }
}
    `;
export const UpdateInvestmentDocument = gql`
    mutation updateInvestment($input: UpdateInvestmentInput!) {
  updateInvestment(input: $input) {
    company {
      aboutUs
      companySize
      conceptPitch
      denyNewContact
      id
      isVc
      logo
      name
      round {
        id
        name
        slug
      }
      slug
      status
      totalFundingAmount
      url
    }
    id
    investedAt
    investorComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
  }
}
    `;
export const UpdateInvestorDocument = gql`
    mutation updateInvestor($input: UpdateInvestorInput!) {
  updateInvestor(input: $input) {
    company {
      aboutUs
      companyMembers {
        id
        user {
          id
          name
          profile {
            jobTitle
            bio
            avatar
            isJobSeeker
          }
          username
        }
      }
      companySize
      conceptPitch
      denyNewContact
      facebookUrl
      id
      instagramUrl
      isVc
      linkedinUrl
      logo
      name
      slug
      totalFundingAmount
      twitterUrl
      url
    }
    id
    investedAt
    startupComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
  }
}
    `;
export const UpdateJobDocument = gql`
    mutation updateJob($input: UpdateJobInput!) {
  updateJob(input: $input) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const UpdateMeDocument = gql`
    mutation updateMe($input: UpdateMeInput!) {
  updateMe(input: $input) {
    username
    name
    email
  }
}
    `;
export const UpdateMyArticleDocument = gql`
    mutation updateMyArticle($input: UpdateMyArticleInput!) {
  updateMyArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const UpdateMyCompanyReferenceDocument = gql`
    mutation updateMyCompanyReference($input: UpdateMyCompanyReferenceInput!) {
  updateMyCompanyReference(input: $input) {
    ...companyReferenceFields
  }
}
    ${CompanyReferenceFieldsFragmentDocBase}`;
export const UpdateMyProfileDocument = gql`
    mutation updateMyProfile($input: UpdateMyProfileInput!) {
  updateMyProfile(input: $input) {
    allowMessageRequestsFrom
    avatar
    bio
    birthday
    birthdayAccessScope
    currencyUnit
    delayOfEmailNotificationsForFollower
    delayOfEmailNotificationsForMessages
    denyNewContact
    desiredCareerPath
    desiredCommunicationStyle
    desiredDecisionCulture
    desiredEvaluationCulture
    desiredManagementCulture
    desiredThingsInNextJob
    desiredOrientationCulture
    desiredProgressionStyle
    desiredRoleOnTeam
    desiredTakingOnWorkStyle
    desiredTrainingCulture
    desiredWorkStyle
    desiredWorkplaceCulture
    facebookUrl
    githubUrl
    instagramUrl
    investmentTargetMarkets {
      id
      name
      slug
    }
    investmentTargetRounds {
      id
      name
      slug
    }
    isAngel
    isCofounderDesired
    isContractorDesired
    isFulltimeEmployeeDesired
    isInternDesired
    isInvestor
    isJobSeeker
    isJobSeekerMailMagazineAccepted
    isOptingInToAnnouncement
    isVerifiedAccount
    jobCategories {
      id
      jobCategoryType
      name
      slug
    }
    jobHuntingStatus
    jobTitle
    linkedinUrl
    locations {
      id
      locationType
      name
      shortDescription
      slug
    }
    maxInvestmentAmount
    minInvestmentAmount
    primaryJobCategory {
      id
      jobCategoryType
      name
      slug
    }
    receiveEmailNotificationsForFollower
    receiveEmailNotificationsForMessages
    skills {
      id
      name
      slug
    }
    twitterUrl
    websiteUrl
    yearsOfExperience
  }
}
    `;
export const UpdateMyReferenceDocument = gql`
    mutation updateMyReference($input: UpdateMyReferenceInput!) {
  updateMyReference(input: $input) {
    ...userReferenceFields
  }
}
    ${UserReferenceFieldsFragmentDocBase}`;
export const UpdatePitchDocument = gql`
    mutation updatePitch($input: UpdatePitchInput!) {
  updatePitch(input: $input) {
    ...minMyPitchFields
  }
}
    ${MinMyPitchFieldsFragmentDocBase}`;
export const UpdatePitchAttachmentDocument = gql`
    mutation updatePitchAttachment($input: UpdatePitchAttachmentInput!) {
  updatePitchAttachment(input: $input) {
    categoryName
    file
    filename
    id
    url
  }
}
    `;
export const UpdateProductDocument = gql`
    mutation updateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    description
    id
    image
    name
    url
  }
}
    `;
export const UpdateUserNotificationSettingsDocument = gql`
    mutation updateUserNotificationSettings($input: UpdateUserNotificationSettingsInput!) {
  updateUserNotificationSettings(input: $input) {
    name
    username
    notificationSettings {
      id
      name
      slug
    }
  }
}
    `;
export const UpdateUserReferenceDocument = gql`
    mutation updateUserReference($input: UpdateUserReferenceInput!) {
  updateUserReference(input: $input) {
    ...userReferenceFields
  }
}
    ${UserReferenceFieldsFragmentDocBase}`;
export const UpdateVehicleDocument = gql`
    mutation updateVehicle($input: UpdateVehicleInput!) {
  updateVehicle(input: $input) {
    ...minVehicleFields
  }
}
    ${MinVehicleFieldsFragmentDocBase}`;
export const UpdateVehicleItemDocument = gql`
    mutation updateVehicleItem($afterPortfolioNotes: String, $beforePortfolioNotes: String, $firstPortfolioNotes: Int, $lastPortfolioNotes: Int, $afterPortfolioMeetings: String, $beforePortfolioMeetings: String, $firstPortfolioMeetings: Int, $lastPortfolioMeetings: Int, $input: UpdateVehicleItemInput!) {
  updateVehicleItem(input: $input) {
    ...vehicleItemFields
  }
}
    ${VehicleItemFieldsFragmentDocBase}`;
export const UpdateVehicleItemPortfolioDocument = gql`
    mutation updateVehicleItemPortfolio($afterPortfolioNotes: String, $beforePortfolioNotes: String, $firstPortfolioNotes: Int, $lastPortfolioNotes: Int, $afterPortfolioMeetings: String, $beforePortfolioMeetings: String, $firstPortfolioMeetings: Int, $lastPortfolioMeetings: Int, $input: UpdateVehicleItemPortfolioInput!) {
  updateVehicleItemPortfolio(input: $input) {
    ...vehicleItemPortfolioFields
  }
}
    ${VehicleItemPortfolioFieldsFragmentDocBase}`;
export const UpdateVehicleItemPortfolioMeetingDocument = gql`
    mutation updateVehicleItemPortfolioMeeting($input: UpdateVehicleItemPortfolioMeetingInput!) {
  updateVehicleItemPortfolioMeeting(input: $input) {
    ...vehicleItemPortfolioMeetingFields
  }
}
    ${VehicleItemPortfolioMeetingFieldsFragmentDocBase}`;
export const UpdateVehicleItemPortfolioNoteDocument = gql`
    mutation updateVehicleItemPortfolioNote($input: UpdateVehicleItemPortfolioNoteInput!) {
  updateVehicleItemPortfolioNote(input: $input) {
    ...vehicleItemPortfolioNoteFields
  }
}
    ${VehicleItemPortfolioNoteFieldsFragmentDocBase}`;
export const UpdateVehicleItemRoundDocument = gql`
    mutation updateVehicleItemRound($input: UpdateVehicleItemRoundInput!) {
  updateVehicleItemRound(input: $input) {
    ...vehicleItemRoundFields
  }
}
    ${VehicleItemRoundFieldsFragmentDocBase}`;
export const UpdateVehicleMemberDocument = gql`
    mutation updateVehicleMember($input: UpdateVehicleMemberInput!) {
  updateVehicleMember(input: $input) {
    ...vehicleMemberFields
  }
}
    ${VehicleMemberFieldsFragmentDocBase}`;
export const UpdateVehicleStatusDocument = gql`
    mutation updateVehicleStatus($after: String, $before: String, $first: Int, $last: Int, $input: UpdateVehicleStatusInput!) {
  updateVehicleStatus(input: $input) {
    ...vehicleStatusFields
  }
}
    ${VehicleStatusFieldsFragmentDocBase}`;
export const FetchAngelsDocument = gql`
    query fetchAngels($after: String, $before: String, $first: Int, $last: Int, $maxInvestmentAmount: BigInt, $minInvestmentAmount: BigInt, $investmentTargetMarketIds: [ID!], $investmentTargetRoundIds: [ID!], $locationIds: [ID!], $currencyUnit: CurrencyUnit, $orderBy: UserOrder, $query: String) {
  angels(
    after: $after
    before: $before
    first: $first
    last: $last
    maxInvestmentAmount: $maxInvestmentAmount
    minInvestmentAmount: $minInvestmentAmount
    investmentTargetMarketIds: $investmentTargetMarketIds
    investmentTargetRoundIds: $investmentTargetRoundIds
    locationIds: $locationIds
    currencyUnit: $currencyUnit
    orderBy: $orderBy
    query: $query
  ) {
    nodes {
      name
      profile {
        avatar
        bio
        denyNewContact
        facebookUrl
        instagramUrl
        isAngel
        isInvestor
        isVerifiedAccount
        jobTitle
        linkedinUrl
        twitterUrl
        currencyUnit
        investmentTargetMarkets {
          id
          name
          slug
        }
        investmentTargetRounds {
          id
          name
          slug
        }
        locations {
          id
          locationType
          name
          shortDescription
          slug
        }
        maxInvestmentAmount
        minInvestmentAmount
        isJobSeeker
        hasInvestmentsWithJobs
      }
      username
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchArticleDocument = gql`
    query fetchArticle($slug: ID!) {
  article(slug: $slug) {
    category {
      id
      name
      slug
    }
    company {
      id
      logo
      name
      slug
    }
    content
    createdAt
    description
    isLiked
    likedUsersCount
    ogImage
    slug
    status
    thumbnail
    opinionsUser {
      ...minUserFields
    }
    originalArticleUrl
    originalSiteName
    title
    topics {
      id
      name
      slug
    }
    fundraisingManualFields {
      id
      step
      subcategory
    }
    updatedAt
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const FetchArticlesDocument = gql`
    query fetchArticles($after: String, $before: String, $first: Int, $last: Int, $categories: [String!]) {
  articles(
    after: $after
    before: $before
    first: $first
    last: $last
    categories: $categories
  ) {
    nodes {
      category {
        id
        name
        slug
      }
      company {
        id
        logo
        name
        slug
      }
      content
      createdAt
      description
      isLiked
      likedUsersCount
      ogImage
      opinionsUser {
        ...minUserFields
      }
      originalArticleUrl
      originalSiteName
      slug
      status
      thumbnail
      title
      topics {
        id
        name
        slug
      }
      fundraisingManualFields {
        id
        step
        subcategory
      }
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const FetchMessageThreadsDocument = gql`
    query fetchMessageThreads($after: String, $before: String, $first: Int, $last: Int) {
  messageThreads {
    id
    messages(after: $after, before: $before, first: $first, last: $last) {
      edges {
        cursor
      }
      nodes {
        ...messageFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    messageThreadType
    name
    slug
    users {
      ...minUserFields
    }
    jobApplication {
      ...minJobApplicationFields
    }
  }
}
    ${MessageFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}
${MinJobApplicationFieldsFragmentDocBase}`;
export const FetchMessageThreadDocument = gql`
    query fetchMessageThread($after: String, $before: String, $first: Int, $last: Int, $slug: ID!) {
  messageThread(slug: $slug) {
    id
    slug
    messages(after: $after, before: $before, first: $first, last: $last) {
      edges {
        cursor
      }
      nodes {
        ...messageFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    ${MessageFieldsFragmentDocBase}`;
export const FetchCompaniesDocument = gql`
    query fetchCompanies($after: String, $before: String, $first: Int, $last: Int, $maxInvestmentAmount: BigInt, $minInvestmentAmount: BigInt, $companySize: CompanySize, $roundIds: [ID!], $investmentTargetMarketIds: [ID!], $investmentTargetRoundIds: [ID!], $locationIds: [ID!], $isVc: Boolean, $marketIds: [ID!], $currencyUnit: CurrencyUnit, $orderBy: CompanyOrder, $query: String) {
  companies(
    after: $after
    before: $before
    first: $first
    maxInvestmentAmount: $maxInvestmentAmount
    minInvestmentAmount: $minInvestmentAmount
    companySize: $companySize
    roundIds: $roundIds
    investmentTargetMarketIds: $investmentTargetMarketIds
    investmentTargetRoundIds: $investmentTargetRoundIds
    isVc: $isVc
    last: $last
    locationIds: $locationIds
    marketIds: $marketIds
    currencyUnit: $currencyUnit
    orderBy: $orderBy
    query: $query
  ) {
    nodes {
      id
      aboutUs
      companySize
      conceptPitch
      currencyUnit
      denyNewContact
      facebookUrl
      followersCount
      instagramUrl
      investmentTargetMarkets {
        ...marketFields
      }
      investmentTargetRounds {
        ...roundFields
      }
      isVc
      linkedinUrl
      locations {
        ...locationFields
      }
      logo
      maxInvestmentAmount
      minInvestmentAmount
      name
      round {
        ...roundFields
      }
      slug
      status
      totalFundingAmount
      twitterUrl
      url
      youtubeUrl
      markets {
        ...marketFields
      }
      hasInvestmentsWithJobs
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}`;
export const FetchCompaniesWithJobsDocument = gql`
    query fetchCompaniesWithJobs($after: String, $before: String, $first: Int, $last: Int, $afterJobs: String, $beforeJobs: String, $firstJobs: Int, $lastJobs: Int, $angelUsername: ID, $companyLocationIds: [ID!], $companySize: CompanySize, $currencyUnit: CurrencyUnit, $equityGrant: [Boolean!], $investmentTargetMarketIds: [ID!], $investmentTargetRoundIds: [ID!], $isVc: Boolean, $jobCategoryIds: [ID!], $jobLocationIds: [ID!], $marketIds: [ID!], $maxInvestmentAmount: BigInt, $maxMonthlySalary: BigInt, $minInvestmentAmount: BigInt, $minMonthlySalary: BigInt, $query: String, $roundIds: [ID!], $skillIds: [ID!], $typeOfPosition: [JobTypeOfPosition!], $vcSlug: ID, $workExperience: JobWorkExperience, $workingForm: [JobWorkingForm!]) {
  companiesWithJobs(
    after: $after
    angelUsername: $angelUsername
    before: $before
    companyLocationIds: $companyLocationIds
    companySize: $companySize
    currencyUnit: $currencyUnit
    equityGrant: $equityGrant
    first: $first
    investmentTargetMarketIds: $investmentTargetMarketIds
    investmentTargetRoundIds: $investmentTargetRoundIds
    isVc: $isVc
    jobCategoryIds: $jobCategoryIds
    jobLocationIds: $jobLocationIds
    last: $last
    marketIds: $marketIds
    maxInvestmentAmount: $maxInvestmentAmount
    maxMonthlySalary: $maxMonthlySalary
    minInvestmentAmount: $minInvestmentAmount
    minMonthlySalary: $minMonthlySalary
    query: $query
    roundIds: $roundIds
    skillIds: $skillIds
    typeOfPosition: $typeOfPosition
    vcSlug: $vcSlug
    workExperience: $workExperience
    workingForm: $workingForm
  ) {
    nodes {
      id
      aboutUs
      companySize
      conceptPitch
      currencyUnit
      denyNewContact
      facebookUrl
      instagramUrl
      investmentTargetMarkets {
        ...marketFields
      }
      investmentTargetRounds {
        ...roundFields
      }
      isVc
      linkedinUrl
      locations {
        ...locationFields
      }
      logo
      maxInvestmentAmount
      minInvestmentAmount
      name
      round {
        ...roundFields
      }
      slug
      status
      totalFundingAmount
      twitterUrl
      url
      youtubeUrl
      markets {
        ...marketFields
      }
      receivedInvestments {
        angel {
          ...minUserFields
        }
        companyInvestedFrom {
          aboutUs
          id
          logo
          name
          slug
          status
        }
        id
      }
      ...highlightedJobListings
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}
${HighlightedJobListingsFragmentDocBase}`;
export const FetchCompanyDocument = gql`
    query fetchCompany($afterJobs: String, $beforeJobs: String, $firstJobs: Int, $lastJobs: Int, $afterReferences: String, $beforeReferences: String, $firstReferences: Int, $lastReferences: Int, $slug: ID!) {
  company(slug: $slug) {
    aboutUs
    companyMembers {
      id
      user {
        ...minUserFields
        isFollower
      }
    }
    companyReferences(
      after: $afterReferences
      before: $beforeReferences
      first: $firstReferences
      last: $lastReferences
    ) {
      nodes {
        ...companyReferenceFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    companySize
    conceptPitch
    denyNewContact
    currencyUnit
    facebookUrl
    followersCount
    headerImage
    instagramUrl
    investmentTargetMarkets {
      ...marketFields
    }
    investmentTargetRounds {
      ...roundFields
    }
    investments {
      company {
        ...minCompanyField
      }
      id
      investedAt
      isLeadInvestor
      referenceUrl
      round {
        ...roundFields
      }
      investorComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
      startupComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
    }
    isFollowing
    isVc
    linkedinUrl
    locations {
      ...locationFields
    }
    logo
    maxInvestmentAmount
    minInvestmentAmount
    name
    notificationSettings {
      id
      name
      slug
    }
    products {
      ...productFields
    }
    round {
      ...roundFields
    }
    slug
    status
    totalFundingAmount
    twitterUrl
    url
    youtubeUrl
    markets {
      ...marketFields
    }
    receivedInvestments {
      angel {
        ...minUserFields
      }
      companyInvestedFrom {
        aboutUs
        id
        logo
        name
        slug
        status
      }
      id
      startupComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
      investorComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
    }
    ...companyWithJobs
  }
}
    ${MinUserFieldsFragmentDocBase}
${CompanyReferenceFieldsFragmentDocBase}
${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}
${MinCompanyFieldFragmentDocBase}
${LocationFieldsFragmentDocBase}
${ProductFieldsFragmentDocBase}
${CompanyWithJobsFragmentDocBase}`;
export const FetchCompanyArticlesDocument = gql`
    query fetchCompanyArticles($after: String, $before: String, $first: Int, $last: Int, $slug: ID!) {
  companyArticles(
    after: $after
    before: $before
    first: $first
    last: $last
    slug: $slug
  ) {
    nodes {
      category {
        id
        name
        slug
      }
      company {
        id
        logo
        name
        slug
      }
      content
      createdAt
      description
      id
      ogImage
      originalArticleUrl
      originalSiteName
      slug
      status
      thumbnail
      title
      topics {
        id
        name
        slug
      }
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchCompanyForViewerDocument = gql`
    query fetchCompanyForViewer($slug: ID!) {
  company(slug: $slug) {
    companyMembers {
      id
      user {
        ...minUserFields
        isFollower
      }
    }
    isFollowing
    notificationSettings {
      id
      name
      slug
    }
    slug
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const FetchCompanyJobsDocument = gql`
    query fetchCompanyJobs($after: String, $before: String, $first: Int, $last: Int, $companySlug: ID!) {
  companyJobs(
    after: $after
    before: $before
    companySlug: $companySlug
    first: $first
    last: $last
  ) {
    nodes {
      ...jobFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}`;
export const FetchFeaturedAngelsDocument = gql`
    query fetchFeaturedAngels {
  featuredAngels {
    name
    profile {
      avatar
      bio
      denyNewContact
      facebookUrl
      instagramUrl
      isAngel
      isInvestor
      isVerifiedAccount
      jobTitle
      linkedinUrl
      twitterUrl
      currencyUnit
      investmentTargetMarkets {
        id
        name
        slug
      }
      investmentTargetRounds {
        id
        name
        slug
      }
      locations {
        id
        locationType
        name
        shortDescription
        slug
      }
      maxInvestmentAmount
      minInvestmentAmount
      isJobSeeker
    }
    username
  }
}
    `;
export const FetchFeaturedCompaniesWithJobsDocument = gql`
    query fetchFeaturedCompaniesWithJobs($afterJobs: String, $beforeJobs: String, $firstJobs: Int, $lastJobs: Int) {
  featuredCompaniesWithJobs {
    aboutUs
    companySize
    conceptPitch
    currencyUnit
    denyNewContact
    facebookUrl
    instagramUrl
    investmentTargetMarkets {
      id
      name
      slug
    }
    investmentTargetRounds {
      id
      name
      slug
    }
    isVc
    linkedinUrl
    locations {
      id
      locationType
      name
      shortDescription
      slug
    }
    logo
    maxInvestmentAmount
    minInvestmentAmount
    name
    round {
      id
      name
    }
    slug
    status
    totalFundingAmount
    twitterUrl
    url
    markets {
      id
      name
      slug
    }
    receivedInvestments {
      angel {
        ...minUserFields
      }
      companyInvestedFrom {
        aboutUs
        id
        logo
        name
        slug
        status
      }
      id
    }
    ...companyWithJobs
  }
}
    ${MinUserFieldsFragmentDocBase}
${CompanyWithJobsFragmentDocBase}`;
export const FetchFeaturedJobsDocument = gql`
    query fetchFeaturedJobs {
  featuredJobs {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const FetchFeaturedStartupsDocument = gql`
    query fetchFeaturedStartups {
  featuredStartups {
    aboutUs
    companySize
    conceptPitch
    currencyUnit
    denyNewContact
    facebookUrl
    instagramUrl
    investmentTargetMarkets {
      id
      name
      slug
    }
    investmentTargetRounds {
      id
      name
      slug
    }
    isVc
    linkedinUrl
    locations {
      id
      locationType
      name
      shortDescription
      slug
    }
    logo
    maxInvestmentAmount
    minInvestmentAmount
    name
    round {
      id
      name
    }
    slug
    status
    totalFundingAmount
    twitterUrl
    url
    markets {
      id
      name
      slug
    }
  }
}
    `;
export const FetchFeaturedStoriesDocument = gql`
    query fetchFeaturedStories {
  featuredStories {
    category {
      id
      name
      slug
    }
    company {
      id
      logo
      name
      slug
    }
    content
    createdAt
    description
    ogImage
    slug
    status
    thumbnail
    opinionsUser {
      ...minUserFields
    }
    originalArticleUrl
    originalSiteName
    title
    topics {
      id
      name
      slug
    }
    updatedAt
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const FetchFeaturedVentureCapitalsDocument = gql`
    query fetchFeaturedVentureCapitals {
  featuredVentureCapitals {
    aboutUs
    companySize
    conceptPitch
    currencyUnit
    denyNewContact
    facebookUrl
    instagramUrl
    investmentTargetMarkets {
      id
      name
      slug
    }
    investmentTargetRounds {
      id
      name
      slug
    }
    isVc
    linkedinUrl
    locations {
      id
      locationType
      name
      shortDescription
      slug
    }
    logo
    maxInvestmentAmount
    minInvestmentAmount
    name
    round {
      id
      name
    }
    slug
    status
    totalFundingAmount
    twitterUrl
    url
    markets {
      id
      name
      slug
    }
  }
}
    `;
export const FetchFollowersDocument = gql`
    query fetchFollowers($after: String, $before: String, $entityType: FollowableEntityEntityType!, $first: Int, $last: Int, $slug: ID!) {
  followers(
    after: $after
    before: $before
    entityType: $entityType
    first: $first
    last: $last
    slug: $slug
  ) {
    nodes {
      isFollowing
      name
      username
      profile {
        avatar
        bio
        isJobSeeker
        isVerifiedAccount
        jobTitle
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchFollowingDocument = gql`
    query fetchFollowing($after: String, $before: String, $first: Int, $last: Int, $username: ID!) {
  following(
    after: $after
    before: $before
    first: $first
    last: $last
    username: $username
  ) {
    nodes {
      category
      description
      entityType
      image
      isFollowing
      isVerifiedAccount
      name
      shortDescription
      slug
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchForexRateDocument = gql`
    query fetchForexRate($tickerSymbol: TickerSymbol!) {
  forexRate(tickerSymbol: $tickerSymbol) {
    id
    rate
    tickerSymbol
  }
}
    `;
export const FetchForexRatesDocument = gql`
    query fetchForexRates($tickerSymbol1: TickerSymbol!, $tickerSymbol2: TickerSymbol!) {
  forexRate1: forexRate(tickerSymbol: $tickerSymbol1) {
    id
    rate
    tickerSymbol
  }
  forexRate2: forexRate(tickerSymbol: $tickerSymbol2) {
    id
    rate
    tickerSymbol
  }
}
    `;
export const FetchJobDocument = gql`
    query fetchJob($slug: ID!) {
  job(slug: $slug) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const FetchJobApplicationsDocument = gql`
    query fetchJobApplications($after: String, $before: String, $first: Int, $last: Int, $after1: String, $before1: String, $companySlug: ID!, $first1: Int, $last1: Int) {
  jobApplications(
    after: $after1
    before: $before1
    companySlug: $companySlug
    first: $first1
    last: $last1
  ) {
    nodes {
      id
      job {
        ...jobFields
      }
      messageThread {
        id
        messageThreadType
        messages(after: $after, before: $before, first: $first, last: $last) {
          edges {
            cursor
          }
          nodes {
            ...messageFields
          }
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
        name
        slug
        users {
          ...minUserFields
        }
      }
      user {
        ...minUserFields
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}
${MessageFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const FetchJobBookmarksDocument = gql`
    query fetchJobBookmarks($after: String, $before: String, $companySlug: ID, $first: Int, $jobSlug: ID, $last: Int) {
  jobBookmarks(
    after: $after
    before: $before
    companySlug: $companySlug
    first: $first
    jobSlug: $jobSlug
    last: $last
  ) {
    nodes {
      createdAt
      id
      job {
        body
        createdAt
        currencyUnit
        equityGrant
        id
        jobCategories {
          ...jobCategoryFields
        }
        jobTags {
          ...jobTagFields
        }
        maxMonthlySalary
        minMonthlySalary
        skills {
          ...skillFields
        }
        slug
        status
        thumbnail
        title
        tokenGrant
        typeOfPosition
        updatedAt
        workExperience
        workingForm
      }
      updatedAt
      user {
        ...minUserFields
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobCategoryFieldsFragmentDocBase}
${JobTagFieldsFragmentDocBase}
${SkillFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const FetchJobCategoriesDocument = gql`
    query fetchJobCategories {
  jobCategories {
    ...jobCategoryFields
  }
}
    ${JobCategoryFieldsFragmentDocBase}`;
export const FetchJobFootprintsDocument = gql`
    query fetchJobFootprints($after: String, $before: String, $companySlug: ID!, $first: Int, $jobSlug: ID, $last: Int) {
  jobFootprints(
    after: $after
    before: $before
    companySlug: $companySlug
    first: $first
    jobSlug: $jobSlug
    last: $last
  ) {
    nodes {
      createdAt
      id
      job {
        createdAt
        id
        slug
        status
        thumbnail
        title
        typeOfPosition
        updatedAt
        body
        currencyUnit
        workExperience
        workingForm
        equityGrant
        tokenGrant
        maxMonthlySalary
        minMonthlySalary
        jobCategories {
          ...jobCategoryFields
        }
        jobTags {
          ...jobTagFields
        }
        skills {
          ...skillFields
        }
      }
      referer
      user {
        ...minUserFields
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobCategoryFieldsFragmentDocBase}
${JobTagFieldsFragmentDocBase}
${SkillFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const FetchJobTagsDocument = gql`
    query fetchJobTags {
  jobTags {
    ...jobTagFields
  }
}
    ${JobTagFieldsFragmentDocBase}`;
export const FetchJobsDocument = gql`
    query fetchJobs($after: String, $before: String, $first: Int, $last: Int, $currencyUnit: CurrencyUnit, $equityGrant: [Boolean!], $jobCategoryIds: [ID!], $locationIds: [ID!], $maxMonthlySalary: BigInt, $minMonthlySalary: BigInt, $query: String, $skillIds: [ID!], $typeOfPosition: [JobTypeOfPosition!], $workExperience: JobWorkExperience, $workingForm: [JobWorkingForm!]) {
  jobs(
    after: $after
    before: $before
    currencyUnit: $currencyUnit
    equityGrant: $equityGrant
    first: $first
    jobCategoryIds: $jobCategoryIds
    last: $last
    locationIds: $locationIds
    maxMonthlySalary: $maxMonthlySalary
    minMonthlySalary: $minMonthlySalary
    query: $query
    skillIds: $skillIds
    typeOfPosition: $typeOfPosition
    workExperience: $workExperience
    workingForm: $workingForm
  ) {
    nodes {
      ...jobFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}`;
export const FetchLocationDocument = gql`
    query fetchLocation($id: ID!) {
  location(id: $id) {
    id
    locationType
    name
    shortDescription
    slug
  }
}
    `;
export const FetchLocationsDocument = gql`
    query fetchLocations($after: String, $before: String, $first: Int, $last: Int, $query: String) {
  locations(
    after: $after
    before: $before
    first: $first
    last: $last
    query: $query
  ) {
    nodes {
      id
      locationType
      name
      shortDescription
      slug
    }
  }
}
    `;
export const FetchMarketsDocument = gql`
    query fetchMarkets {
  markets {
    id
    name
    slug
  }
}
    `;
export const FetchMeDocument = gql`
    query fetchMe($articlesAfter: String, $articlesBefore: String, $articlesFirst: Int, $articlesLast: Int, $notificationsAfter: String, $notificationsBefore: String, $notificationsFirst: Int, $notificationsLast: Int) {
  me {
    id
    companyMembers {
      company {
        aboutUs
        articles(
          after: $articlesAfter
          before: $articlesBefore
          first: $articlesFirst
          last: $articlesLast
        ) {
          edges {
            cursor
          }
          nodes {
            content
            createdAt
            description
            id
            ogImage
            originalArticleUrl
            originalSiteName
            slug
            status
            thumbnail
            title
            updatedAt
          }
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
        companyMembers {
          id
          invitedByUser {
            ...minUserFields
          }
          role
          user {
            ...minUserFields
          }
        }
        receivedInvestments {
          ...recievedInvestmentFields
        }
        companySize
        conceptPitch
        currencyUnit
        denyNewContact
        facebookUrl
        headerImage
        id
        instagramUrl
        investmentTargetMarkets {
          ...marketFields
        }
        investmentTargetRounds {
          ...roundFields
        }
        investments {
          id
          company {
            aboutUs
            companySize
            conceptPitch
            id
            isVc
            logo
            name
            slug
            status
            totalFundingAmount
            url
          }
          investedAt
          isLeadInvestor
          referenceUrl
          round {
            id
            slug
            name
          }
          investorComment {
            comment
            commenter {
              id
              name
              status
              username
            }
            commenterType
          }
        }
        isVc
        jobApplicationsCount
        jobBookmarksCount
        jobFootprintsCount
        linkedinUrl
        locations {
          ...locationFields
        }
        logo
        maxInvestmentAmount
        minInvestmentAmount
        name
        round {
          ...roundFields
        }
        pitches {
          ...myPitchFields
        }
        pmsPlan
        products {
          ...productFields
        }
        slug
        status
        totalFundingAmount
        twitterUrl
        url
        youtubeUrl
        markets {
          ...marketFields
        }
        recruitPlan
        hasStripeCustomerId
      }
      invitedByUser {
        ...minUserFields
      }
      role
      id
    }
    email
    experiences {
      addedByUser {
        id
        name
        profile {
          avatar
          isJobSeeker
        }
        username
      }
      company {
        id
        isVc
        logo
        name
        slug
        status
        url
      }
      current
      description
      endedAt
      id
      startedAt
      status
      title
    }
    id
    investments {
      company {
        id
        isVc
        logo
        name
        slug
        status
        url
      }
      id
      investedAt
      isLeadInvestor
      referenceUrl
      round {
        id
        name
        slug
      }
      investorComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
    }
    invitationOf
    isFirstSignIn
    name
    pmsPlan
    profile {
      allowMessageRequestsFrom
      avatar
      bio
      birthday
      birthdayAccessScope
      currencyUnit
      delayOfEmailNotificationsForFollower
      delayOfEmailNotificationsForMessages
      denyNewContact
      desiredCareerPath
      desiredCommunicationStyle
      desiredDecisionCulture
      desiredEvaluationCulture
      desiredManagementCulture
      desiredThingsInNextJob
      desiredOrientationCulture
      desiredProgressionStyle
      desiredRoleOnTeam
      desiredTakingOnWorkStyle
      desiredTrainingCulture
      desiredWorkStyle
      desiredWorkplaceCulture
      facebookUrl
      githubUrl
      headerImage
      instagramUrl
      investmentTargetMarkets {
        ...marketFields
      }
      investmentTargetRounds {
        ...roundFields
      }
      isAngel
      isCofounderDesired
      isContractorDesired
      isFulltimeEmployeeDesired
      isInternDesired
      isInvestor
      isJobSeeker
      isJobSeekerMailMagazineAccepted
      isOptingInToAnnouncement
      isVerifiedAccount
      jobCategories {
        ...jobCategoryFields
      }
      jobHuntingStatus
      jobTitle
      linkedinUrl
      locations {
        ...locationFields
      }
      maxInvestmentAmount
      minInvestmentAmount
      primaryJobCategory {
        ...jobCategoryFields
      }
      receiveEmailNotificationsForFollower
      receiveEmailNotificationsForMessages
      skills {
        ...skillFields
      }
      twitterUrl
      websiteUrl
      yearsOfExperience
    }
    role
    username
    hasUnreadNotifications
    notifications(
      after: $notificationsAfter
      before: $notificationsBefore
      first: $notificationsFirst
      last: $notificationsLast
    ) {
      edges {
        cursor
      }
      nodes {
        ...notificationFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    investorMembers {
      role
      investor {
        id
        investorSlug
        investorType
        company {
          ...minCompanyField
        }
        user {
          ...minUserFields
        }
      }
      vehicleMembers {
        vehicle {
          id
          slug
        }
        role
      }
    }
  }
}
    ${MinUserFieldsFragmentDocBase}
${RecievedInvestmentFieldsFragmentDocBase}
${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}
${MyPitchFieldsFragmentDocBase}
${ProductFieldsFragmentDocBase}
${JobCategoryFieldsFragmentDocBase}
${SkillFieldsFragmentDocBase}
${NotificationFieldsFragmentDocBase}
${MinCompanyFieldFragmentDocBase}`;
export const FetchMyArticlesDocument = gql`
    query fetchMyArticles($after: String, $before: String, $first: Int, $last: Int) {
  myArticles(after: $after, before: $before, first: $first, last: $last) {
    nodes {
      category {
        id
        name
        slug
      }
      company {
        id
        logo
        name
        slug
      }
      content
      createdAt
      description
      id
      ogImage
      originalArticleUrl
      originalSiteName
      slug
      status
      thumbnail
      title
      topics {
        id
        name
        slug
      }
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchMyCompanyDocument = gql`
    query fetchMyCompany($after: String, $before: String, $first: Int, $last: Int, $slug: ID!) {
  myCompany(slug: $slug) {
    aboutUs
    articles(after: $after, before: $before, first: $first, last: $last) {
      edges {
        cursor
      }
      nodes {
        content
        createdAt
        description
        id
        ogImage
        originalArticleUrl
        originalSiteName
        slug
        status
        thumbnail
        title
        updatedAt
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    companyMembers {
      id
      invitedByUser {
        ...minUserFields
      }
      role
      user {
        ...minUserFields
      }
    }
    receivedInvestments {
      angel {
        id
        name
        profile {
          bio
          avatar
          isVerifiedAccount
          twitterUrl
          isJobSeeker
        }
        username
      }
      company {
        aboutUs
        companySize
        conceptPitch
        id
        isVc
        logo
        name
        slug
        status
        totalFundingAmount
        url
      }
      companyInvestedFrom {
        aboutUs
        id
        logo
        name
        slug
        status
        investments {
          id
          company {
            aboutUs
            companySize
            conceptPitch
            id
            isVc
            logo
            name
            slug
            status
            totalFundingAmount
            url
          }
          investedAt
          isLeadInvestor
          referenceUrl
          round {
            id
            slug
            name
          }
          investorComment {
            comment
            commenter {
              id
              name
              status
              username
            }
            commenterType
          }
        }
      }
      id
      investedAt
      isLeadInvestor
      referenceUrl
      startupComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
      investorComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
    }
    companySize
    conceptPitch
    currencyUnit
    denyNewContact
    facebookUrl
    id
    instagramUrl
    investmentTargetMarkets {
      ...marketFields
    }
    investmentTargetRounds {
      ...roundFields
    }
    investments {
      id
      company {
        aboutUs
        companySize
        conceptPitch
        id
        isVc
        logo
        name
        slug
        status
        totalFundingAmount
        url
      }
      investedAt
      isLeadInvestor
      referenceUrl
      round {
        id
        slug
        name
      }
      investorComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
    }
    isVc
    jobApplicationsCount
    jobBookmarksCount
    jobFootprintsCount
    linkedinUrl
    locations {
      ...locationFields
    }
    logo
    maxInvestmentAmount
    minInvestmentAmount
    name
    round {
      ...roundFields
    }
    pitches {
      ...myPitchFields
    }
    pmsPlan
    products {
      ...productFields
    }
    slug
    status
    totalFundingAmount
    twitterUrl
    url
    youtubeUrl
    markets {
      ...marketFields
    }
    recruitPlan
    hasStripeCustomerId
  }
}
    ${MinUserFieldsFragmentDocBase}
${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}
${MyPitchFieldsFragmentDocBase}
${ProductFieldsFragmentDocBase}`;
export const FetchMyCompanyArticlesDocument = gql`
    query fetchMyCompanyArticles($after: String, $before: String, $first: Int, $last: Int, $slug: ID!) {
  myCompany(slug: $slug) {
    articles(after: $after, before: $before, first: $first, last: $last) {
      edges {
        cursor
      }
      nodes {
        content
        createdAt
        description
        id
        ogImage
        originalArticleUrl
        originalSiteName
        slug
        status
        thumbnail
        title
        updatedAt
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    `;
export const FetchMyCompanyReferencesDocument = gql`
    query fetchMyCompanyReferences($after: String, $before: String, $first: Int, $last: Int, $slug: ID!) {
  myCompanyReferences(
    after: $after
    before: $before
    first: $first
    last: $last
    slug: $slug
  ) {
    nodes {
      ...companyReferenceFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${CompanyReferenceFieldsFragmentDocBase}`;
export const FetchMyInvestorMembersDocument = gql`
    query fetchMyInvestorMembers {
  me {
    id
    email
    name
    username
    investorMembers {
      role
      investor {
        id
        investorSlug
        investorType
        user {
          ...minUserFields
        }
        company {
          ...minCompanyField
        }
      }
      vehicleMembers {
        vehicle {
          id
          slug
          name
        }
        role
      }
    }
  }
}
    ${MinUserFieldsFragmentDocBase}
${MinCompanyFieldFragmentDocBase}`;
export const FetchMyJobBookmarksDocument = gql`
    query fetchMyJobBookmarks($after: String, $before: String, $first: Int, $last: Int) {
  myJobBookmarks(after: $after, before: $before, first: $first, last: $last) {
    nodes {
      id
      job {
        ...jobFields
      }
      user {
        ...minUserFields
      }
      createdAt
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const FetchMyJobsDocument = gql`
    query fetchMyJobs($after: String, $before: String, $first: Int, $last: Int, $companySlug: ID!) {
  myJobs(
    after: $after
    before: $before
    companySlug: $companySlug
    first: $first
    last: $last
  ) {
    nodes {
      ...jobFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}`;
export const FetchMyPitchesDocument = gql`
    query fetchMyPitches($companySlug: ID!) {
  myPitches(companySlug: $companySlug) {
    ...myPitchFields
  }
}
    ${MyPitchFieldsFragmentDocBase}`;
export const FetchMyReferencesDocument = gql`
    query fetchMyReferences($after: String, $before: String, $first: Int, $last: Int) {
  myReferences(after: $after, before: $before, first: $first, last: $last) {
    nodes {
      ...userReferenceFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${UserReferenceFieldsFragmentDocBase}`;
export const FetchNotificationsDocument = gql`
    query fetchNotifications($after: String, $before: String, $first: Int, $last: Int) {
  me {
    email
    name
    username
    notifications(after: $after, before: $before, first: $first, last: $last) {
      nodes {
        ...notificationFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    ${NotificationFieldsFragmentDocBase}`;
export const FetchPaginatedMessageThreadsDocument = gql`
    query fetchPaginatedMessageThreads($after: String, $before: String, $first: Int, $last: Int, $messagesAfter: String, $messagesBefore: String, $messagesFirst: Int, $messagesLast: Int) {
  paginatedMessageThreads(
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    nodes {
      id
      messages(
        after: $messagesAfter
        before: $messagesBefore
        first: $messagesFirst
        last: $messagesLast
      ) {
        edges {
          cursor
        }
        nodes {
          ...messageFields
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
      messageThreadType
      name
      slug
      users {
        ...minUserFields
      }
      jobApplication {
        ...minJobApplicationFields
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${MessageFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}
${MinJobApplicationFieldsFragmentDocBase}`;
export const FetchPickedUpFeaturesDocument = gql`
    query fetchPickedUpFeatures {
  pickedUpFeatures {
    category {
      id
      name
      slug
    }
    company {
      id
      logo
      name
      slug
    }
    content
    createdAt
    description
    ogImage
    slug
    status
    thumbnail
    opinionsUser {
      ...minUserFields
    }
    originalArticleUrl
    originalSiteName
    title
    topics {
      id
      name
      slug
    }
    updatedAt
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const FetchPitchDocument = gql`
    query fetchPitch($slug: ID!) {
  pitch(slug: $slug) {
    ...pitchFields
  }
}
    ${PitchFieldsFragmentDocBase}`;
export const FetchPitchesDocument = gql`
    query fetchPitches($companySlug: ID!) {
  pitches(companySlug: $companySlug) {
    ...pitchFields
  }
}
    ${PitchFieldsFragmentDocBase}`;
export const FetchSkillsDocument = gql`
    query fetchSkills($after: String, $before: String, $first: Int, $last: Int, $query: String) {
  skills(
    after: $after
    before: $before
    first: $first
    last: $last
    query: $query
  ) {
    nodes {
      ...skillFields
    }
  }
}
    ${SkillFieldsFragmentDocBase}`;
export const FetchSubsidiesDocument = gql`
    query fetchSubsidies($after: String, $before: String, $first: Int, $last: Int, $locationsId: ID, $query: String, $subsidyPurposeIds: [ID!]) {
  subsidies(
    after: $after
    before: $before
    first: $first
    last: $last
    locationsId: $locationsId
    query: $query
    subsidyPurposeIds: $subsidyPurposeIds
  ) {
    nodes {
      ...subsidyFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${SubsidyFieldsFragmentDocBase}`;
export const FetchSubsidyDocument = gql`
    query fetchSubsidy($id: ID!) {
  subsidy(id: $id) {
    ...subsidyFields
  }
}
    ${SubsidyFieldsFragmentDocBase}`;
export const FetchSubsidyPurposeDocument = gql`
    query fetchSubsidyPurpose($id: ID!) {
  subsidyPurpose(id: $id) {
    createdAt
    id
    name
    updatedAt
  }
}
    `;
export const FetchSubsidyPurposesDocument = gql`
    query fetchSubsidyPurposes {
  subsidyPurposes {
    createdAt
    id
    name
    updatedAt
  }
}
    `;
export const FetchUserDocument = gql`
    query fetchUser($afterReferences: String, $beforeReferences: String, $firstReferences: Int, $lastReferences: Int, $username: ID!) {
  user(username: $username) {
    experiences {
      addedByUser {
        id
        name
        profile {
          avatar
          isJobSeeker
        }
        username
      }
      company {
        id
        isVc
        logo
        name
        slug
        status
        url
      }
      current
      description
      endedAt
      id
      startedAt
      status
      title
    }
    followersCount
    followingCount
    investments {
      id
      company {
        isVc
        logo
        name
        slug
        status
        url
      }
      investedAt
      isLeadInvestor
      referenceUrl
      startupComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
    }
    isFollower
    isFollowing
    name
    notificationSettings {
      id
      name
      slug
    }
    profile {
      allowMessageRequestsFrom
      avatar
      bio
      birthday
      birthdayAccessScope
      currencyUnit
      denyNewContact
      desiredCareerPath
      desiredCommunicationStyle
      desiredDecisionCulture
      desiredEvaluationCulture
      desiredManagementCulture
      desiredThingsInNextJob
      desiredOrientationCulture
      desiredProgressionStyle
      desiredRoleOnTeam
      desiredTakingOnWorkStyle
      desiredTrainingCulture
      desiredWorkStyle
      desiredWorkplaceCulture
      facebookUrl
      githubUrl
      headerImage
      instagramUrl
      investmentTargetMarkets {
        id
        name
        slug
      }
      investmentTargetRounds {
        id
        name
        slug
      }
      isAngel
      isCofounderDesired
      isContractorDesired
      isFulltimeEmployeeDesired
      isInternDesired
      isInvestor
      isJobSeeker
      isJobSeekerMailMagazineAccepted
      isVerifiedAccount
      jobCategories {
        id
        jobCategoryType
        name
        slug
      }
      jobHuntingStatus
      jobTitle
      linkedinUrl
      locations {
        id
        locationType
        name
        shortDescription
        slug
      }
      maxInvestmentAmount
      minInvestmentAmount
      primaryJobCategory {
        id
        jobCategoryType
        name
        slug
      }
      skills {
        id
        name
        slug
      }
      twitterUrl
      websiteUrl
      yearsOfExperience
    }
    username
    status
    userReferences(
      after: $afterReferences
      before: $beforeReferences
      first: $firstReferences
      last: $lastReferences
    ) {
      nodes {
        ...userReferenceFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    ${UserReferenceFieldsFragmentDocBase}`;
export const FetchUserArticlesDocument = gql`
    query fetchUserArticles($after: String, $before: String, $first: Int, $last: Int, $username: ID) {
  userArticles(
    after: $after
    before: $before
    first: $first
    last: $last
    username: $username
  ) {
    nodes {
      category {
        id
        name
        slug
      }
      company {
        id
        logo
        name
        slug
      }
      content
      createdAt
      description
      id
      ogImage
      originalArticleUrl
      originalSiteName
      slug
      status
      thumbnail
      title
      topics {
        id
        name
        slug
      }
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchUserForViewerDocument = gql`
    query fetchUserForViewer($username: ID!) {
  user(username: $username) {
    isFollower
    isFollowing
    name
    notificationSettings {
      id
      name
      slug
    }
    username
  }
}
    `;
export const FetchVehicleDocument = gql`
    query fetchVehicle($after: String, $before: String, $first: Int, $last: Int, $slug: ID!) {
  vehicle(slug: $slug) {
    ...vehicleFields
  }
}
    ${VehicleFieldsFragmentDocBase}`;
export const FetchVehicleAnalyticsDocument = gql`
    query fetchVehicleAnalytics($vehicleSlug: ID!) {
  vehicleAnalytics(vehicleSlug: $vehicleSlug) {
    dashboardItems {
      category
      name
      numberDashboardItem {
        value
      }
      pieDashboardItems {
        name
        value
      }
    }
    name
  }
}
    `;
export const FetchVehicleItemDocument = gql`
    query fetchVehicleItem($afterPortfolioNotes: String, $beforePortfolioNotes: String, $firstPortfolioNotes: Int, $lastPortfolioNotes: Int, $afterPortfolioMeetings: String, $beforePortfolioMeetings: String, $firstPortfolioMeetings: Int, $lastPortfolioMeetings: Int, $id: ID!) {
  vehicleItem(id: $id) {
    ...vehicleItemFields
  }
}
    ${VehicleItemFieldsFragmentDocBase}`;
export const FetchVehicleItemsDocument = gql`
    query fetchVehicleItems($after: String, $before: String, $first: Int, $last: Int, $query: String, $vehicleSlug: ID!, $vehicleStatusIds: [ID!]) {
  vehicleItems(
    after: $after
    before: $before
    first: $first
    last: $last
    query: $query
    vehicleSlug: $vehicleSlug
    vehicleStatusIds: $vehicleStatusIds
  ) {
    nodes {
      ...minVehicleItemFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${MinVehicleItemFieldsFragmentDocBase}`;
export const FetchVehicleItemsForAllStatusesDocument = gql`
    query fetchVehicleItemsForAllStatuses($after1: String, $before1: String, $first1: Int, $last1: Int, $query1: String, $vehicleSlug: ID!, $vehicleStatusIds1: [ID!], $after2: String, $before2: String, $first2: Int, $last2: Int, $query2: String, $vehicleStatusIds2: [ID!], $after3: String, $before3: String, $first3: Int, $last3: Int, $query3: String, $vehicleStatusIds3: [ID!], $after4: String, $before4: String, $first4: Int, $last4: Int, $query4: String, $vehicleStatusIds4: [ID!]) {
  vehicleItems1: vehicleItems(
    after: $after1
    before: $before1
    first: $first1
    last: $last1
    query: $query1
    vehicleSlug: $vehicleSlug
    vehicleStatusIds: $vehicleStatusIds1
  ) {
    nodes {
      ...minVehicleItemFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
  vehicleItems2: vehicleItems(
    after: $after2
    before: $before2
    first: $first2
    last: $last2
    query: $query2
    vehicleSlug: $vehicleSlug
    vehicleStatusIds: $vehicleStatusIds2
  ) {
    nodes {
      ...minVehicleItemFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
  vehicleItems3: vehicleItems(
    after: $after3
    before: $before3
    first: $first3
    last: $last3
    query: $query3
    vehicleSlug: $vehicleSlug
    vehicleStatusIds: $vehicleStatusIds3
  ) {
    nodes {
      ...minVehicleItemFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
  vehicleItems4: vehicleItems(
    after: $after4
    before: $before4
    first: $first4
    last: $last4
    query: $query4
    vehicleSlug: $vehicleSlug
    vehicleStatusIds: $vehicleStatusIds4
  ) {
    nodes {
      ...minVehicleItemFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${MinVehicleItemFieldsFragmentDocBase}`;
export const SearchCompanyDocument = gql`
    query searchCompany($after: String, $before: String, $first: Int, $last: Int, $query: String!) {
  searchCompany(
    after: $after
    before: $before
    first: $first
    last: $last
    query: $query
  ) {
    nodes {
      id
      logo
      name
      slug
      url
    }
  }
}
    `;
export const SearchUserDocument = gql`
    query searchUser($query: String!) {
  searchUser(query: $query) {
    edges {
      cursor
    }
    nodes {
      id
      name
      profile {
        avatar
        bio
        denyNewContact
        facebookUrl
        instagramUrl
        isAngel
        isInvestor
        isVerifiedAccount
        jobTitle
        linkedinUrl
        twitterUrl
        currencyUnit
        investmentTargetMarkets {
          id
          name
          slug
        }
        investmentTargetRounds {
          id
          name
          slug
        }
        locations {
          id
          locationType
          name
          shortDescription
          slug
        }
        maxInvestmentAmount
        minInvestmentAmount
        isJobSeeker
      }
      username
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const ValidInvitationTokenDocument = gql`
    query validInvitationToken($token: String!) {
  validInvitationToken(token: $token) {
    invitationOf
    isValid
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    addAngelInvestmentInvitation(variables: AddAngelInvestmentInvitationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddAngelInvestmentInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddAngelInvestmentInvitationMutation>(AddAngelInvestmentInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addAngelInvestmentInvitation');
    },
    addAngelInvitation(variables: AddAngelInvitationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddAngelInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddAngelInvitationMutation>(AddAngelInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addAngelInvitation');
    },
    addCompanyInvestment(variables: AddCompanyInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddCompanyInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCompanyInvestmentMutation>(AddCompanyInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addCompanyInvestment');
    },
    addCompanyMember(variables: AddCompanyMemberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddCompanyMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCompanyMemberMutation>(AddCompanyMemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addCompanyMember');
    },
    addCompanyReference(variables: AddCompanyReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddCompanyReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCompanyReferenceMutation>(AddCompanyReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addCompanyReference');
    },
    addExperience(variables: AddExperienceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddExperienceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddExperienceMutation>(AddExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addExperience');
    },
    addFootprintToJob(variables: AddFootprintToJobMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddFootprintToJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddFootprintToJobMutation>(AddFootprintToJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addFootprintToJob');
    },
    addInvestor(variables: AddInvestorMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddInvestorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddInvestorMutation>(AddInvestorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addInvestor');
    },
    addMemberInvitation(variables: AddMemberInvitationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddMemberInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddMemberInvitationMutation>(AddMemberInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addMemberInvitation');
    },
    addMyInvestment(variables: AddMyInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddMyInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddMyInvestmentMutation>(AddMyInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addMyInvestment');
    },
    addMyJobBookmark(variables: AddMyJobBookmarkMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddMyJobBookmarkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddMyJobBookmarkMutation>(AddMyJobBookmarkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addMyJobBookmark');
    },
    addPitchAttachment(variables: AddPitchAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddPitchAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddPitchAttachmentMutation>(AddPitchAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addPitchAttachment');
    },
    addProduct(variables: AddProductMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddProductMutation>(AddProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addProduct');
    },
    addUserReference(variables: AddUserReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddUserReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUserReferenceMutation>(AddUserReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addUserReference');
    },
    addVcInvestmentInvitation(variables: AddVcInvestmentInvitationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddVcInvestmentInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddVcInvestmentInvitationMutation>(AddVcInvestmentInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addVcInvestmentInvitation');
    },
    addVcInvitation(variables: AddVcInvitationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddVcInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddVcInvitationMutation>(AddVcInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addVcInvitation');
    },
    addVehicleItemPortfolioAttachment(variables: AddVehicleItemPortfolioAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddVehicleItemPortfolioAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddVehicleItemPortfolioAttachmentMutation>(AddVehicleItemPortfolioAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addVehicleItemPortfolioAttachment');
    },
    addVehicleItemRoundAttachment(variables: AddVehicleItemRoundAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddVehicleItemRoundAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddVehicleItemRoundAttachmentMutation>(AddVehicleItemRoundAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addVehicleItemRoundAttachment');
    },
    addVehicleMember(variables: AddVehicleMemberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddVehicleMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddVehicleMemberMutation>(AddVehicleMemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addVehicleMember');
    },
    applyForJob(variables: ApplyForJobMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ApplyForJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyForJobMutation>(ApplyForJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applyForJob');
    },
    createArticleAttachment(variables: CreateArticleAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateArticleAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateArticleAttachmentMutation>(CreateArticleAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createArticleAttachment');
    },
    createBillingPortalSession(variables: CreateBillingPortalSessionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateBillingPortalSessionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBillingPortalSessionMutation>(CreateBillingPortalSessionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createBillingPortalSession');
    },
    createCompany(variables: CreateCompanyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCompanyMutation>(CreateCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCompany');
    },
    createCompanyArticle(variables: CreateCompanyArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateCompanyArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCompanyArticleMutation>(CreateCompanyArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCompanyArticle');
    },
    createJob(variables: CreateJobMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateJobMutation>(CreateJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createJob');
    },
    createJobAttachment(variables: CreateJobAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateJobAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateJobAttachmentMutation>(CreateJobAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createJobAttachment');
    },
    createMessageThread(variables: CreateMessageThreadMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateMessageThreadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMessageThreadMutation>(CreateMessageThreadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMessageThread');
    },
    createMyArticle(variables: CreateMyArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateMyArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMyArticleMutation>(CreateMyArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMyArticle');
    },
    createMyCompany(variables: CreateMyCompanyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateMyCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMyCompanyMutation>(CreateMyCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMyCompany');
    },
    createPitch(variables: CreatePitchMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreatePitchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePitchMutation>(CreatePitchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPitch');
    },
    createRecruitSubscription(variables: CreateRecruitSubscriptionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateRecruitSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRecruitSubscriptionMutation>(CreateRecruitSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRecruitSubscription');
    },
    createSkill(variables: CreateSkillMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateSkillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSkillMutation>(CreateSkillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSkill');
    },
    createVehicle(variables: CreateVehicleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateVehicleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVehicleMutation>(CreateVehicleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createVehicle');
    },
    createVehicleItem(variables: CreateVehicleItemMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateVehicleItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVehicleItemMutation>(CreateVehicleItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createVehicleItem');
    },
    createVehicleItemPortfolioMeeting(variables: CreateVehicleItemPortfolioMeetingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateVehicleItemPortfolioMeetingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVehicleItemPortfolioMeetingMutation>(CreateVehicleItemPortfolioMeetingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createVehicleItemPortfolioMeeting');
    },
    createVehicleItemPortfolioNote(variables: CreateVehicleItemPortfolioNoteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateVehicleItemPortfolioNoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVehicleItemPortfolioNoteMutation>(CreateVehicleItemPortfolioNoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createVehicleItemPortfolioNote');
    },
    createVehicleItemRound(variables: CreateVehicleItemRoundMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateVehicleItemRoundMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVehicleItemRoundMutation>(CreateVehicleItemRoundDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createVehicleItemRound');
    },
    createVehicleStatus(variables: CreateVehicleStatusMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateVehicleStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVehicleStatusMutation>(CreateVehicleStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createVehicleStatus');
    },
    deleteCompanyArticle(variables: DeleteCompanyArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteCompanyArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCompanyArticleMutation>(DeleteCompanyArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteCompanyArticle');
    },
    deleteJob(variables: DeleteJobMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteJobMutation>(DeleteJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteJob');
    },
    deleteMyArticle(variables: DeleteMyArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteMyArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMyArticleMutation>(DeleteMyArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteMyArticle');
    },
    deletePitch(variables: DeletePitchMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePitchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePitchMutation>(DeletePitchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePitch');
    },
    deletePitchAttachment(variables: DeletePitchAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePitchAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePitchAttachmentMutation>(DeletePitchAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePitchAttachment');
    },
    deleteVehicle(variables: DeleteVehicleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteVehicleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVehicleMutation>(DeleteVehicleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteVehicle');
    },
    deleteVehicleItem(variables: DeleteVehicleItemMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteVehicleItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVehicleItemMutation>(DeleteVehicleItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteVehicleItem');
    },
    deleteVehicleItemPortfolioAttachment(variables: DeleteVehicleItemPortfolioAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteVehicleItemPortfolioAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVehicleItemPortfolioAttachmentMutation>(DeleteVehicleItemPortfolioAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteVehicleItemPortfolioAttachment');
    },
    deleteVehicleItemPortfolioMeeting(variables: DeleteVehicleItemPortfolioMeetingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteVehicleItemPortfolioMeetingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVehicleItemPortfolioMeetingMutation>(DeleteVehicleItemPortfolioMeetingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteVehicleItemPortfolioMeeting');
    },
    deleteVehicleItemPortfolioNote(variables: DeleteVehicleItemPortfolioNoteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteVehicleItemPortfolioNoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVehicleItemPortfolioNoteMutation>(DeleteVehicleItemPortfolioNoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteVehicleItemPortfolioNote');
    },
    deleteVehicleItemRound(variables: DeleteVehicleItemRoundMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteVehicleItemRoundMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVehicleItemRoundMutation>(DeleteVehicleItemRoundDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteVehicleItemRound');
    },
    deleteVehicleItemRoundAttachment(variables: DeleteVehicleItemRoundAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteVehicleItemRoundAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVehicleItemRoundAttachmentMutation>(DeleteVehicleItemRoundAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteVehicleItemRoundAttachment');
    },
    deleteVehicleStatus(variables: DeleteVehicleStatusMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteVehicleStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVehicleStatusMutation>(DeleteVehicleStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteVehicleStatus');
    },
    duplicateJob(variables: DuplicateJobMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DuplicateJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DuplicateJobMutation>(DuplicateJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'duplicateJob');
    },
    initializePms(variables: InitializePmsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InitializePmsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InitializePmsMutation>(InitializePmsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'initializePms');
    },
    leaveService(variables: LeaveServiceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LeaveServiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LeaveServiceMutation>(LeaveServiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'leaveService');
    },
    markAllMessagesAsRead(variables: MarkAllMessagesAsReadMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MarkAllMessagesAsReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkAllMessagesAsReadMutation>(MarkAllMessagesAsReadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markAllMessagesAsRead');
    },
    markNotificationsAsRead(variables: MarkNotificationsAsReadMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MarkNotificationsAsReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkNotificationsAsReadMutation>(MarkNotificationsAsReadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markNotificationsAsRead');
    },
    markPitchAsRead(variables: MarkPitchAsReadMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MarkPitchAsReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkPitchAsReadMutation>(MarkPitchAsReadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markPitchAsRead');
    },
    removeCompanyMember(variables: RemoveCompanyMemberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveCompanyMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCompanyMemberMutation>(RemoveCompanyMemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeCompanyMember');
    },
    removeCompanyReference(variables: RemoveCompanyReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveCompanyReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCompanyReferenceMutation>(RemoveCompanyReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeCompanyReference');
    },
    removeExperience(variables: RemoveExperienceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveExperienceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveExperienceMutation>(RemoveExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeExperience');
    },
    removeInvestment(variables: RemoveInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveInvestmentMutation>(RemoveInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeInvestment');
    },
    removeInvestor(variables: RemoveInvestorMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveInvestorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveInvestorMutation>(RemoveInvestorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeInvestor');
    },
    removeMyJobBookmark(variables: RemoveMyJobBookmarkMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveMyJobBookmarkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveMyJobBookmarkMutation>(RemoveMyJobBookmarkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeMyJobBookmark');
    },
    removePitchAttachmentFromPitch(variables: RemovePitchAttachmentFromPitchMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemovePitchAttachmentFromPitchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemovePitchAttachmentFromPitchMutation>(RemovePitchAttachmentFromPitchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removePitchAttachmentFromPitch');
    },
    removeProduct(variables: RemoveProductMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveProductMutation>(RemoveProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeProduct');
    },
    removeUserReference(variables: RemoveUserReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveUserReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveUserReferenceMutation>(RemoveUserReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeUserReference');
    },
    removeVehicleMember(variables: RemoveVehicleMemberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveVehicleMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveVehicleMemberMutation>(RemoveVehicleMemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeVehicleMember');
    },
    toggleArticleLikedState(variables: ToggleArticleLikedStateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ToggleArticleLikedStateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ToggleArticleLikedStateMutation>(ToggleArticleLikedStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'toggleArticleLikedState');
    },
    toggleFollowCompany(variables: ToggleFollowCompanyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ToggleFollowCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ToggleFollowCompanyMutation>(ToggleFollowCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'toggleFollowCompany');
    },
    toggleFollowUser(variables: ToggleFollowUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ToggleFollowUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ToggleFollowUserMutation>(ToggleFollowUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'toggleFollowUser');
    },
    updateCompany(variables: UpdateCompanyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyMutation>(UpdateCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompany');
    },
    updateCompanyArticle(variables: UpdateCompanyArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyArticleMutation>(UpdateCompanyArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompanyArticle');
    },
    updateCompanyMember(variables: UpdateCompanyMemberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyMemberMutation>(UpdateCompanyMemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompanyMember');
    },
    updateCompanyNotificationSettings(variables: UpdateCompanyNotificationSettingsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyNotificationSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyNotificationSettingsMutation>(UpdateCompanyNotificationSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompanyNotificationSettings');
    },
    updateCompanyReference(variables: UpdateCompanyReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyReferenceMutation>(UpdateCompanyReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompanyReference');
    },
    updateExperience(variables: UpdateExperienceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateExperienceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateExperienceMutation>(UpdateExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateExperience');
    },
    updateInvestment(variables: UpdateInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvestmentMutation>(UpdateInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvestment');
    },
    updateInvestor(variables: UpdateInvestorMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInvestorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvestorMutation>(UpdateInvestorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvestor');
    },
    updateJob(variables: UpdateJobMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateJobMutation>(UpdateJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateJob');
    },
    updateMe(variables: UpdateMeMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMeMutation>(UpdateMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMe');
    },
    updateMyArticle(variables: UpdateMyArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMyArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMyArticleMutation>(UpdateMyArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMyArticle');
    },
    updateMyCompanyReference(variables: UpdateMyCompanyReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMyCompanyReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMyCompanyReferenceMutation>(UpdateMyCompanyReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMyCompanyReference');
    },
    updateMyProfile(variables: UpdateMyProfileMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMyProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMyProfileMutation>(UpdateMyProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMyProfile');
    },
    updateMyReference(variables: UpdateMyReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMyReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMyReferenceMutation>(UpdateMyReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMyReference');
    },
    updatePitch(variables: UpdatePitchMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePitchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePitchMutation>(UpdatePitchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePitch');
    },
    updatePitchAttachment(variables: UpdatePitchAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePitchAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePitchAttachmentMutation>(UpdatePitchAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePitchAttachment');
    },
    updateProduct(variables: UpdateProductMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProductMutation>(UpdateProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateProduct');
    },
    updateUserNotificationSettings(variables: UpdateUserNotificationSettingsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserNotificationSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserNotificationSettingsMutation>(UpdateUserNotificationSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserNotificationSettings');
    },
    updateUserReference(variables: UpdateUserReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserReferenceMutation>(UpdateUserReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserReference');
    },
    updateVehicle(variables: UpdateVehicleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateVehicleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVehicleMutation>(UpdateVehicleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicle');
    },
    updateVehicleItem(variables: UpdateVehicleItemMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateVehicleItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVehicleItemMutation>(UpdateVehicleItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicleItem');
    },
    updateVehicleItemPortfolio(variables: UpdateVehicleItemPortfolioMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateVehicleItemPortfolioMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVehicleItemPortfolioMutation>(UpdateVehicleItemPortfolioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicleItemPortfolio');
    },
    updateVehicleItemPortfolioMeeting(variables: UpdateVehicleItemPortfolioMeetingMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateVehicleItemPortfolioMeetingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVehicleItemPortfolioMeetingMutation>(UpdateVehicleItemPortfolioMeetingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicleItemPortfolioMeeting');
    },
    updateVehicleItemPortfolioNote(variables: UpdateVehicleItemPortfolioNoteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateVehicleItemPortfolioNoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVehicleItemPortfolioNoteMutation>(UpdateVehicleItemPortfolioNoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicleItemPortfolioNote');
    },
    updateVehicleItemRound(variables: UpdateVehicleItemRoundMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateVehicleItemRoundMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVehicleItemRoundMutation>(UpdateVehicleItemRoundDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicleItemRound');
    },
    updateVehicleMember(variables: UpdateVehicleMemberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateVehicleMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVehicleMemberMutation>(UpdateVehicleMemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicleMember');
    },
    updateVehicleStatus(variables: UpdateVehicleStatusMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateVehicleStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVehicleStatusMutation>(UpdateVehicleStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicleStatus');
    },
    fetchAngels(variables?: FetchAngelsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchAngelsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchAngelsQuery>(FetchAngelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchAngels');
    },
    fetchArticle(variables: FetchArticleQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchArticleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchArticleQuery>(FetchArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchArticle');
    },
    fetchArticles(variables?: FetchArticlesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchArticlesQuery>(FetchArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchArticles');
    },
    fetchMessageThreads(variables?: FetchMessageThreadsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMessageThreadsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMessageThreadsQuery>(FetchMessageThreadsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMessageThreads');
    },
    fetchMessageThread(variables: FetchMessageThreadQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMessageThreadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMessageThreadQuery>(FetchMessageThreadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMessageThread');
    },
    fetchCompanies(variables?: FetchCompaniesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCompaniesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCompaniesQuery>(FetchCompaniesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCompanies');
    },
    fetchCompaniesWithJobs(variables?: FetchCompaniesWithJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCompaniesWithJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCompaniesWithJobsQuery>(FetchCompaniesWithJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCompaniesWithJobs');
    },
    fetchCompany(variables: FetchCompanyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCompanyQuery>(FetchCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCompany');
    },
    fetchCompanyArticles(variables: FetchCompanyArticlesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCompanyArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCompanyArticlesQuery>(FetchCompanyArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCompanyArticles');
    },
    fetchCompanyForViewer(variables: FetchCompanyForViewerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCompanyForViewerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCompanyForViewerQuery>(FetchCompanyForViewerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCompanyForViewer');
    },
    fetchCompanyJobs(variables: FetchCompanyJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCompanyJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCompanyJobsQuery>(FetchCompanyJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCompanyJobs');
    },
    fetchFeaturedAngels(variables?: FetchFeaturedAngelsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFeaturedAngelsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFeaturedAngelsQuery>(FetchFeaturedAngelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFeaturedAngels');
    },
    fetchFeaturedCompaniesWithJobs(variables?: FetchFeaturedCompaniesWithJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFeaturedCompaniesWithJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFeaturedCompaniesWithJobsQuery>(FetchFeaturedCompaniesWithJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFeaturedCompaniesWithJobs');
    },
    fetchFeaturedJobs(variables?: FetchFeaturedJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFeaturedJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFeaturedJobsQuery>(FetchFeaturedJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFeaturedJobs');
    },
    fetchFeaturedStartups(variables?: FetchFeaturedStartupsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFeaturedStartupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFeaturedStartupsQuery>(FetchFeaturedStartupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFeaturedStartups');
    },
    fetchFeaturedStories(variables?: FetchFeaturedStoriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFeaturedStoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFeaturedStoriesQuery>(FetchFeaturedStoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFeaturedStories');
    },
    fetchFeaturedVentureCapitals(variables?: FetchFeaturedVentureCapitalsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFeaturedVentureCapitalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFeaturedVentureCapitalsQuery>(FetchFeaturedVentureCapitalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFeaturedVentureCapitals');
    },
    fetchFollowers(variables: FetchFollowersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFollowersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFollowersQuery>(FetchFollowersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFollowers');
    },
    fetchFollowing(variables: FetchFollowingQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFollowingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFollowingQuery>(FetchFollowingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFollowing');
    },
    fetchForexRate(variables: FetchForexRateQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchForexRateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchForexRateQuery>(FetchForexRateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchForexRate');
    },
    fetchForexRates(variables: FetchForexRatesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchForexRatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchForexRatesQuery>(FetchForexRatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchForexRates');
    },
    fetchJob(variables: FetchJobQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobQuery>(FetchJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJob');
    },
    fetchJobApplications(variables: FetchJobApplicationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobApplicationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobApplicationsQuery>(FetchJobApplicationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobApplications');
    },
    fetchJobBookmarks(variables?: FetchJobBookmarksQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobBookmarksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobBookmarksQuery>(FetchJobBookmarksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobBookmarks');
    },
    fetchJobCategories(variables?: FetchJobCategoriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobCategoriesQuery>(FetchJobCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobCategories');
    },
    fetchJobFootprints(variables: FetchJobFootprintsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobFootprintsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobFootprintsQuery>(FetchJobFootprintsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobFootprints');
    },
    fetchJobTags(variables?: FetchJobTagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobTagsQuery>(FetchJobTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobTags');
    },
    fetchJobs(variables?: FetchJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobsQuery>(FetchJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobs');
    },
    fetchLocation(variables: FetchLocationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchLocationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchLocationQuery>(FetchLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchLocation');
    },
    fetchLocations(variables?: FetchLocationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchLocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchLocationsQuery>(FetchLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchLocations');
    },
    fetchMarkets(variables?: FetchMarketsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMarketsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMarketsQuery>(FetchMarketsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMarkets');
    },
    fetchMe(variables?: FetchMeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMeQuery>(FetchMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMe');
    },
    fetchMyArticles(variables?: FetchMyArticlesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyArticlesQuery>(FetchMyArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyArticles');
    },
    fetchMyCompany(variables: FetchMyCompanyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyCompanyQuery>(FetchMyCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyCompany');
    },
    fetchMyCompanyArticles(variables: FetchMyCompanyArticlesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyCompanyArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyCompanyArticlesQuery>(FetchMyCompanyArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyCompanyArticles');
    },
    fetchMyCompanyReferences(variables: FetchMyCompanyReferencesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyCompanyReferencesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyCompanyReferencesQuery>(FetchMyCompanyReferencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyCompanyReferences');
    },
    fetchMyInvestorMembers(variables?: FetchMyInvestorMembersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyInvestorMembersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyInvestorMembersQuery>(FetchMyInvestorMembersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyInvestorMembers');
    },
    fetchMyJobBookmarks(variables?: FetchMyJobBookmarksQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyJobBookmarksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyJobBookmarksQuery>(FetchMyJobBookmarksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyJobBookmarks');
    },
    fetchMyJobs(variables: FetchMyJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyJobsQuery>(FetchMyJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyJobs');
    },
    fetchMyPitches(variables: FetchMyPitchesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyPitchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyPitchesQuery>(FetchMyPitchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyPitches');
    },
    fetchMyReferences(variables?: FetchMyReferencesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyReferencesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyReferencesQuery>(FetchMyReferencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyReferences');
    },
    fetchNotifications(variables?: FetchNotificationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchNotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchNotificationsQuery>(FetchNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchNotifications');
    },
    fetchPaginatedMessageThreads(variables?: FetchPaginatedMessageThreadsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchPaginatedMessageThreadsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchPaginatedMessageThreadsQuery>(FetchPaginatedMessageThreadsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchPaginatedMessageThreads');
    },
    fetchPickedUpFeatures(variables?: FetchPickedUpFeaturesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchPickedUpFeaturesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchPickedUpFeaturesQuery>(FetchPickedUpFeaturesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchPickedUpFeatures');
    },
    fetchPitch(variables: FetchPitchQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchPitchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchPitchQuery>(FetchPitchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchPitch');
    },
    fetchPitches(variables: FetchPitchesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchPitchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchPitchesQuery>(FetchPitchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchPitches');
    },
    fetchSkills(variables?: FetchSkillsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchSkillsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchSkillsQuery>(FetchSkillsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchSkills');
    },
    fetchSubsidies(variables?: FetchSubsidiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchSubsidiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchSubsidiesQuery>(FetchSubsidiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchSubsidies');
    },
    fetchSubsidy(variables: FetchSubsidyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchSubsidyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchSubsidyQuery>(FetchSubsidyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchSubsidy');
    },
    fetchSubsidyPurpose(variables: FetchSubsidyPurposeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchSubsidyPurposeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchSubsidyPurposeQuery>(FetchSubsidyPurposeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchSubsidyPurpose');
    },
    fetchSubsidyPurposes(variables?: FetchSubsidyPurposesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchSubsidyPurposesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchSubsidyPurposesQuery>(FetchSubsidyPurposesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchSubsidyPurposes');
    },
    fetchUser(variables: FetchUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchUserQuery>(FetchUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchUser');
    },
    fetchUserArticles(variables?: FetchUserArticlesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchUserArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchUserArticlesQuery>(FetchUserArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchUserArticles');
    },
    fetchUserForViewer(variables: FetchUserForViewerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchUserForViewerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchUserForViewerQuery>(FetchUserForViewerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchUserForViewer');
    },
    fetchVehicle(variables: FetchVehicleQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchVehicleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchVehicleQuery>(FetchVehicleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchVehicle');
    },
    fetchVehicleAnalytics(variables: FetchVehicleAnalyticsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchVehicleAnalyticsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchVehicleAnalyticsQuery>(FetchVehicleAnalyticsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchVehicleAnalytics');
    },
    fetchVehicleItem(variables: FetchVehicleItemQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchVehicleItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchVehicleItemQuery>(FetchVehicleItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchVehicleItem');
    },
    fetchVehicleItems(variables: FetchVehicleItemsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchVehicleItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchVehicleItemsQuery>(FetchVehicleItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchVehicleItems');
    },
    fetchVehicleItemsForAllStatuses(variables: FetchVehicleItemsForAllStatusesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchVehicleItemsForAllStatusesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchVehicleItemsForAllStatusesQuery>(FetchVehicleItemsForAllStatusesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchVehicleItemsForAllStatuses');
    },
    searchCompany(variables: SearchCompanyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SearchCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchCompanyQuery>(SearchCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchCompany');
    },
    searchUser(variables: SearchUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SearchUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchUserQuery>(SearchUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchUser');
    },
    validInvitationToken(variables: ValidInvitationTokenQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ValidInvitationTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ValidInvitationTokenQuery>(ValidInvitationTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'validInvitationToken');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;